/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as AnonymousRouteImport } from "./routes/_anonymous";
import { Route as AuthenticatedRouteImport } from "./routes/_authenticated";
import { Route as CmsRouteImport } from "./routes/_cms";
import { Route as SessionRouteImport } from "./routes/_session";
import { Route as AutoLoginRouteImport } from "./routes/auto-login";
import { Route as EnrollmentRouteImport } from "./routes/enrollment";
import { Route as compatibilityOnboardingRouteImport } from "./routes/(compatibility)/onboarding";
import { Route as compatibilitySign_upRouteImport } from "./routes/(compatibility)/sign_up";
import { Route as AnonymousMobile_sign_inRouteImport } from "./routes/_anonymous/mobile_sign_in";
import { Route as AnonymousUnsubscribeRouteImport } from "./routes/_anonymous/unsubscribe";
import { Route as AuthenticatedFeature_announcementRouteImport } from "./routes/_authenticated/_feature_announcement";
import { Route as SessionForgotRouteImport } from "./routes/_session/forgot";
import { Route as EnrollmentIndexRouteImport } from "./routes/enrollment/index";
import { Route as EnrollmentCompleteRouteImport } from "./routes/enrollment/complete";
import { Route as EnrollmentDiscoverRouteImport } from "./routes/enrollment/discover";
import { Route as EnrollmentProfileRouteImport } from "./routes/enrollment/profile";
import { Route as AnonymousEvent_checkinEventIdRouteImport } from "./routes/_anonymous/event_checkin/$eventId";
import { Route as AnonymousVerifyTokenRouteImport } from "./routes/_anonymous/verify.$token";
import { Route as AuthenticatedFeature_announcementUserRouteImport } from "./routes/_authenticated/_feature_announcement/_user";
import { Route as AuthenticatedFeature_announcementAdminRouteImport } from "./routes/_authenticated/_feature_announcement/admin";
import { Route as CmsCmsIndexRouteImport } from "./routes/_cms/cms/index";
import { Route as SessionLoginIndexRouteImport } from "./routes/_session/login/index";
import { Route as SessionLoginActivateRouteImport } from "./routes/_session/login/activate";
import { Route as SessionLoginAdminRouteImport } from "./routes/_session/login/admin";
import { Route as SessionLoginCredentialsRouteImport } from "./routes/_session/login/credentials";
import { Route as SessionPassword_resetIndexRouteImport } from "./routes/_session/password_reset/index";
import { Route as SessionPassword_resetTokenRouteImport } from "./routes/_session/password_reset/$token";
import { Route as AuthenticatedFeature_announcementUserIndexRouteImport } from "./routes/_authenticated/_feature_announcement/_user/index";
import { Route as AuthenticatedFeature_announcementUserCommunitiesRouteImport } from "./routes/_authenticated/_feature_announcement/_user/communities";
import { Route as AuthenticatedFeature_announcementUserDownloadsRouteImport } from "./routes/_authenticated/_feature_announcement/_user/downloads";
import { Route as AuthenticatedFeature_announcementUserGroupsRouteImport } from "./routes/_authenticated/_feature_announcement/_user/groups";
import { Route as AuthenticatedFeature_announcementUserNotificationsRouteImport } from "./routes/_authenticated/_feature_announcement/_user/notifications";
import { Route as AuthenticatedFeature_announcementUserProfileRouteImport } from "./routes/_authenticated/_feature_announcement/_user/profile";
import { Route as AuthenticatedFeature_announcementUserRewardsRouteImport } from "./routes/_authenticated/_feature_announcement/_user/rewards";
import { Route as AuthenticatedFeature_announcementUserSupportRouteImport } from "./routes/_authenticated/_feature_announcement/_user/support";
import { Route as AuthenticatedFeature_announcementAdminSupportConfigRouteImport } from "./routes/_authenticated/_feature_announcement/admin/support-config";
import { Route as AuthenticatedFeature_announcementAdminSystemRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId";
import { Route as AuthenticatedFeature_announcementOpen_invitationsOpenInvitationIdRouteImport } from "./routes/_authenticated/_feature_announcement/open_invitations/$openInvitationId";
import { Route as CmsCmsReviewComment_moderationRouteImport } from "./routes/_cms/cms/review/comment_moderation";
import { Route as CmsCmsToolsReview_settingsRouteImport } from "./routes/_cms/cms/tools/review_settings";
import { Route as AuthenticatedFeature_announcementUserCommunityLabIndexRouteImport } from "./routes/_authenticated/_feature_announcement/_user/community-lab/index";
import { Route as AuthenticatedFeature_announcementUserCommunityLabSplatRouteImport } from "./routes/_authenticated/_feature_announcement/_user/community-lab/$";
import { Route as AuthenticatedFeature_announcementUserCommunityLabSessionRouteImport } from "./routes/_authenticated/_feature_announcement/_user/community-lab/session";
import { Route as AuthenticatedFeature_announcementUserCommunityLabWorksheetRouteImport } from "./routes/_authenticated/_feature_announcement/_user/community-lab/worksheet";
import { Route as AuthenticatedFeature_announcementUserEventsIndexRouteImport } from "./routes/_authenticated/_feature_announcement/_user/events/index";
import { Route as AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdRouteImport } from "./routes/_authenticated/_feature_announcement/_user/global-survey-response.$surveyId";
import { Route as AuthenticatedFeature_announcementUserPostsIndexRouteImport } from "./routes/_authenticated/_feature_announcement/_user/posts/index";
import { Route as AuthenticatedFeature_announcementUserProfileIndexRouteImport } from "./routes/_authenticated/_feature_announcement/_user/profile/index";
import { Route as AuthenticatedFeature_announcementUserProfileStatisticsRouteImport } from "./routes/_authenticated/_feature_announcement/_user/profile/statistics";
import { Route as AuthenticatedFeature_announcementAdminAnalyzeIndexRouteImport } from "./routes/_authenticated/_feature_announcement/admin/analyze/index";
import { Route as AuthenticatedFeature_announcementAdminAnalyzeCommunityLabReportRouteImport } from "./routes/_authenticated/_feature_announcement/admin/analyze/community-lab-report";
import { Route as AuthenticatedFeature_announcementAdminAnalyzeGroupsRouteImport } from "./routes/_authenticated/_feature_announcement/admin/analyze/groups";
import { Route as AuthenticatedFeature_announcementAdminAnalyzeReportsRouteImport } from "./routes/_authenticated/_feature_announcement/admin/analyze/reports";
import { Route as AuthenticatedFeature_announcementAdminAnalyzeSegmentsRouteImport } from "./routes/_authenticated/_feature_announcement/admin/analyze/segments";
import { Route as AuthenticatedFeature_announcementAdminAnalyzeUsersRouteImport } from "./routes/_authenticated/_feature_announcement/admin/analyze/users";
import { Route as AuthenticatedFeature_announcementAdminContextBackfillIndexRouteImport } from "./routes/_authenticated/_feature_announcement/admin/context-backfill/index";
import { Route as AuthenticatedFeature_announcementAdminGamificationRewardsRouteImport } from "./routes/_authenticated/_feature_announcement/admin/gamification/rewards";
import { Route as AuthenticatedFeature_announcementAdminManageArchivedRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/archived";
import { Route as AuthenticatedFeature_announcementAdminManageEventsRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/events";
import { Route as AuthenticatedFeature_announcementAdminManageFoldersRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/folders";
import { Route as AuthenticatedFeature_announcementAdminManageLabelsRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/labels";
import { Route as AuthenticatedFeature_announcementAdminManageLeadersRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/leaders";
import { Route as AuthenticatedFeature_announcementAdminManageTagsRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/tags";
import { Route as AuthenticatedFeature_announcementAdminPlanAggregate_budgetingRouteImport } from "./routes/_authenticated/_feature_announcement/admin/plan/aggregate_budgeting";
import { Route as AuthenticatedFeature_announcementAdminSurveysIndexRouteImport } from "./routes/_authenticated/_feature_announcement/admin/surveys/index";
import { Route as AuthenticatedFeature_announcementAdminSurveysNewRouteImport } from "./routes/_authenticated/_feature_announcement/admin/surveys/new";
import { Route as AuthenticatedFeature_announcementAdminSystemApi_access_tokensRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/api_access_tokens";
import { Route as AuthenticatedFeature_announcementAdminSystemBrandingRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/branding";
import { Route as AuthenticatedFeature_announcementAdminSystemIntegrationsRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/integrations";
import { Route as AuthenticatedFeature_announcementAdminSystemLogsRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/logs";
import { Route as AuthenticatedFeature_announcementAdminSystemMcp_connectorRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/mcp_connector";
import { Route as AuthenticatedFeature_announcementAdminSystemRolesRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/roles";
import { Route as AuthenticatedFeature_announcementAdminSystemSettingsRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/settings";
import { Route as AuthenticatedFeature_announcementAdminSystemUsersRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/users";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdIndexRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/index";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/budgeting";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdChaptersRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/chapters";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdFoldersRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/folders";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdManageRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/manage";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdMembersRouteRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/members/route";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/plan";
import { Route as AuthenticatedFeature_announcementGroupsGroupIdSplatRouteImport } from "./routes/_authenticated/_feature_announcement/groups/$groupId/$";
import { Route as AuthenticatedFeature_announcementInvitationsInvitationIdAcceptRouteImport } from "./routes/_authenticated/_feature_announcement/invitations/$invitationId/accept";
import { Route as AuthenticatedFeature_announcementInvitationsInvitationIdDeclineRouteImport } from "./routes/_authenticated/_feature_announcement/invitations/$invitationId/decline";
import { Route as AuthenticatedFeature_announcementRegionsRegionIdSplatRouteImport } from "./routes/_authenticated/_feature_announcement/regions/$regionId/$";
import { Route as CmsCmsManageCommunicationsIndexRouteImport } from "./routes/_cms/cms/manage/communications/index";
import { Route as CmsCmsManageCommunicationsDraftIdRouteImport } from "./routes/_cms/cms/manage/communications/$draftId";
import { Route as CmsCmsManageEventsIndexRouteImport } from "./routes/_cms/cms/manage/events/index";
import { Route as CmsCmsManageEventsDraftIdRouteImport } from "./routes/_cms/cms/manage/events/$draftId";
import { Route as CmsCmsManageEventsNewRouteImport } from "./routes/_cms/cms/manage/events/new";
import { Route as CmsCmsManagePostsIndexRouteImport } from "./routes/_cms/cms/manage/posts/index";
import { Route as CmsCmsManagePostsDraftIdRouteImport } from "./routes/_cms/cms/manage/posts/$draftId";
import { Route as CmsCmsManagePublication_requestsIndexRouteImport } from "./routes/_cms/cms/manage/publication_requests/index";
import { Route as CmsCmsManagePublication_requestsPublicationRequestIdRouteImport } from "./routes/_cms/cms/manage/publication_requests/$publicationRequestId";
import { Route as CmsCmsReviewPublication_requestsIndexRouteImport } from "./routes/_cms/cms/review/publication_requests/index";
import { Route as CmsCmsReviewPublication_requestsPublicationRequestIdRouteImport } from "./routes/_cms/cms/review/publication_requests/$publicationRequestId";
import { Route as compatibilityEnterprisesEnterpriseIdFoldersFolderIdResourcesRouteImport } from "./routes/(compatibility)/enterprises.$enterpriseId.folders.$folderId.resources";
import { Route as compatibilityGroupsGroupIdFoldersFolderIdResourcesRouteImport } from "./routes/(compatibility)/groups.$groupId.folders.$folderId.resources";
import { Route as compatibilityGroupsGroupIdNewsTypePostIdRouteImport } from "./routes/(compatibility)/groups.$groupId.news.$type.$postId";
import { Route as compatibilityRegionsRegionIdNewsTypePostIdRouteImport } from "./routes/(compatibility)/regions.$regionId.news.$type.$postId";
import { Route as AuthenticatedFeature_announcementUserEventsEventIdSplatRouteImport } from "./routes/_authenticated/_feature_announcement/_user/events/$eventId/$";
import { Route as AuthenticatedFeature_announcementUserEventsDraftsIndexRouteImport } from "./routes/_authenticated/_feature_announcement/_user/events/drafts/index";
import { Route as AuthenticatedFeature_announcementUserEventsDraftsDraftIdRouteImport } from "./routes/_authenticated/_feature_announcement/_user/events/drafts/$draftId";
import { Route as AuthenticatedFeature_announcementUserEventsDraftsNewRouteImport } from "./routes/_authenticated/_feature_announcement/_user/events/drafts/new";
import { Route as AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdIndexRouteImport } from "./routes/_authenticated/_feature_announcement/_user/global-survey-response.$surveyId.index";
import { Route as AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdRouteImport } from "./routes/_authenticated/_feature_announcement/_user/network-survey-response.$networkId.$surveyId";
import { Route as AuthenticatedFeature_announcementUserPostsPostIdSplatRouteImport } from "./routes/_authenticated/_feature_announcement/_user/posts/$postId/$";
import { Route as AuthenticatedFeature_announcementUserPostsDraftsIndexRouteImport } from "./routes/_authenticated/_feature_announcement/_user/posts/drafts/index";
import { Route as AuthenticatedFeature_announcementUserPostsDraftsDraftIdRouteImport } from "./routes/_authenticated/_feature_announcement/_user/posts/drafts/$draftId";
import { Route as AuthenticatedFeature_announcementUserProfileEditAccessibilityRouteImport } from "./routes/_authenticated/_feature_announcement/_user/profile/edit/accessibility";
import { Route as AuthenticatedFeature_announcementUserProfileEditEngagementReportRouteImport } from "./routes/_authenticated/_feature_announcement/_user/profile/edit/engagement-report";
import { Route as AuthenticatedFeature_announcementUserProfileEditGeneralRouteImport } from "./routes/_authenticated/_feature_announcement/_user/profile/edit/general";
import { Route as AuthenticatedFeature_announcementUserProfileEditLeadershipRouteImport } from "./routes/_authenticated/_feature_announcement/_user/profile/edit/leadership";
import { Route as AuthenticatedFeature_announcementUserProfileEditNotificationRouteImport } from "./routes/_authenticated/_feature_announcement/_user/profile/edit/notification";
import { Route as AuthenticatedFeature_announcementUserProfileEditOutlookRouteImport } from "./routes/_authenticated/_feature_announcement/_user/profile/edit/outlook";
import { Route as AuthenticatedFeature_announcementUserProfileEditPrivateRouteImport } from "./routes/_authenticated/_feature_announcement/_user/profile/edit/private";
import { Route as AuthenticatedFeature_announcementUserUserUserIdIndexRouteImport } from "./routes/_authenticated/_feature_announcement/_user/user/$userId/index";
import { Route as AuthenticatedFeature_announcementUserUserUserIdAchievementsRouteImport } from "./routes/_authenticated/_feature_announcement/_user/user/$userId/achievements";
import { Route as AuthenticatedFeature_announcementUserUserUserIdEditRouteImport } from "./routes/_authenticated/_feature_announcement/_user/user/$userId/edit";
import { Route as AuthenticatedFeature_announcementUserUserUserIdStatisticsRouteImport } from "./routes/_authenticated/_feature_announcement/_user/user/$userId/statistics";
import { Route as AuthenticatedFeature_announcementUserUserUserIdTransactionsRouteImport } from "./routes/_authenticated/_feature_announcement/_user/user/$userId/transactions";
import { Route as AuthenticatedFeature_announcementAdminAnalyzeDashboardsSplatRouteImport } from "./routes/_authenticated/_feature_announcement/admin/analyze/dashboards.$";
import { Route as AuthenticatedFeature_announcementAdminAnalyzeGroupsIndexRouteImport } from "./routes/_authenticated/_feature_announcement/admin/analyze/groups/index";
import { Route as AuthenticatedFeature_announcementAdminAnalyzeGroupsEventsRouteImport } from "./routes/_authenticated/_feature_announcement/admin/analyze/groups/events";
import { Route as AuthenticatedFeature_announcementAdminAnalyzeGroupsPostsRouteImport } from "./routes/_authenticated/_feature_announcement/admin/analyze/groups/posts";
import { Route as AuthenticatedFeature_announcementAdminAnalyzeGroupsResourcesRouteImport } from "./routes/_authenticated/_feature_announcement/admin/analyze/groups/resources";
import { Route as AuthenticatedFeature_announcementAdminAnalyzeGroupsUsersRouteImport } from "./routes/_authenticated/_feature_announcement/admin/analyze/groups/users";
import { Route as AuthenticatedFeature_announcementAdminAnalyzeRoiSuiteSplatRouteImport } from "./routes/_authenticated/_feature_announcement/admin/analyze/roi-suite.$";
import { Route as AuthenticatedFeature_announcementAdminAnalyzeUsersIndexRouteImport } from "./routes/_authenticated/_feature_announcement/admin/analyze/users/index";
import { Route as AuthenticatedFeature_announcementAdminAnalyzeUsersEventsRouteImport } from "./routes/_authenticated/_feature_announcement/admin/analyze/users/events";
import { Route as AuthenticatedFeature_announcementAdminGamificationAchievementsIndexRouteImport } from "./routes/_authenticated/_feature_announcement/admin/gamification/achievements/index";
import { Route as AuthenticatedFeature_announcementAdminGamificationAchievementsNewRouteImport } from "./routes/_authenticated/_feature_announcement/admin/gamification/achievements/new";
import { Route as AuthenticatedFeature_announcementAdminGamificationPointsManageRouteImport } from "./routes/_authenticated/_feature_announcement/admin/gamification/points/manage";
import { Route as AuthenticatedFeature_announcementAdminGamificationRewardsIndexRouteImport } from "./routes/_authenticated/_feature_announcement/admin/gamification/rewards/index";
import { Route as AuthenticatedFeature_announcementAdminGamificationRewardsNewRouteImport } from "./routes/_authenticated/_feature_announcement/admin/gamification/rewards/new";
import { Route as AuthenticatedFeature_announcementAdminGamificationRewardsPendingRouteImport } from "./routes/_authenticated/_feature_announcement/admin/gamification/rewards/pending";
import { Route as AuthenticatedFeature_announcementAdminManageCalendarIndexRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/calendar/index";
import { Route as AuthenticatedFeature_announcementAdminManageCalendarCreateRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/calendar/create";
import { Route as AuthenticatedFeature_announcementAdminManageCommunicationsIndexRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/communications/index";
import { Route as AuthenticatedFeature_announcementAdminManageCommunicationsNewRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/communications/new";
import { Route as AuthenticatedFeature_announcementAdminManageEventsCalendarRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/events/calendar";
import { Route as AuthenticatedFeature_announcementAdminManageEventsConfigurationRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/events/configuration";
import { Route as AuthenticatedFeature_announcementAdminManageEventsQuestionnaireRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/events/questionnaire";
import { Route as AuthenticatedFeature_announcementAdminManageGroupsIndexRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/groups/index";
import { Route as AuthenticatedFeature_announcementAdminManageGroupsConnectionsRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/groups/connections";
import { Route as AuthenticatedFeature_announcementAdminManageGroupsLeader_positionsRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/groups/leader_positions";
import { Route as AuthenticatedFeature_announcementAdminManageGroupsNewRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/groups/new";
import { Route as AuthenticatedFeature_announcementAdminManageSegmentsIndexRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/segments/index";
import { Route as AuthenticatedFeature_announcementAdminManageSegmentsNewRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/segments/new";
import { Route as AuthenticatedFeature_announcementAdminPlanBudgetingIndexRouteImport } from "./routes/_authenticated/_feature_announcement/admin/plan/budgeting/index";
import { Route as AuthenticatedFeature_announcementAdminSurveysSurveyIdEditRouteImport } from "./routes/_authenticated/_feature_announcement/admin/surveys/$surveyId/edit";
import { Route as AuthenticatedFeature_announcementAdminSurveysSurveyIdResponsesRouteImport } from "./routes/_authenticated/_feature_announcement/admin/surveys/$surveyId/responses";
import { Route as AuthenticatedFeature_announcementAdminSystemBrandingColorsRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/branding/colors";
import { Route as AuthenticatedFeature_announcementAdminSystemBrandingHomeRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/branding/home";
import { Route as AuthenticatedFeature_announcementAdminSystemBrandingLogosRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/branding/logos";
import { Route as AuthenticatedFeature_announcementAdminSystemBrandingThemeRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/branding/theme";
import { Route as AuthenticatedFeature_announcementAdminSystemIntegrationsIndexRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/integrations/index";
import { Route as AuthenticatedFeature_announcementAdminSystemIntegrationsMentorcliqRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/integrations/mentorcliq";
import { Route as AuthenticatedFeature_announcementAdminSystemIntegrationsOutlookRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/integrations/outlook";
import { Route as AuthenticatedFeature_announcementAdminSystemIntegrationsSimpplrRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/integrations/simpplr";
import { Route as AuthenticatedFeature_announcementAdminSystemIntegrationsSlackRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/integrations/slack";
import { Route as AuthenticatedFeature_announcementAdminSystemIntegrationsTeamsRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/integrations/teams";
import { Route as AuthenticatedFeature_announcementAdminSystemIntegrationsUkgRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/integrations/ukg";
import { Route as AuthenticatedFeature_announcementAdminSystemIntegrationsVivaEngageRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/integrations/viva-engage";
import { Route as AuthenticatedFeature_announcementAdminSystemRolesRole_configurationRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/roles/role_configuration";
import { Route as AuthenticatedFeature_announcementAdminSystemSettingsConfigurationRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/settings/_configuration";
import { Route as AuthenticatedFeature_announcementAdminSystemSettingsCustom_textsRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/settings/custom_texts";
import { Route as AuthenticatedFeature_announcementAdminSystemSettingsFieldsRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/settings/fields";
import { Route as AuthenticatedFeature_announcementAdminSystemSettingsSsoRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/settings/sso";
import { Route as AuthenticatedFeature_announcementAdminSystemUsersImportRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/users/import";
import { Route as AuthenticatedFeature_announcementAdminSystemUsersListRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/users/list";
import { Route as AuthenticatedFeature_announcementAdminSystemUsersMergeRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/users/merge";
import { Route as AuthenticatedFeature_announcementAdminSystemUsersNewRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/users/new";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingManageRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/budgeting/manage";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingOverviewRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/budgeting/overview";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRequestRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/budgeting/request";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdEventsIndexRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/events/index";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdEventsPendingRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/events/pending";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdManageArchivesRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/manage/archives";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunityLabReportRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/manage/community-lab-report";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdManageReview_settingsRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/manage/review_settings";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdManageRole_configurationRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/manage/role_configuration";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/manage/settings";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdMembersIndexRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/members/index";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRouteRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/members/automations/route";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdMembersInvitationsRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/members/invitations";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/plan/budgeting";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdPlanEventsRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/plan/events";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdPostsIndexRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/posts/index";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdRoiSuiteSplatRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/roi-suite.$";
import { Route as AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdCohortsCohortIdRouteImport } from "./routes/_authenticated/_feature_announcement/_user/global-survey-response.$surveyId.cohorts.$cohortId";
import { Route as AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdIndexRouteImport } from "./routes/_authenticated/_feature_announcement/_user/network-survey-response.$networkId.$surveyId.index";
import { Route as AuthenticatedFeature_announcementUserProfileEditRecordHoursCommunityIdRouteImport } from "./routes/_authenticated/_feature_announcement/_user/profile/edit/record-hours.$communityId";
import { Route as AuthenticatedFeature_announcementAdminGamificationAchievementsAchievementIdEditRouteImport } from "./routes/_authenticated/_feature_announcement/admin/gamification/achievements/$achievementId.edit";
import { Route as AuthenticatedFeature_announcementAdminGamificationRewardsRewardIdEditRouteImport } from "./routes/_authenticated/_feature_announcement/admin/gamification/rewards/$rewardId.edit";
import { Route as AuthenticatedFeature_announcementAdminManageCalendarCalendarIdUpdateRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/calendar/$calendarId/update";
import { Route as AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdDistributionsRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/communications/$communicationId/distributions";
import { Route as AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdEditRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/communications/$communicationId/edit";
import { Route as AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdRecipientsRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/communications/$communicationId/recipients";
import { Route as AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarIndexRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/events/notable_dates_calendar/index";
import { Route as AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCreateRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/events/notable_dates_calendar/create";
import { Route as AuthenticatedFeature_announcementAdminManageGroupsGroupIdCategorizeRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/groups/$groupId/categorize";
import { Route as AuthenticatedFeature_announcementAdminManageGroupsGroupIdEditRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/groups/$groupId/edit";
import { Route as AuthenticatedFeature_announcementAdminManageGroupsCategoriesIndexRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/groups/categories/index";
import { Route as AuthenticatedFeature_announcementAdminManageGroupsCategoriesNewRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/groups/categories/new";
import { Route as AuthenticatedFeature_announcementAdminManageSegmentsSegmentIdEditRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/segments/$segmentId.edit";
import { Route as AuthenticatedFeature_announcementAdminPlanBudgetingFiscal_periodsNewRouteImport } from "./routes/_authenticated/_feature_announcement/admin/plan/budgeting/fiscal_periods.new";
import { Route as AuthenticatedFeature_announcementAdminSystemBrandingSponsorsIndexRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/branding/sponsors/index";
import { Route as AuthenticatedFeature_announcementAdminSystemBrandingSponsorsNewRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/branding/sponsors/new";
import { Route as AuthenticatedFeature_announcementAdminSystemRolesCommunityIndexRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/roles/community/index";
import { Route as AuthenticatedFeature_announcementAdminSystemRolesPlatformIndexRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/roles/platform/index";
import { Route as AuthenticatedFeature_announcementAdminSystemSettingsConfigurationCommunitiesRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/settings/_configuration/communities";
import { Route as AuthenticatedFeature_announcementAdminSystemSettingsConfigurationConfigurationRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/settings/_configuration/configuration";
import { Route as AuthenticatedFeature_announcementAdminSystemSettingsConfigurationModulesRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/settings/_configuration/modules";
import { Route as AuthenticatedFeature_announcementAdminSystemSettingsConfigurationProfile_fieldsRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/settings/_configuration/profile_fields";
import { Route as AuthenticatedFeature_announcementAdminSystemSettingsEmailsIndexRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/settings/emails/index";
import { Route as AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsIndexRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/settings/policy_documents/index";
import { Route as AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsNewRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/settings/policy_documents/new";
import { Route as AuthenticatedFeature_announcementAdminSystemUsersUserIdIndexRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/users/$userId/index";
import { Route as AuthenticatedFeature_announcementAdminSystemUsersUserIdEditRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/users/$userId/edit";
import { Route as AuthenticatedFeature_announcementAdminSystemUsersUserIdRole_assignmentsRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/users/$userId/role_assignments";
import { Route as AuthenticatedFeature_announcementAdminSystemUsersUserIdStatisticsRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/users/$userId/statistics";
import { Route as AuthenticatedFeature_announcementAdminSystemUsersPolicy_templatesIndexRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/users/policy_templates/index";
import { Route as AuthenticatedFeature_announcementAdminSystemUsersRolesIndexRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/users/roles/index";
import { Route as AuthenticatedFeature_announcementAdminSystemUsersRolesNewRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/users/roles/new";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdIndexRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/events/$eventId/index";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdEditRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/events/$eventId/edit";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsIndexRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/manage/communications/index";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsNewRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/manage/communications/new";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdManageEventsPendingRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/manage/events.pending";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersIndexRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/manage/leaders/index";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersNewRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/manage/leaders/new";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsIndexRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/manage/settings/index";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsIntegrationRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/manage/settings/integration";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsWelcome_messageRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/manage/settings/welcome_message";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsIndexRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/manage/sponsors/index";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsNewRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/manage/sponsors/new";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysIndexRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/manage/surveys/index";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysNewRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/manage/surveys/new";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsIndexRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/members/automations/index";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsNewRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/members/automations/new";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingManageRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/plan/budgeting/manage";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingOverviewRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/plan/budgeting/overview";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRequestRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/plan/budgeting/request";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesIndexRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/plan/outcomes/index";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesNewRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/plan/outcomes/new";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsIndexRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/plan/pillars/index";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsNewRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/plan/pillars/new";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdPostsPostIdIndexRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/posts/$postId/index";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdPostsPostIdEditRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/posts/$postId/edit";
import { Route as AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdCohortsCohortIdRouteImport } from "./routes/_authenticated/_feature_announcement/_user/network-survey-response.$networkId.$surveyId.cohorts.$cohortId";
import { Route as AuthenticatedFeature_announcementAdminManageCalendarCalendarIdNotable_datesCreateRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/calendar/$calendarId/notable_dates/create";
import { Route as AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdUpdateRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/events/notable_dates_calendar/$calendarId/update";
import { Route as AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsIndexRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/groups/$groupId/regions/index";
import { Route as AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsNewRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/groups/$groupId/regions/new";
import { Route as AuthenticatedFeature_announcementAdminManageGroupsCategoriesCategoryIdEditRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/groups/categories/$categoryId.edit";
import { Route as AuthenticatedFeature_announcementAdminSystemBrandingSponsorsSponsorIdEditRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/branding/sponsors/$sponsorId.edit";
import { Route as AuthenticatedFeature_announcementAdminSystemRolesCommunityRoleIdIndexRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/roles/community/$roleId/index";
import { Route as AuthenticatedFeature_announcementAdminSystemRolesCommunityRoleIdPermissionsRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/roles/community/$roleId/permissions";
import { Route as AuthenticatedFeature_announcementAdminSystemRolesPlatformRoleIdIndexRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/roles/platform/$roleId/index";
import { Route as AuthenticatedFeature_announcementAdminSystemRolesPlatformRoleIdPermissionsRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/roles/platform/$roleId/permissions";
import { Route as AuthenticatedFeature_announcementAdminSystemSettingsEmailsEmailIdEditRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/settings/emails/$emailId.edit";
import { Route as AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsEditPolicyDocumentIdRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/settings/policy_documents/edit.$policyDocumentId";
import { Route as AuthenticatedFeature_announcementAdminSystemUsersUserIdEditFieldsRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/users/$userId/edit.fields";
import { Route as AuthenticatedFeature_announcementAdminSystemUsersUserIdEditGeneralRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/users/$userId/edit.general";
import { Route as AuthenticatedFeature_announcementAdminSystemUsersPolicy_templatesPolicyIdEditRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/users/policy_templates/$policyId.edit";
import { Route as AuthenticatedFeature_announcementAdminSystemUsersRolesRoleIdEditRouteImport } from "./routes/_authenticated/_feature_announcement/admin/system/users/roles/$roleId/edit";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageAttendeesRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/events/$eventId/manage/attendees";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageBudgetingRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/events/$eventId/manage/budgeting";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageWaitlistRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/events/$eventId/manage/waitlist";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdDistributionsRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/manage/communications/$communicationId/distributions";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdEditRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/manage/communications/$communicationId/edit";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdRecipientsRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/manage/communications/$communicationId/recipients";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersLeaderIdEditRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/manage/leaders/$leaderId.edit";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsSponsorIdEditRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/manage/sponsors/$sponsorId.edit";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysSurveyIdEditRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/manage/surveys/$surveyId/edit";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysSurveyIdResponsesRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/manage/surveys/$surveyId/responses";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRuleIdEditRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/members/automations/$ruleId.edit";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsHistoryIndexRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/members/automations/history/index";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsHistoryRunIdRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/members/automations/history/$runId";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesOutcomeIdEditRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/plan/outcomes/$outcomeId.edit";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsPillarIdEditRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/plan/pillars/$pillarId/edit";
import { Route as AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsPillarIdEventsRouteImport } from "./routes/_authenticated/_feature_announcement/communities/$communityId/plan/pillars/$pillarId/events";
import { Route as AuthenticatedFeature_announcementAdminManageCalendarCalendarIdNotable_datesEventIdUpdateRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/calendar/$calendarId/notable_dates/$eventId.update";
import { Route as AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdNotable_datesCreateRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/events/notable_dates_calendar/$calendarId/notable_dates/create";
import { Route as AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsRegionIdEditRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/groups/$groupId/regions/$regionId.edit";
import { Route as AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdNotable_datesEventIdUpdateRouteImport } from "./routes/_authenticated/_feature_announcement/admin/manage/events/notable_dates_calendar/$calendarId/notable_dates/$eventId.update";

const AnonymousRoute = AnonymousRouteImport.update({
  id: "/_anonymous",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRouteImport,
} as any);
const CmsRoute = CmsRouteImport.update({
  id: "/_cms",
  getParentRoute: () => rootRouteImport,
} as any);
const SessionRoute = SessionRouteImport.update({
  id: "/_session",
  getParentRoute: () => rootRouteImport,
} as any);
const AutoLoginRoute = AutoLoginRouteImport.update({
  id: "/auto-login",
  path: "/auto-login",
  getParentRoute: () => rootRouteImport,
} as any);
const EnrollmentRoute = EnrollmentRouteImport.update({
  id: "/enrollment",
  path: "/enrollment",
  getParentRoute: () => rootRouteImport,
} as any);
const compatibilityOnboardingRoute = compatibilityOnboardingRouteImport.update({
  id: "/(compatibility)/onboarding",
  path: "/onboarding",
  getParentRoute: () => rootRouteImport,
} as any);
const compatibilitySign_upRoute = compatibilitySign_upRouteImport.update({
  id: "/(compatibility)/sign_up",
  path: "/sign_up",
  getParentRoute: () => rootRouteImport,
} as any);
const AnonymousMobile_sign_inRoute = AnonymousMobile_sign_inRouteImport.update({
  id: "/mobile_sign_in",
  path: "/mobile_sign_in",
  getParentRoute: () => AnonymousRoute,
} as any);
const AnonymousUnsubscribeRoute = AnonymousUnsubscribeRouteImport.update({
  id: "/unsubscribe",
  path: "/unsubscribe",
  getParentRoute: () => AnonymousRoute,
} as any);
const AuthenticatedFeature_announcementRoute =
  AuthenticatedFeature_announcementRouteImport.update({
    id: "/_feature_announcement",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const SessionForgotRoute = SessionForgotRouteImport.update({
  id: "/forgot",
  path: "/forgot",
  getParentRoute: () => SessionRoute,
} as any);
const EnrollmentIndexRoute = EnrollmentIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => EnrollmentRoute,
} as any);
const EnrollmentCompleteRoute = EnrollmentCompleteRouteImport.update({
  id: "/complete",
  path: "/complete",
  getParentRoute: () => EnrollmentRoute,
} as any);
const EnrollmentDiscoverRoute = EnrollmentDiscoverRouteImport.update({
  id: "/discover",
  path: "/discover",
  getParentRoute: () => EnrollmentRoute,
} as any);
const EnrollmentProfileRoute = EnrollmentProfileRouteImport.update({
  id: "/profile",
  path: "/profile",
  getParentRoute: () => EnrollmentRoute,
} as any);
const AnonymousEvent_checkinEventIdRoute =
  AnonymousEvent_checkinEventIdRouteImport.update({
    id: "/event_checkin/$eventId",
    path: "/event_checkin/$eventId",
    getParentRoute: () => AnonymousRoute,
  } as any);
const AnonymousVerifyTokenRoute = AnonymousVerifyTokenRouteImport.update({
  id: "/verify/$token",
  path: "/verify/$token",
  getParentRoute: () => AnonymousRoute,
} as any);
const AuthenticatedFeature_announcementUserRoute =
  AuthenticatedFeature_announcementUserRouteImport.update({
    id: "/_user",
    getParentRoute: () => AuthenticatedFeature_announcementRoute,
  } as any);
const AuthenticatedFeature_announcementAdminRoute =
  AuthenticatedFeature_announcementAdminRouteImport.update({
    id: "/admin",
    path: "/admin",
    getParentRoute: () => AuthenticatedFeature_announcementRoute,
  } as any);
const CmsCmsIndexRoute = CmsCmsIndexRouteImport.update({
  id: "/cms/",
  path: "/cms/",
  getParentRoute: () => CmsRoute,
} as any);
const SessionLoginIndexRoute = SessionLoginIndexRouteImport.update({
  id: "/login/",
  path: "/login/",
  getParentRoute: () => SessionRoute,
} as any);
const SessionLoginActivateRoute = SessionLoginActivateRouteImport.update({
  id: "/login/activate",
  path: "/login/activate",
  getParentRoute: () => SessionRoute,
} as any);
const SessionLoginAdminRoute = SessionLoginAdminRouteImport.update({
  id: "/login/admin",
  path: "/login/admin",
  getParentRoute: () => SessionRoute,
} as any);
const SessionLoginCredentialsRoute = SessionLoginCredentialsRouteImport.update({
  id: "/login/credentials",
  path: "/login/credentials",
  getParentRoute: () => SessionRoute,
} as any);
const SessionPassword_resetIndexRoute =
  SessionPassword_resetIndexRouteImport.update({
    id: "/password_reset/",
    path: "/password_reset/",
    getParentRoute: () => SessionRoute,
  } as any);
const SessionPassword_resetTokenRoute =
  SessionPassword_resetTokenRouteImport.update({
    id: "/password_reset/$token",
    path: "/password_reset/$token",
    getParentRoute: () => SessionRoute,
  } as any);
const AuthenticatedFeature_announcementUserIndexRoute =
  AuthenticatedFeature_announcementUserIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedFeature_announcementUserRoute,
  } as any);
const AuthenticatedFeature_announcementUserCommunitiesRoute =
  AuthenticatedFeature_announcementUserCommunitiesRouteImport.update({
    id: "/communities",
    path: "/communities",
    getParentRoute: () => AuthenticatedFeature_announcementUserRoute,
  } as any);
const AuthenticatedFeature_announcementUserDownloadsRoute =
  AuthenticatedFeature_announcementUserDownloadsRouteImport.update({
    id: "/downloads",
    path: "/downloads",
    getParentRoute: () => AuthenticatedFeature_announcementUserRoute,
  } as any);
const AuthenticatedFeature_announcementUserGroupsRoute =
  AuthenticatedFeature_announcementUserGroupsRouteImport.update({
    id: "/groups",
    path: "/groups",
    getParentRoute: () => AuthenticatedFeature_announcementUserRoute,
  } as any);
const AuthenticatedFeature_announcementUserNotificationsRoute =
  AuthenticatedFeature_announcementUserNotificationsRouteImport.update({
    id: "/notifications",
    path: "/notifications",
    getParentRoute: () => AuthenticatedFeature_announcementUserRoute,
  } as any);
const AuthenticatedFeature_announcementUserProfileRoute =
  AuthenticatedFeature_announcementUserProfileRouteImport.update({
    id: "/profile",
    path: "/profile",
    getParentRoute: () => AuthenticatedFeature_announcementUserRoute,
  } as any);
const AuthenticatedFeature_announcementUserRewardsRoute =
  AuthenticatedFeature_announcementUserRewardsRouteImport.update({
    id: "/rewards",
    path: "/rewards",
    getParentRoute: () => AuthenticatedFeature_announcementUserRoute,
  } as any);
const AuthenticatedFeature_announcementUserSupportRoute =
  AuthenticatedFeature_announcementUserSupportRouteImport.update({
    id: "/support",
    path: "/support",
    getParentRoute: () => AuthenticatedFeature_announcementUserRoute,
  } as any);
const AuthenticatedFeature_announcementAdminSupportConfigRoute =
  AuthenticatedFeature_announcementAdminSupportConfigRouteImport.update({
    id: "/support-config",
    path: "/support-config",
    getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
  } as any);
const AuthenticatedFeature_announcementAdminSystemRoute =
  AuthenticatedFeature_announcementAdminSystemRouteImport.update({
    id: "/system",
    path: "/system",
    getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
  } as any);
const AuthenticatedFeature_announcementCommunitiesCommunityIdRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdRouteImport.update({
    id: "/communities/$communityId",
    path: "/communities/$communityId",
    getParentRoute: () => AuthenticatedFeature_announcementRoute,
  } as any);
const AuthenticatedFeature_announcementOpen_invitationsOpenInvitationIdRoute =
  AuthenticatedFeature_announcementOpen_invitationsOpenInvitationIdRouteImport.update(
    {
      id: "/open_invitations/$openInvitationId",
      path: "/open_invitations/$openInvitationId",
      getParentRoute: () => AuthenticatedFeature_announcementRoute,
    } as any,
  );
const CmsCmsReviewComment_moderationRoute =
  CmsCmsReviewComment_moderationRouteImport.update({
    id: "/cms/review/comment_moderation",
    path: "/cms/review/comment_moderation",
    getParentRoute: () => CmsRoute,
  } as any);
const CmsCmsToolsReview_settingsRoute =
  CmsCmsToolsReview_settingsRouteImport.update({
    id: "/cms/tools/review_settings",
    path: "/cms/tools/review_settings",
    getParentRoute: () => CmsRoute,
  } as any);
const AuthenticatedFeature_announcementUserCommunityLabIndexRoute =
  AuthenticatedFeature_announcementUserCommunityLabIndexRouteImport.update({
    id: "/community-lab/",
    path: "/community-lab/",
    getParentRoute: () => AuthenticatedFeature_announcementUserRoute,
  } as any);
const AuthenticatedFeature_announcementUserCommunityLabSplatRoute =
  AuthenticatedFeature_announcementUserCommunityLabSplatRouteImport.update({
    id: "/community-lab/$",
    path: "/community-lab/$",
    getParentRoute: () => AuthenticatedFeature_announcementUserRoute,
  } as any);
const AuthenticatedFeature_announcementUserCommunityLabSessionRoute =
  AuthenticatedFeature_announcementUserCommunityLabSessionRouteImport.update({
    id: "/community-lab/session",
    path: "/community-lab/session",
    getParentRoute: () => AuthenticatedFeature_announcementUserRoute,
  } as any);
const AuthenticatedFeature_announcementUserCommunityLabWorksheetRoute =
  AuthenticatedFeature_announcementUserCommunityLabWorksheetRouteImport.update({
    id: "/community-lab/worksheet",
    path: "/community-lab/worksheet",
    getParentRoute: () => AuthenticatedFeature_announcementUserRoute,
  } as any);
const AuthenticatedFeature_announcementUserEventsIndexRoute =
  AuthenticatedFeature_announcementUserEventsIndexRouteImport.update({
    id: "/events/",
    path: "/events/",
    getParentRoute: () => AuthenticatedFeature_announcementUserRoute,
  } as any);
const AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdRoute =
  AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdRouteImport.update(
    {
      id: "/global-survey-response/$surveyId",
      path: "/global-survey-response/$surveyId",
      getParentRoute: () => AuthenticatedFeature_announcementUserRoute,
    } as any,
  );
const AuthenticatedFeature_announcementUserPostsIndexRoute =
  AuthenticatedFeature_announcementUserPostsIndexRouteImport.update({
    id: "/posts/",
    path: "/posts/",
    getParentRoute: () => AuthenticatedFeature_announcementUserRoute,
  } as any);
const AuthenticatedFeature_announcementUserProfileIndexRoute =
  AuthenticatedFeature_announcementUserProfileIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedFeature_announcementUserProfileRoute,
  } as any);
const AuthenticatedFeature_announcementUserProfileStatisticsRoute =
  AuthenticatedFeature_announcementUserProfileStatisticsRouteImport.update({
    id: "/statistics",
    path: "/statistics",
    getParentRoute: () => AuthenticatedFeature_announcementUserProfileRoute,
  } as any);
const AuthenticatedFeature_announcementAdminAnalyzeIndexRoute =
  AuthenticatedFeature_announcementAdminAnalyzeIndexRouteImport.update({
    id: "/analyze/",
    path: "/analyze/",
    getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
  } as any);
const AuthenticatedFeature_announcementAdminAnalyzeCommunityLabReportRoute =
  AuthenticatedFeature_announcementAdminAnalyzeCommunityLabReportRouteImport.update(
    {
      id: "/analyze/community-lab-report",
      path: "/analyze/community-lab-report",
      getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminAnalyzeGroupsRoute =
  AuthenticatedFeature_announcementAdminAnalyzeGroupsRouteImport.update({
    id: "/analyze/groups",
    path: "/analyze/groups",
    getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
  } as any);
const AuthenticatedFeature_announcementAdminAnalyzeReportsRoute =
  AuthenticatedFeature_announcementAdminAnalyzeReportsRouteImport.update({
    id: "/analyze/reports",
    path: "/analyze/reports",
    getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
  } as any);
const AuthenticatedFeature_announcementAdminAnalyzeSegmentsRoute =
  AuthenticatedFeature_announcementAdminAnalyzeSegmentsRouteImport.update({
    id: "/analyze/segments",
    path: "/analyze/segments",
    getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
  } as any);
const AuthenticatedFeature_announcementAdminAnalyzeUsersRoute =
  AuthenticatedFeature_announcementAdminAnalyzeUsersRouteImport.update({
    id: "/analyze/users",
    path: "/analyze/users",
    getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
  } as any);
const AuthenticatedFeature_announcementAdminContextBackfillIndexRoute =
  AuthenticatedFeature_announcementAdminContextBackfillIndexRouteImport.update({
    id: "/context-backfill/",
    path: "/context-backfill/",
    getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
  } as any);
const AuthenticatedFeature_announcementAdminGamificationRewardsRoute =
  AuthenticatedFeature_announcementAdminGamificationRewardsRouteImport.update({
    id: "/gamification/rewards",
    path: "/gamification/rewards",
    getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
  } as any);
const AuthenticatedFeature_announcementAdminManageArchivedRoute =
  AuthenticatedFeature_announcementAdminManageArchivedRouteImport.update({
    id: "/manage/archived",
    path: "/manage/archived",
    getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
  } as any);
const AuthenticatedFeature_announcementAdminManageEventsRoute =
  AuthenticatedFeature_announcementAdminManageEventsRouteImport.update({
    id: "/manage/events",
    path: "/manage/events",
    getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
  } as any);
const AuthenticatedFeature_announcementAdminManageFoldersRoute =
  AuthenticatedFeature_announcementAdminManageFoldersRouteImport.update({
    id: "/manage/folders",
    path: "/manage/folders",
    getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
  } as any);
const AuthenticatedFeature_announcementAdminManageLabelsRoute =
  AuthenticatedFeature_announcementAdminManageLabelsRouteImport.update({
    id: "/manage/labels",
    path: "/manage/labels",
    getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
  } as any);
const AuthenticatedFeature_announcementAdminManageLeadersRoute =
  AuthenticatedFeature_announcementAdminManageLeadersRouteImport.update({
    id: "/manage/leaders",
    path: "/manage/leaders",
    getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
  } as any);
const AuthenticatedFeature_announcementAdminManageTagsRoute =
  AuthenticatedFeature_announcementAdminManageTagsRouteImport.update({
    id: "/manage/tags",
    path: "/manage/tags",
    getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
  } as any);
const AuthenticatedFeature_announcementAdminPlanAggregate_budgetingRoute =
  AuthenticatedFeature_announcementAdminPlanAggregate_budgetingRouteImport.update(
    {
      id: "/plan/aggregate_budgeting",
      path: "/plan/aggregate_budgeting",
      getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSurveysIndexRoute =
  AuthenticatedFeature_announcementAdminSurveysIndexRouteImport.update({
    id: "/surveys/",
    path: "/surveys/",
    getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
  } as any);
const AuthenticatedFeature_announcementAdminSurveysNewRoute =
  AuthenticatedFeature_announcementAdminSurveysNewRouteImport.update({
    id: "/surveys/new",
    path: "/surveys/new",
    getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
  } as any);
const AuthenticatedFeature_announcementAdminSystemApi_access_tokensRoute =
  AuthenticatedFeature_announcementAdminSystemApi_access_tokensRouteImport.update(
    {
      id: "/api_access_tokens",
      path: "/api_access_tokens",
      getParentRoute: () => AuthenticatedFeature_announcementAdminSystemRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemBrandingRoute =
  AuthenticatedFeature_announcementAdminSystemBrandingRouteImport.update({
    id: "/branding",
    path: "/branding",
    getParentRoute: () => AuthenticatedFeature_announcementAdminSystemRoute,
  } as any);
const AuthenticatedFeature_announcementAdminSystemIntegrationsRoute =
  AuthenticatedFeature_announcementAdminSystemIntegrationsRouteImport.update({
    id: "/integrations",
    path: "/integrations",
    getParentRoute: () => AuthenticatedFeature_announcementAdminSystemRoute,
  } as any);
const AuthenticatedFeature_announcementAdminSystemLogsRoute =
  AuthenticatedFeature_announcementAdminSystemLogsRouteImport.update({
    id: "/logs",
    path: "/logs",
    getParentRoute: () => AuthenticatedFeature_announcementAdminSystemRoute,
  } as any);
const AuthenticatedFeature_announcementAdminSystemMcp_connectorRoute =
  AuthenticatedFeature_announcementAdminSystemMcp_connectorRouteImport.update({
    id: "/mcp_connector",
    path: "/mcp_connector",
    getParentRoute: () => AuthenticatedFeature_announcementAdminSystemRoute,
  } as any);
const AuthenticatedFeature_announcementAdminSystemRolesRoute =
  AuthenticatedFeature_announcementAdminSystemRolesRouteImport.update({
    id: "/roles",
    path: "/roles",
    getParentRoute: () => AuthenticatedFeature_announcementAdminSystemRoute,
  } as any);
const AuthenticatedFeature_announcementAdminSystemSettingsRoute =
  AuthenticatedFeature_announcementAdminSystemSettingsRouteImport.update({
    id: "/settings",
    path: "/settings",
    getParentRoute: () => AuthenticatedFeature_announcementAdminSystemRoute,
  } as any);
const AuthenticatedFeature_announcementAdminSystemUsersRoute =
  AuthenticatedFeature_announcementAdminSystemUsersRouteImport.update({
    id: "/users",
    path: "/users",
    getParentRoute: () => AuthenticatedFeature_announcementAdminSystemRoute,
  } as any);
const AuthenticatedFeature_announcementCommunitiesCommunityIdIndexRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdIndexRouteImport.update(
    {
      id: "/",
      path: "/",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRouteImport.update(
    {
      id: "/budgeting",
      path: "/budgeting",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdChaptersRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdChaptersRouteImport.update(
    {
      id: "/chapters",
      path: "/chapters",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdFoldersRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdFoldersRouteImport.update(
    {
      id: "/folders",
      path: "/folders",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageRouteImport.update(
    {
      id: "/manage",
      path: "/manage",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdMembersRouteRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdMembersRouteRouteImport.update(
    {
      id: "/members",
      path: "/members",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRouteImport.update(
    {
      id: "/plan",
      path: "/plan",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdRoute,
    } as any,
  );
const AuthenticatedFeature_announcementGroupsGroupIdSplatRoute =
  AuthenticatedFeature_announcementGroupsGroupIdSplatRouteImport.update({
    id: "/groups/$groupId/$",
    path: "/groups/$groupId/$",
    getParentRoute: () => AuthenticatedFeature_announcementRoute,
  } as any);
const AuthenticatedFeature_announcementInvitationsInvitationIdAcceptRoute =
  AuthenticatedFeature_announcementInvitationsInvitationIdAcceptRouteImport.update(
    {
      id: "/invitations/$invitationId/accept",
      path: "/invitations/$invitationId/accept",
      getParentRoute: () => AuthenticatedFeature_announcementRoute,
    } as any,
  );
const AuthenticatedFeature_announcementInvitationsInvitationIdDeclineRoute =
  AuthenticatedFeature_announcementInvitationsInvitationIdDeclineRouteImport.update(
    {
      id: "/invitations/$invitationId/decline",
      path: "/invitations/$invitationId/decline",
      getParentRoute: () => AuthenticatedFeature_announcementRoute,
    } as any,
  );
const AuthenticatedFeature_announcementRegionsRegionIdSplatRoute =
  AuthenticatedFeature_announcementRegionsRegionIdSplatRouteImport.update({
    id: "/regions/$regionId/$",
    path: "/regions/$regionId/$",
    getParentRoute: () => AuthenticatedFeature_announcementRoute,
  } as any);
const CmsCmsManageCommunicationsIndexRoute =
  CmsCmsManageCommunicationsIndexRouteImport.update({
    id: "/cms/manage/communications/",
    path: "/cms/manage/communications/",
    getParentRoute: () => CmsRoute,
  } as any);
const CmsCmsManageCommunicationsDraftIdRoute =
  CmsCmsManageCommunicationsDraftIdRouteImport.update({
    id: "/cms/manage/communications/$draftId",
    path: "/cms/manage/communications/$draftId",
    getParentRoute: () => CmsRoute,
  } as any);
const CmsCmsManageEventsIndexRoute = CmsCmsManageEventsIndexRouteImport.update({
  id: "/cms/manage/events/",
  path: "/cms/manage/events/",
  getParentRoute: () => CmsRoute,
} as any);
const CmsCmsManageEventsDraftIdRoute =
  CmsCmsManageEventsDraftIdRouteImport.update({
    id: "/cms/manage/events/$draftId",
    path: "/cms/manage/events/$draftId",
    getParentRoute: () => CmsRoute,
  } as any);
const CmsCmsManageEventsNewRoute = CmsCmsManageEventsNewRouteImport.update({
  id: "/cms/manage/events/new",
  path: "/cms/manage/events/new",
  getParentRoute: () => CmsRoute,
} as any);
const CmsCmsManagePostsIndexRoute = CmsCmsManagePostsIndexRouteImport.update({
  id: "/cms/manage/posts/",
  path: "/cms/manage/posts/",
  getParentRoute: () => CmsRoute,
} as any);
const CmsCmsManagePostsDraftIdRoute =
  CmsCmsManagePostsDraftIdRouteImport.update({
    id: "/cms/manage/posts/$draftId",
    path: "/cms/manage/posts/$draftId",
    getParentRoute: () => CmsRoute,
  } as any);
const CmsCmsManagePublication_requestsIndexRoute =
  CmsCmsManagePublication_requestsIndexRouteImport.update({
    id: "/cms/manage/publication_requests/",
    path: "/cms/manage/publication_requests/",
    getParentRoute: () => CmsRoute,
  } as any);
const CmsCmsManagePublication_requestsPublicationRequestIdRoute =
  CmsCmsManagePublication_requestsPublicationRequestIdRouteImport.update({
    id: "/cms/manage/publication_requests/$publicationRequestId",
    path: "/cms/manage/publication_requests/$publicationRequestId",
    getParentRoute: () => CmsRoute,
  } as any);
const CmsCmsReviewPublication_requestsIndexRoute =
  CmsCmsReviewPublication_requestsIndexRouteImport.update({
    id: "/cms/review/publication_requests/",
    path: "/cms/review/publication_requests/",
    getParentRoute: () => CmsRoute,
  } as any);
const CmsCmsReviewPublication_requestsPublicationRequestIdRoute =
  CmsCmsReviewPublication_requestsPublicationRequestIdRouteImport.update({
    id: "/cms/review/publication_requests/$publicationRequestId",
    path: "/cms/review/publication_requests/$publicationRequestId",
    getParentRoute: () => CmsRoute,
  } as any);
const compatibilityEnterprisesEnterpriseIdFoldersFolderIdResourcesRoute =
  compatibilityEnterprisesEnterpriseIdFoldersFolderIdResourcesRouteImport.update(
    {
      id: "/(compatibility)/enterprises/$enterpriseId/folders/$folderId/resources",
      path: "/enterprises/$enterpriseId/folders/$folderId/resources",
      getParentRoute: () => rootRouteImport,
    } as any,
  );
const compatibilityGroupsGroupIdFoldersFolderIdResourcesRoute =
  compatibilityGroupsGroupIdFoldersFolderIdResourcesRouteImport.update({
    id: "/(compatibility)/groups/$groupId/folders/$folderId/resources",
    path: "/groups/$groupId/folders/$folderId/resources",
    getParentRoute: () => rootRouteImport,
  } as any);
const compatibilityGroupsGroupIdNewsTypePostIdRoute =
  compatibilityGroupsGroupIdNewsTypePostIdRouteImport.update({
    id: "/(compatibility)/groups/$groupId/news/$type/$postId",
    path: "/groups/$groupId/news/$type/$postId",
    getParentRoute: () => rootRouteImport,
  } as any);
const compatibilityRegionsRegionIdNewsTypePostIdRoute =
  compatibilityRegionsRegionIdNewsTypePostIdRouteImport.update({
    id: "/(compatibility)/regions/$regionId/news/$type/$postId",
    path: "/regions/$regionId/news/$type/$postId",
    getParentRoute: () => rootRouteImport,
  } as any);
const AuthenticatedFeature_announcementUserEventsEventIdSplatRoute =
  AuthenticatedFeature_announcementUserEventsEventIdSplatRouteImport.update({
    id: "/events/$eventId/$",
    path: "/events/$eventId/$",
    getParentRoute: () => AuthenticatedFeature_announcementUserRoute,
  } as any);
const AuthenticatedFeature_announcementUserEventsDraftsIndexRoute =
  AuthenticatedFeature_announcementUserEventsDraftsIndexRouteImport.update({
    id: "/events/drafts/",
    path: "/events/drafts/",
    getParentRoute: () => AuthenticatedFeature_announcementUserRoute,
  } as any);
const AuthenticatedFeature_announcementUserEventsDraftsDraftIdRoute =
  AuthenticatedFeature_announcementUserEventsDraftsDraftIdRouteImport.update({
    id: "/events/drafts/$draftId",
    path: "/events/drafts/$draftId",
    getParentRoute: () => AuthenticatedFeature_announcementUserRoute,
  } as any);
const AuthenticatedFeature_announcementUserEventsDraftsNewRoute =
  AuthenticatedFeature_announcementUserEventsDraftsNewRouteImport.update({
    id: "/events/drafts/new",
    path: "/events/drafts/new",
    getParentRoute: () => AuthenticatedFeature_announcementUserRoute,
  } as any);
const AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdIndexRoute =
  AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdIndexRouteImport.update(
    {
      id: "/",
      path: "/",
      getParentRoute: () =>
        AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdRoute,
    } as any,
  );
const AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdRoute =
  AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdRouteImport.update(
    {
      id: "/network-survey-response/$networkId/$surveyId",
      path: "/network-survey-response/$networkId/$surveyId",
      getParentRoute: () => AuthenticatedFeature_announcementUserRoute,
    } as any,
  );
const AuthenticatedFeature_announcementUserPostsPostIdSplatRoute =
  AuthenticatedFeature_announcementUserPostsPostIdSplatRouteImport.update({
    id: "/posts/$postId/$",
    path: "/posts/$postId/$",
    getParentRoute: () => AuthenticatedFeature_announcementUserRoute,
  } as any);
const AuthenticatedFeature_announcementUserPostsDraftsIndexRoute =
  AuthenticatedFeature_announcementUserPostsDraftsIndexRouteImport.update({
    id: "/posts/drafts/",
    path: "/posts/drafts/",
    getParentRoute: () => AuthenticatedFeature_announcementUserRoute,
  } as any);
const AuthenticatedFeature_announcementUserPostsDraftsDraftIdRoute =
  AuthenticatedFeature_announcementUserPostsDraftsDraftIdRouteImport.update({
    id: "/posts/drafts/$draftId",
    path: "/posts/drafts/$draftId",
    getParentRoute: () => AuthenticatedFeature_announcementUserRoute,
  } as any);
const AuthenticatedFeature_announcementUserProfileEditAccessibilityRoute =
  AuthenticatedFeature_announcementUserProfileEditAccessibilityRouteImport.update(
    {
      id: "/edit/accessibility",
      path: "/edit/accessibility",
      getParentRoute: () => AuthenticatedFeature_announcementUserProfileRoute,
    } as any,
  );
const AuthenticatedFeature_announcementUserProfileEditEngagementReportRoute =
  AuthenticatedFeature_announcementUserProfileEditEngagementReportRouteImport.update(
    {
      id: "/edit/engagement-report",
      path: "/edit/engagement-report",
      getParentRoute: () => AuthenticatedFeature_announcementUserProfileRoute,
    } as any,
  );
const AuthenticatedFeature_announcementUserProfileEditGeneralRoute =
  AuthenticatedFeature_announcementUserProfileEditGeneralRouteImport.update({
    id: "/edit/general",
    path: "/edit/general",
    getParentRoute: () => AuthenticatedFeature_announcementUserProfileRoute,
  } as any);
const AuthenticatedFeature_announcementUserProfileEditLeadershipRoute =
  AuthenticatedFeature_announcementUserProfileEditLeadershipRouteImport.update({
    id: "/edit/leadership",
    path: "/edit/leadership",
    getParentRoute: () => AuthenticatedFeature_announcementUserProfileRoute,
  } as any);
const AuthenticatedFeature_announcementUserProfileEditNotificationRoute =
  AuthenticatedFeature_announcementUserProfileEditNotificationRouteImport.update(
    {
      id: "/edit/notification",
      path: "/edit/notification",
      getParentRoute: () => AuthenticatedFeature_announcementUserProfileRoute,
    } as any,
  );
const AuthenticatedFeature_announcementUserProfileEditOutlookRoute =
  AuthenticatedFeature_announcementUserProfileEditOutlookRouteImport.update({
    id: "/edit/outlook",
    path: "/edit/outlook",
    getParentRoute: () => AuthenticatedFeature_announcementUserProfileRoute,
  } as any);
const AuthenticatedFeature_announcementUserProfileEditPrivateRoute =
  AuthenticatedFeature_announcementUserProfileEditPrivateRouteImport.update({
    id: "/edit/private",
    path: "/edit/private",
    getParentRoute: () => AuthenticatedFeature_announcementUserProfileRoute,
  } as any);
const AuthenticatedFeature_announcementUserUserUserIdIndexRoute =
  AuthenticatedFeature_announcementUserUserUserIdIndexRouteImport.update({
    id: "/user/$userId/",
    path: "/user/$userId/",
    getParentRoute: () => AuthenticatedFeature_announcementUserRoute,
  } as any);
const AuthenticatedFeature_announcementUserUserUserIdAchievementsRoute =
  AuthenticatedFeature_announcementUserUserUserIdAchievementsRouteImport.update(
    {
      id: "/user/$userId/achievements",
      path: "/user/$userId/achievements",
      getParentRoute: () => AuthenticatedFeature_announcementUserRoute,
    } as any,
  );
const AuthenticatedFeature_announcementUserUserUserIdEditRoute =
  AuthenticatedFeature_announcementUserUserUserIdEditRouteImport.update({
    id: "/user/$userId/edit",
    path: "/user/$userId/edit",
    getParentRoute: () => AuthenticatedFeature_announcementUserRoute,
  } as any);
const AuthenticatedFeature_announcementUserUserUserIdStatisticsRoute =
  AuthenticatedFeature_announcementUserUserUserIdStatisticsRouteImport.update({
    id: "/user/$userId/statistics",
    path: "/user/$userId/statistics",
    getParentRoute: () => AuthenticatedFeature_announcementUserRoute,
  } as any);
const AuthenticatedFeature_announcementUserUserUserIdTransactionsRoute =
  AuthenticatedFeature_announcementUserUserUserIdTransactionsRouteImport.update(
    {
      id: "/user/$userId/transactions",
      path: "/user/$userId/transactions",
      getParentRoute: () => AuthenticatedFeature_announcementUserRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminAnalyzeDashboardsSplatRoute =
  AuthenticatedFeature_announcementAdminAnalyzeDashboardsSplatRouteImport.update(
    {
      id: "/analyze/dashboards/$",
      path: "/analyze/dashboards/$",
      getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminAnalyzeGroupsIndexRoute =
  AuthenticatedFeature_announcementAdminAnalyzeGroupsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () =>
      AuthenticatedFeature_announcementAdminAnalyzeGroupsRoute,
  } as any);
const AuthenticatedFeature_announcementAdminAnalyzeGroupsEventsRoute =
  AuthenticatedFeature_announcementAdminAnalyzeGroupsEventsRouteImport.update({
    id: "/events",
    path: "/events",
    getParentRoute: () =>
      AuthenticatedFeature_announcementAdminAnalyzeGroupsRoute,
  } as any);
const AuthenticatedFeature_announcementAdminAnalyzeGroupsPostsRoute =
  AuthenticatedFeature_announcementAdminAnalyzeGroupsPostsRouteImport.update({
    id: "/posts",
    path: "/posts",
    getParentRoute: () =>
      AuthenticatedFeature_announcementAdminAnalyzeGroupsRoute,
  } as any);
const AuthenticatedFeature_announcementAdminAnalyzeGroupsResourcesRoute =
  AuthenticatedFeature_announcementAdminAnalyzeGroupsResourcesRouteImport.update(
    {
      id: "/resources",
      path: "/resources",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminAnalyzeGroupsRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminAnalyzeGroupsUsersRoute =
  AuthenticatedFeature_announcementAdminAnalyzeGroupsUsersRouteImport.update({
    id: "/users",
    path: "/users",
    getParentRoute: () =>
      AuthenticatedFeature_announcementAdminAnalyzeGroupsRoute,
  } as any);
const AuthenticatedFeature_announcementAdminAnalyzeRoiSuiteSplatRoute =
  AuthenticatedFeature_announcementAdminAnalyzeRoiSuiteSplatRouteImport.update({
    id: "/analyze/roi-suite/$",
    path: "/analyze/roi-suite/$",
    getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
  } as any);
const AuthenticatedFeature_announcementAdminAnalyzeUsersIndexRoute =
  AuthenticatedFeature_announcementAdminAnalyzeUsersIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () =>
      AuthenticatedFeature_announcementAdminAnalyzeUsersRoute,
  } as any);
const AuthenticatedFeature_announcementAdminAnalyzeUsersEventsRoute =
  AuthenticatedFeature_announcementAdminAnalyzeUsersEventsRouteImport.update({
    id: "/events",
    path: "/events",
    getParentRoute: () =>
      AuthenticatedFeature_announcementAdminAnalyzeUsersRoute,
  } as any);
const AuthenticatedFeature_announcementAdminGamificationAchievementsIndexRoute =
  AuthenticatedFeature_announcementAdminGamificationAchievementsIndexRouteImport.update(
    {
      id: "/gamification/achievements/",
      path: "/gamification/achievements/",
      getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminGamificationAchievementsNewRoute =
  AuthenticatedFeature_announcementAdminGamificationAchievementsNewRouteImport.update(
    {
      id: "/gamification/achievements/new",
      path: "/gamification/achievements/new",
      getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminGamificationPointsManageRoute =
  AuthenticatedFeature_announcementAdminGamificationPointsManageRouteImport.update(
    {
      id: "/gamification/points/manage",
      path: "/gamification/points/manage",
      getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminGamificationRewardsIndexRoute =
  AuthenticatedFeature_announcementAdminGamificationRewardsIndexRouteImport.update(
    {
      id: "/",
      path: "/",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminGamificationRewardsRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminGamificationRewardsNewRoute =
  AuthenticatedFeature_announcementAdminGamificationRewardsNewRouteImport.update(
    {
      id: "/new",
      path: "/new",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminGamificationRewardsRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminGamificationRewardsPendingRoute =
  AuthenticatedFeature_announcementAdminGamificationRewardsPendingRouteImport.update(
    {
      id: "/pending",
      path: "/pending",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminGamificationRewardsRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminManageCalendarIndexRoute =
  AuthenticatedFeature_announcementAdminManageCalendarIndexRouteImport.update({
    id: "/manage/calendar/",
    path: "/manage/calendar/",
    getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
  } as any);
const AuthenticatedFeature_announcementAdminManageCalendarCreateRoute =
  AuthenticatedFeature_announcementAdminManageCalendarCreateRouteImport.update({
    id: "/manage/calendar/create",
    path: "/manage/calendar/create",
    getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
  } as any);
const AuthenticatedFeature_announcementAdminManageCommunicationsIndexRoute =
  AuthenticatedFeature_announcementAdminManageCommunicationsIndexRouteImport.update(
    {
      id: "/manage/communications/",
      path: "/manage/communications/",
      getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminManageCommunicationsNewRoute =
  AuthenticatedFeature_announcementAdminManageCommunicationsNewRouteImport.update(
    {
      id: "/manage/communications/new",
      path: "/manage/communications/new",
      getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminManageEventsCalendarRoute =
  AuthenticatedFeature_announcementAdminManageEventsCalendarRouteImport.update({
    id: "/calendar",
    path: "/calendar",
    getParentRoute: () =>
      AuthenticatedFeature_announcementAdminManageEventsRoute,
  } as any);
const AuthenticatedFeature_announcementAdminManageEventsConfigurationRoute =
  AuthenticatedFeature_announcementAdminManageEventsConfigurationRouteImport.update(
    {
      id: "/configuration",
      path: "/configuration",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminManageEventsRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminManageEventsQuestionnaireRoute =
  AuthenticatedFeature_announcementAdminManageEventsQuestionnaireRouteImport.update(
    {
      id: "/questionnaire",
      path: "/questionnaire",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminManageEventsRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminManageGroupsIndexRoute =
  AuthenticatedFeature_announcementAdminManageGroupsIndexRouteImport.update({
    id: "/manage/groups/",
    path: "/manage/groups/",
    getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
  } as any);
const AuthenticatedFeature_announcementAdminManageGroupsConnectionsRoute =
  AuthenticatedFeature_announcementAdminManageGroupsConnectionsRouteImport.update(
    {
      id: "/manage/groups/connections",
      path: "/manage/groups/connections",
      getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminManageGroupsLeader_positionsRoute =
  AuthenticatedFeature_announcementAdminManageGroupsLeader_positionsRouteImport.update(
    {
      id: "/manage/groups/leader_positions",
      path: "/manage/groups/leader_positions",
      getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminManageGroupsNewRoute =
  AuthenticatedFeature_announcementAdminManageGroupsNewRouteImport.update({
    id: "/manage/groups/new",
    path: "/manage/groups/new",
    getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
  } as any);
const AuthenticatedFeature_announcementAdminManageSegmentsIndexRoute =
  AuthenticatedFeature_announcementAdminManageSegmentsIndexRouteImport.update({
    id: "/manage/segments/",
    path: "/manage/segments/",
    getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
  } as any);
const AuthenticatedFeature_announcementAdminManageSegmentsNewRoute =
  AuthenticatedFeature_announcementAdminManageSegmentsNewRouteImport.update({
    id: "/manage/segments/new",
    path: "/manage/segments/new",
    getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
  } as any);
const AuthenticatedFeature_announcementAdminPlanBudgetingIndexRoute =
  AuthenticatedFeature_announcementAdminPlanBudgetingIndexRouteImport.update({
    id: "/plan/budgeting/",
    path: "/plan/budgeting/",
    getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
  } as any);
const AuthenticatedFeature_announcementAdminSurveysSurveyIdEditRoute =
  AuthenticatedFeature_announcementAdminSurveysSurveyIdEditRouteImport.update({
    id: "/surveys/$surveyId/edit",
    path: "/surveys/$surveyId/edit",
    getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
  } as any);
const AuthenticatedFeature_announcementAdminSurveysSurveyIdResponsesRoute =
  AuthenticatedFeature_announcementAdminSurveysSurveyIdResponsesRouteImport.update(
    {
      id: "/surveys/$surveyId/responses",
      path: "/surveys/$surveyId/responses",
      getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemBrandingColorsRoute =
  AuthenticatedFeature_announcementAdminSystemBrandingColorsRouteImport.update({
    id: "/colors",
    path: "/colors",
    getParentRoute: () =>
      AuthenticatedFeature_announcementAdminSystemBrandingRoute,
  } as any);
const AuthenticatedFeature_announcementAdminSystemBrandingHomeRoute =
  AuthenticatedFeature_announcementAdminSystemBrandingHomeRouteImport.update({
    id: "/home",
    path: "/home",
    getParentRoute: () =>
      AuthenticatedFeature_announcementAdminSystemBrandingRoute,
  } as any);
const AuthenticatedFeature_announcementAdminSystemBrandingLogosRoute =
  AuthenticatedFeature_announcementAdminSystemBrandingLogosRouteImport.update({
    id: "/logos",
    path: "/logos",
    getParentRoute: () =>
      AuthenticatedFeature_announcementAdminSystemBrandingRoute,
  } as any);
const AuthenticatedFeature_announcementAdminSystemBrandingThemeRoute =
  AuthenticatedFeature_announcementAdminSystemBrandingThemeRouteImport.update({
    id: "/theme",
    path: "/theme",
    getParentRoute: () =>
      AuthenticatedFeature_announcementAdminSystemBrandingRoute,
  } as any);
const AuthenticatedFeature_announcementAdminSystemIntegrationsIndexRoute =
  AuthenticatedFeature_announcementAdminSystemIntegrationsIndexRouteImport.update(
    {
      id: "/",
      path: "/",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemIntegrationsRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemIntegrationsMentorcliqRoute =
  AuthenticatedFeature_announcementAdminSystemIntegrationsMentorcliqRouteImport.update(
    {
      id: "/mentorcliq",
      path: "/mentorcliq",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemIntegrationsRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemIntegrationsOutlookRoute =
  AuthenticatedFeature_announcementAdminSystemIntegrationsOutlookRouteImport.update(
    {
      id: "/outlook",
      path: "/outlook",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemIntegrationsRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemIntegrationsSimpplrRoute =
  AuthenticatedFeature_announcementAdminSystemIntegrationsSimpplrRouteImport.update(
    {
      id: "/simpplr",
      path: "/simpplr",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemIntegrationsRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemIntegrationsSlackRoute =
  AuthenticatedFeature_announcementAdminSystemIntegrationsSlackRouteImport.update(
    {
      id: "/slack",
      path: "/slack",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemIntegrationsRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemIntegrationsTeamsRoute =
  AuthenticatedFeature_announcementAdminSystemIntegrationsTeamsRouteImport.update(
    {
      id: "/teams",
      path: "/teams",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemIntegrationsRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemIntegrationsUkgRoute =
  AuthenticatedFeature_announcementAdminSystemIntegrationsUkgRouteImport.update(
    {
      id: "/ukg",
      path: "/ukg",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemIntegrationsRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemIntegrationsVivaEngageRoute =
  AuthenticatedFeature_announcementAdminSystemIntegrationsVivaEngageRouteImport.update(
    {
      id: "/viva-engage",
      path: "/viva-engage",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemIntegrationsRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemRolesRole_configurationRoute =
  AuthenticatedFeature_announcementAdminSystemRolesRole_configurationRouteImport.update(
    {
      id: "/role_configuration",
      path: "/role_configuration",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemRolesRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemSettingsConfigurationRoute =
  AuthenticatedFeature_announcementAdminSystemSettingsConfigurationRouteImport.update(
    {
      id: "/_configuration",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemSettingsRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemSettingsCustom_textsRoute =
  AuthenticatedFeature_announcementAdminSystemSettingsCustom_textsRouteImport.update(
    {
      id: "/custom_texts",
      path: "/custom_texts",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemSettingsRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemSettingsFieldsRoute =
  AuthenticatedFeature_announcementAdminSystemSettingsFieldsRouteImport.update({
    id: "/fields",
    path: "/fields",
    getParentRoute: () =>
      AuthenticatedFeature_announcementAdminSystemSettingsRoute,
  } as any);
const AuthenticatedFeature_announcementAdminSystemSettingsSsoRoute =
  AuthenticatedFeature_announcementAdminSystemSettingsSsoRouteImport.update({
    id: "/sso",
    path: "/sso",
    getParentRoute: () =>
      AuthenticatedFeature_announcementAdminSystemSettingsRoute,
  } as any);
const AuthenticatedFeature_announcementAdminSystemUsersImportRoute =
  AuthenticatedFeature_announcementAdminSystemUsersImportRouteImport.update({
    id: "/import",
    path: "/import",
    getParentRoute: () =>
      AuthenticatedFeature_announcementAdminSystemUsersRoute,
  } as any);
const AuthenticatedFeature_announcementAdminSystemUsersListRoute =
  AuthenticatedFeature_announcementAdminSystemUsersListRouteImport.update({
    id: "/list",
    path: "/list",
    getParentRoute: () =>
      AuthenticatedFeature_announcementAdminSystemUsersRoute,
  } as any);
const AuthenticatedFeature_announcementAdminSystemUsersMergeRoute =
  AuthenticatedFeature_announcementAdminSystemUsersMergeRouteImport.update({
    id: "/merge",
    path: "/merge",
    getParentRoute: () =>
      AuthenticatedFeature_announcementAdminSystemUsersRoute,
  } as any);
const AuthenticatedFeature_announcementAdminSystemUsersNewRoute =
  AuthenticatedFeature_announcementAdminSystemUsersNewRouteImport.update({
    id: "/new",
    path: "/new",
    getParentRoute: () =>
      AuthenticatedFeature_announcementAdminSystemUsersRoute,
  } as any);
const AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingManageRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingManageRouteImport.update(
    {
      id: "/manage",
      path: "/manage",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingOverviewRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingOverviewRouteImport.update(
    {
      id: "/overview",
      path: "/overview",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRequestRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRequestRouteImport.update(
    {
      id: "/request",
      path: "/request",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdEventsIndexRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdEventsIndexRouteImport.update(
    {
      id: "/events/",
      path: "/events/",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdEventsPendingRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdEventsPendingRouteImport.update(
    {
      id: "/events/pending",
      path: "/events/pending",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdManageArchivesRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageArchivesRouteImport.update(
    {
      id: "/archives",
      path: "/archives",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunityLabReportRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunityLabReportRouteImport.update(
    {
      id: "/community-lab-report",
      path: "/community-lab-report",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdManageReview_settingsRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageReview_settingsRouteImport.update(
    {
      id: "/review_settings",
      path: "/review_settings",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdManageRole_configurationRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageRole_configurationRouteImport.update(
    {
      id: "/role_configuration",
      path: "/role_configuration",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsRouteImport.update(
    {
      id: "/settings",
      path: "/settings",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdMembersIndexRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdMembersIndexRouteImport.update(
    {
      id: "/",
      path: "/",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdMembersRouteRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRouteRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRouteRouteImport.update(
    {
      id: "/automations",
      path: "/automations",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdMembersRouteRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdMembersInvitationsRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdMembersInvitationsRouteImport.update(
    {
      id: "/invitations",
      path: "/invitations",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdMembersRouteRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRouteImport.update(
    {
      id: "/budgeting",
      path: "/budgeting",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdPlanEventsRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdPlanEventsRouteImport.update(
    {
      id: "/events",
      path: "/events",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdPostsIndexRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdPostsIndexRouteImport.update(
    {
      id: "/posts/",
      path: "/posts/",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdRoiSuiteSplatRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdRoiSuiteSplatRouteImport.update(
    {
      id: "/roi-suite/$",
      path: "/roi-suite/$",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdRoute,
    } as any,
  );
const AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdCohortsCohortIdRoute =
  AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdCohortsCohortIdRouteImport.update(
    {
      id: "/cohorts/$cohortId",
      path: "/cohorts/$cohortId",
      getParentRoute: () =>
        AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdRoute,
    } as any,
  );
const AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdIndexRoute =
  AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdIndexRouteImport.update(
    {
      id: "/",
      path: "/",
      getParentRoute: () =>
        AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdRoute,
    } as any,
  );
const AuthenticatedFeature_announcementUserProfileEditRecordHoursCommunityIdRoute =
  AuthenticatedFeature_announcementUserProfileEditRecordHoursCommunityIdRouteImport.update(
    {
      id: "/edit/record-hours/$communityId",
      path: "/edit/record-hours/$communityId",
      getParentRoute: () => AuthenticatedFeature_announcementUserProfileRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminGamificationAchievementsAchievementIdEditRoute =
  AuthenticatedFeature_announcementAdminGamificationAchievementsAchievementIdEditRouteImport.update(
    {
      id: "/gamification/achievements/$achievementId/edit",
      path: "/gamification/achievements/$achievementId/edit",
      getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminGamificationRewardsRewardIdEditRoute =
  AuthenticatedFeature_announcementAdminGamificationRewardsRewardIdEditRouteImport.update(
    {
      id: "/$rewardId/edit",
      path: "/$rewardId/edit",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminGamificationRewardsRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminManageCalendarCalendarIdUpdateRoute =
  AuthenticatedFeature_announcementAdminManageCalendarCalendarIdUpdateRouteImport.update(
    {
      id: "/manage/calendar/$calendarId/update",
      path: "/manage/calendar/$calendarId/update",
      getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdDistributionsRoute =
  AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdDistributionsRouteImport.update(
    {
      id: "/manage/communications/$communicationId/distributions",
      path: "/manage/communications/$communicationId/distributions",
      getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdEditRoute =
  AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdEditRouteImport.update(
    {
      id: "/manage/communications/$communicationId/edit",
      path: "/manage/communications/$communicationId/edit",
      getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdRecipientsRoute =
  AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdRecipientsRouteImport.update(
    {
      id: "/manage/communications/$communicationId/recipients",
      path: "/manage/communications/$communicationId/recipients",
      getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarIndexRoute =
  AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarIndexRouteImport.update(
    {
      id: "/notable_dates_calendar/",
      path: "/notable_dates_calendar/",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminManageEventsRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCreateRoute =
  AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCreateRouteImport.update(
    {
      id: "/notable_dates_calendar/create",
      path: "/notable_dates_calendar/create",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminManageEventsRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminManageGroupsGroupIdCategorizeRoute =
  AuthenticatedFeature_announcementAdminManageGroupsGroupIdCategorizeRouteImport.update(
    {
      id: "/manage/groups/$groupId/categorize",
      path: "/manage/groups/$groupId/categorize",
      getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminManageGroupsGroupIdEditRoute =
  AuthenticatedFeature_announcementAdminManageGroupsGroupIdEditRouteImport.update(
    {
      id: "/manage/groups/$groupId/edit",
      path: "/manage/groups/$groupId/edit",
      getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminManageGroupsCategoriesIndexRoute =
  AuthenticatedFeature_announcementAdminManageGroupsCategoriesIndexRouteImport.update(
    {
      id: "/manage/groups/categories/",
      path: "/manage/groups/categories/",
      getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminManageGroupsCategoriesNewRoute =
  AuthenticatedFeature_announcementAdminManageGroupsCategoriesNewRouteImport.update(
    {
      id: "/manage/groups/categories/new",
      path: "/manage/groups/categories/new",
      getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminManageSegmentsSegmentIdEditRoute =
  AuthenticatedFeature_announcementAdminManageSegmentsSegmentIdEditRouteImport.update(
    {
      id: "/manage/segments/$segmentId/edit",
      path: "/manage/segments/$segmentId/edit",
      getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminPlanBudgetingFiscal_periodsNewRoute =
  AuthenticatedFeature_announcementAdminPlanBudgetingFiscal_periodsNewRouteImport.update(
    {
      id: "/plan/budgeting/fiscal_periods/new",
      path: "/plan/budgeting/fiscal_periods/new",
      getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemBrandingSponsorsIndexRoute =
  AuthenticatedFeature_announcementAdminSystemBrandingSponsorsIndexRouteImport.update(
    {
      id: "/sponsors/",
      path: "/sponsors/",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemBrandingRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemBrandingSponsorsNewRoute =
  AuthenticatedFeature_announcementAdminSystemBrandingSponsorsNewRouteImport.update(
    {
      id: "/sponsors/new",
      path: "/sponsors/new",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemBrandingRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemRolesCommunityIndexRoute =
  AuthenticatedFeature_announcementAdminSystemRolesCommunityIndexRouteImport.update(
    {
      id: "/community/",
      path: "/community/",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemRolesRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemRolesPlatformIndexRoute =
  AuthenticatedFeature_announcementAdminSystemRolesPlatformIndexRouteImport.update(
    {
      id: "/platform/",
      path: "/platform/",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemRolesRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemSettingsConfigurationCommunitiesRoute =
  AuthenticatedFeature_announcementAdminSystemSettingsConfigurationCommunitiesRouteImport.update(
    {
      id: "/communities",
      path: "/communities",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemSettingsConfigurationRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemSettingsConfigurationConfigurationRoute =
  AuthenticatedFeature_announcementAdminSystemSettingsConfigurationConfigurationRouteImport.update(
    {
      id: "/configuration",
      path: "/configuration",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemSettingsConfigurationRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemSettingsConfigurationModulesRoute =
  AuthenticatedFeature_announcementAdminSystemSettingsConfigurationModulesRouteImport.update(
    {
      id: "/modules",
      path: "/modules",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemSettingsConfigurationRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemSettingsConfigurationProfile_fieldsRoute =
  AuthenticatedFeature_announcementAdminSystemSettingsConfigurationProfile_fieldsRouteImport.update(
    {
      id: "/profile_fields",
      path: "/profile_fields",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemSettingsConfigurationRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemSettingsEmailsIndexRoute =
  AuthenticatedFeature_announcementAdminSystemSettingsEmailsIndexRouteImport.update(
    {
      id: "/emails/",
      path: "/emails/",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemSettingsRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsIndexRoute =
  AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsIndexRouteImport.update(
    {
      id: "/policy_documents/",
      path: "/policy_documents/",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemSettingsRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsNewRoute =
  AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsNewRouteImport.update(
    {
      id: "/policy_documents/new",
      path: "/policy_documents/new",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemSettingsRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemUsersUserIdIndexRoute =
  AuthenticatedFeature_announcementAdminSystemUsersUserIdIndexRouteImport.update(
    {
      id: "/$userId/",
      path: "/$userId/",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemUsersRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemUsersUserIdEditRoute =
  AuthenticatedFeature_announcementAdminSystemUsersUserIdEditRouteImport.update(
    {
      id: "/$userId/edit",
      path: "/$userId/edit",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemUsersRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemUsersUserIdRole_assignmentsRoute =
  AuthenticatedFeature_announcementAdminSystemUsersUserIdRole_assignmentsRouteImport.update(
    {
      id: "/$userId/role_assignments",
      path: "/$userId/role_assignments",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemUsersRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemUsersUserIdStatisticsRoute =
  AuthenticatedFeature_announcementAdminSystemUsersUserIdStatisticsRouteImport.update(
    {
      id: "/$userId/statistics",
      path: "/$userId/statistics",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemUsersRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemUsersPolicy_templatesIndexRoute =
  AuthenticatedFeature_announcementAdminSystemUsersPolicy_templatesIndexRouteImport.update(
    {
      id: "/policy_templates/",
      path: "/policy_templates/",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemUsersRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemUsersRolesIndexRoute =
  AuthenticatedFeature_announcementAdminSystemUsersRolesIndexRouteImport.update(
    {
      id: "/roles/",
      path: "/roles/",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemUsersRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemUsersRolesNewRoute =
  AuthenticatedFeature_announcementAdminSystemUsersRolesNewRouteImport.update({
    id: "/roles/new",
    path: "/roles/new",
    getParentRoute: () =>
      AuthenticatedFeature_announcementAdminSystemUsersRoute,
  } as any);
const AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdIndexRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdIndexRouteImport.update(
    {
      id: "/events/$eventId/",
      path: "/events/$eventId/",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdEditRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdEditRouteImport.update(
    {
      id: "/events/$eventId/edit",
      path: "/events/$eventId/edit",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsIndexRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsIndexRouteImport.update(
    {
      id: "/communications/",
      path: "/communications/",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsNewRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsNewRouteImport.update(
    {
      id: "/communications/new",
      path: "/communications/new",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdManageEventsPendingRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageEventsPendingRouteImport.update(
    {
      id: "/events/pending",
      path: "/events/pending",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersIndexRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersIndexRouteImport.update(
    {
      id: "/leaders/",
      path: "/leaders/",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersNewRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersNewRouteImport.update(
    {
      id: "/leaders/new",
      path: "/leaders/new",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsIndexRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsIndexRouteImport.update(
    {
      id: "/",
      path: "/",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsIntegrationRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsIntegrationRouteImport.update(
    {
      id: "/integration",
      path: "/integration",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsWelcome_messageRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsWelcome_messageRouteImport.update(
    {
      id: "/welcome_message",
      path: "/welcome_message",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsIndexRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsIndexRouteImport.update(
    {
      id: "/sponsors/",
      path: "/sponsors/",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsNewRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsNewRouteImport.update(
    {
      id: "/sponsors/new",
      path: "/sponsors/new",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysIndexRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysIndexRouteImport.update(
    {
      id: "/surveys/",
      path: "/surveys/",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysNewRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysNewRouteImport.update(
    {
      id: "/surveys/new",
      path: "/surveys/new",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsIndexRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsIndexRouteImport.update(
    {
      id: "/",
      path: "/",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRouteRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsNewRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsNewRouteImport.update(
    {
      id: "/new",
      path: "/new",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRouteRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingManageRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingManageRouteImport.update(
    {
      id: "/manage",
      path: "/manage",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingOverviewRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingOverviewRouteImport.update(
    {
      id: "/overview",
      path: "/overview",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRequestRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRequestRouteImport.update(
    {
      id: "/request",
      path: "/request",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesIndexRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesIndexRouteImport.update(
    {
      id: "/outcomes/",
      path: "/outcomes/",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesNewRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesNewRouteImport.update(
    {
      id: "/outcomes/new",
      path: "/outcomes/new",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsIndexRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsIndexRouteImport.update(
    {
      id: "/pillars/",
      path: "/pillars/",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsNewRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsNewRouteImport.update(
    {
      id: "/pillars/new",
      path: "/pillars/new",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdPostsPostIdIndexRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdPostsPostIdIndexRouteImport.update(
    {
      id: "/posts/$postId/",
      path: "/posts/$postId/",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdPostsPostIdEditRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdPostsPostIdEditRouteImport.update(
    {
      id: "/posts/$postId/edit",
      path: "/posts/$postId/edit",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdRoute,
    } as any,
  );
const AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdCohortsCohortIdRoute =
  AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdCohortsCohortIdRouteImport.update(
    {
      id: "/cohorts/$cohortId",
      path: "/cohorts/$cohortId",
      getParentRoute: () =>
        AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminManageCalendarCalendarIdNotable_datesCreateRoute =
  AuthenticatedFeature_announcementAdminManageCalendarCalendarIdNotable_datesCreateRouteImport.update(
    {
      id: "/manage/calendar/$calendarId/notable_dates/create",
      path: "/manage/calendar/$calendarId/notable_dates/create",
      getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdUpdateRoute =
  AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdUpdateRouteImport.update(
    {
      id: "/notable_dates_calendar/$calendarId/update",
      path: "/notable_dates_calendar/$calendarId/update",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminManageEventsRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsIndexRoute =
  AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsIndexRouteImport.update(
    {
      id: "/manage/groups/$groupId/regions/",
      path: "/manage/groups/$groupId/regions/",
      getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsNewRoute =
  AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsNewRouteImport.update(
    {
      id: "/manage/groups/$groupId/regions/new",
      path: "/manage/groups/$groupId/regions/new",
      getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminManageGroupsCategoriesCategoryIdEditRoute =
  AuthenticatedFeature_announcementAdminManageGroupsCategoriesCategoryIdEditRouteImport.update(
    {
      id: "/manage/groups/categories/$categoryId/edit",
      path: "/manage/groups/categories/$categoryId/edit",
      getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemBrandingSponsorsSponsorIdEditRoute =
  AuthenticatedFeature_announcementAdminSystemBrandingSponsorsSponsorIdEditRouteImport.update(
    {
      id: "/sponsors/$sponsorId/edit",
      path: "/sponsors/$sponsorId/edit",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemBrandingRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemRolesCommunityRoleIdIndexRoute =
  AuthenticatedFeature_announcementAdminSystemRolesCommunityRoleIdIndexRouteImport.update(
    {
      id: "/community/$roleId/",
      path: "/community/$roleId/",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemRolesRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemRolesCommunityRoleIdPermissionsRoute =
  AuthenticatedFeature_announcementAdminSystemRolesCommunityRoleIdPermissionsRouteImport.update(
    {
      id: "/community/$roleId/permissions",
      path: "/community/$roleId/permissions",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemRolesRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemRolesPlatformRoleIdIndexRoute =
  AuthenticatedFeature_announcementAdminSystemRolesPlatformRoleIdIndexRouteImport.update(
    {
      id: "/platform/$roleId/",
      path: "/platform/$roleId/",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemRolesRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemRolesPlatformRoleIdPermissionsRoute =
  AuthenticatedFeature_announcementAdminSystemRolesPlatformRoleIdPermissionsRouteImport.update(
    {
      id: "/platform/$roleId/permissions",
      path: "/platform/$roleId/permissions",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemRolesRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemSettingsEmailsEmailIdEditRoute =
  AuthenticatedFeature_announcementAdminSystemSettingsEmailsEmailIdEditRouteImport.update(
    {
      id: "/emails/$emailId/edit",
      path: "/emails/$emailId/edit",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemSettingsRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsEditPolicyDocumentIdRoute =
  AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsEditPolicyDocumentIdRouteImport.update(
    {
      id: "/policy_documents/edit/$policyDocumentId",
      path: "/policy_documents/edit/$policyDocumentId",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemSettingsRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemUsersUserIdEditFieldsRoute =
  AuthenticatedFeature_announcementAdminSystemUsersUserIdEditFieldsRouteImport.update(
    {
      id: "/fields",
      path: "/fields",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemUsersUserIdEditRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemUsersUserIdEditGeneralRoute =
  AuthenticatedFeature_announcementAdminSystemUsersUserIdEditGeneralRouteImport.update(
    {
      id: "/general",
      path: "/general",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemUsersUserIdEditRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemUsersPolicy_templatesPolicyIdEditRoute =
  AuthenticatedFeature_announcementAdminSystemUsersPolicy_templatesPolicyIdEditRouteImport.update(
    {
      id: "/policy_templates/$policyId/edit",
      path: "/policy_templates/$policyId/edit",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemUsersRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminSystemUsersRolesRoleIdEditRoute =
  AuthenticatedFeature_announcementAdminSystemUsersRolesRoleIdEditRouteImport.update(
    {
      id: "/roles/$roleId/edit",
      path: "/roles/$roleId/edit",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminSystemUsersRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageAttendeesRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageAttendeesRouteImport.update(
    {
      id: "/events/$eventId/manage/attendees",
      path: "/events/$eventId/manage/attendees",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageBudgetingRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageBudgetingRouteImport.update(
    {
      id: "/events/$eventId/manage/budgeting",
      path: "/events/$eventId/manage/budgeting",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageWaitlistRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageWaitlistRouteImport.update(
    {
      id: "/events/$eventId/manage/waitlist",
      path: "/events/$eventId/manage/waitlist",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdDistributionsRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdDistributionsRouteImport.update(
    {
      id: "/communications/$communicationId/distributions",
      path: "/communications/$communicationId/distributions",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdEditRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdEditRouteImport.update(
    {
      id: "/communications/$communicationId/edit",
      path: "/communications/$communicationId/edit",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdRecipientsRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdRecipientsRouteImport.update(
    {
      id: "/communications/$communicationId/recipients",
      path: "/communications/$communicationId/recipients",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersLeaderIdEditRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersLeaderIdEditRouteImport.update(
    {
      id: "/leaders/$leaderId/edit",
      path: "/leaders/$leaderId/edit",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsSponsorIdEditRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsSponsorIdEditRouteImport.update(
    {
      id: "/sponsors/$sponsorId/edit",
      path: "/sponsors/$sponsorId/edit",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysSurveyIdEditRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysSurveyIdEditRouteImport.update(
    {
      id: "/surveys/$surveyId/edit",
      path: "/surveys/$surveyId/edit",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysSurveyIdResponsesRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysSurveyIdResponsesRouteImport.update(
    {
      id: "/surveys/$surveyId/responses",
      path: "/surveys/$surveyId/responses",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRuleIdEditRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRuleIdEditRouteImport.update(
    {
      id: "/$ruleId/edit",
      path: "/$ruleId/edit",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRouteRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsHistoryIndexRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsHistoryIndexRouteImport.update(
    {
      id: "/history/",
      path: "/history/",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRouteRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsHistoryRunIdRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsHistoryRunIdRouteImport.update(
    {
      id: "/history/$runId",
      path: "/history/$runId",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRouteRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesOutcomeIdEditRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesOutcomeIdEditRouteImport.update(
    {
      id: "/outcomes/$outcomeId/edit",
      path: "/outcomes/$outcomeId/edit",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsPillarIdEditRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsPillarIdEditRouteImport.update(
    {
      id: "/pillars/$pillarId/edit",
      path: "/pillars/$pillarId/edit",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRoute,
    } as any,
  );
const AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsPillarIdEventsRoute =
  AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsPillarIdEventsRouteImport.update(
    {
      id: "/pillars/$pillarId/events",
      path: "/pillars/$pillarId/events",
      getParentRoute: () =>
        AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminManageCalendarCalendarIdNotable_datesEventIdUpdateRoute =
  AuthenticatedFeature_announcementAdminManageCalendarCalendarIdNotable_datesEventIdUpdateRouteImport.update(
    {
      id: "/manage/calendar/$calendarId/notable_dates/$eventId/update",
      path: "/manage/calendar/$calendarId/notable_dates/$eventId/update",
      getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdNotable_datesCreateRoute =
  AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdNotable_datesCreateRouteImport.update(
    {
      id: "/notable_dates_calendar/$calendarId/notable_dates/create",
      path: "/notable_dates_calendar/$calendarId/notable_dates/create",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminManageEventsRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsRegionIdEditRoute =
  AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsRegionIdEditRouteImport.update(
    {
      id: "/manage/groups/$groupId/regions/$regionId/edit",
      path: "/manage/groups/$groupId/regions/$regionId/edit",
      getParentRoute: () => AuthenticatedFeature_announcementAdminRoute,
    } as any,
  );
const AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdNotable_datesEventIdUpdateRoute =
  AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdNotable_datesEventIdUpdateRouteImport.update(
    {
      id: "/notable_dates_calendar/$calendarId/notable_dates/$eventId/update",
      path: "/notable_dates_calendar/$calendarId/notable_dates/$eventId/update",
      getParentRoute: () =>
        AuthenticatedFeature_announcementAdminManageEventsRoute,
    } as any,
  );

export interface FileRoutesByFullPath {
  "/": typeof AuthenticatedFeature_announcementUserIndexRoute;
  "/auto-login": typeof AutoLoginRoute;
  "/enrollment": typeof EnrollmentRouteWithChildren;
  "/onboarding": typeof compatibilityOnboardingRoute;
  "/sign_up": typeof compatibilitySign_upRoute;
  "/mobile_sign_in": typeof AnonymousMobile_sign_inRoute;
  "/unsubscribe": typeof AnonymousUnsubscribeRoute;
  "/forgot": typeof SessionForgotRoute;
  "/enrollment/complete": typeof EnrollmentCompleteRoute;
  "/enrollment/discover": typeof EnrollmentDiscoverRoute;
  "/enrollment/profile": typeof EnrollmentProfileRoute;
  "/enrollment/": typeof EnrollmentIndexRoute;
  "/event_checkin/$eventId": typeof AnonymousEvent_checkinEventIdRoute;
  "/verify/$token": typeof AnonymousVerifyTokenRoute;
  "/admin": typeof AuthenticatedFeature_announcementAdminRouteWithChildren;
  "/login/activate": typeof SessionLoginActivateRoute;
  "/login/admin": typeof SessionLoginAdminRoute;
  "/login/credentials": typeof SessionLoginCredentialsRoute;
  "/password_reset/$token": typeof SessionPassword_resetTokenRoute;
  "/cms/": typeof CmsCmsIndexRoute;
  "/login/": typeof SessionLoginIndexRoute;
  "/password_reset/": typeof SessionPassword_resetIndexRoute;
  "/communities": typeof AuthenticatedFeature_announcementUserCommunitiesRoute;
  "/downloads": typeof AuthenticatedFeature_announcementUserDownloadsRoute;
  "/groups": typeof AuthenticatedFeature_announcementUserGroupsRoute;
  "/notifications": typeof AuthenticatedFeature_announcementUserNotificationsRoute;
  "/profile": typeof AuthenticatedFeature_announcementUserProfileRouteWithChildren;
  "/rewards": typeof AuthenticatedFeature_announcementUserRewardsRoute;
  "/support": typeof AuthenticatedFeature_announcementUserSupportRoute;
  "/admin/support-config": typeof AuthenticatedFeature_announcementAdminSupportConfigRoute;
  "/admin/system": typeof AuthenticatedFeature_announcementAdminSystemRouteWithChildren;
  "/communities/$communityId": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdRouteWithChildren;
  "/open_invitations/$openInvitationId": typeof AuthenticatedFeature_announcementOpen_invitationsOpenInvitationIdRoute;
  "/cms/review/comment_moderation": typeof CmsCmsReviewComment_moderationRoute;
  "/cms/tools/review_settings": typeof CmsCmsToolsReview_settingsRoute;
  "/communities/$communityId/members": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersRouteRouteWithChildren;
  "/community-lab/$": typeof AuthenticatedFeature_announcementUserCommunityLabSplatRoute;
  "/community-lab/session": typeof AuthenticatedFeature_announcementUserCommunityLabSessionRoute;
  "/community-lab/worksheet": typeof AuthenticatedFeature_announcementUserCommunityLabWorksheetRoute;
  "/global-survey-response/$surveyId": typeof AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdRouteWithChildren;
  "/profile/statistics": typeof AuthenticatedFeature_announcementUserProfileStatisticsRoute;
  "/admin/analyze/community-lab-report": typeof AuthenticatedFeature_announcementAdminAnalyzeCommunityLabReportRoute;
  "/admin/analyze/groups": typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsRouteWithChildren;
  "/admin/analyze/reports": typeof AuthenticatedFeature_announcementAdminAnalyzeReportsRoute;
  "/admin/analyze/segments": typeof AuthenticatedFeature_announcementAdminAnalyzeSegmentsRoute;
  "/admin/analyze/users": typeof AuthenticatedFeature_announcementAdminAnalyzeUsersRouteWithChildren;
  "/admin/gamification/rewards": typeof AuthenticatedFeature_announcementAdminGamificationRewardsRouteWithChildren;
  "/admin/manage/archived": typeof AuthenticatedFeature_announcementAdminManageArchivedRoute;
  "/admin/manage/events": typeof AuthenticatedFeature_announcementAdminManageEventsRouteWithChildren;
  "/admin/manage/folders": typeof AuthenticatedFeature_announcementAdminManageFoldersRoute;
  "/admin/manage/labels": typeof AuthenticatedFeature_announcementAdminManageLabelsRoute;
  "/admin/manage/leaders": typeof AuthenticatedFeature_announcementAdminManageLeadersRoute;
  "/admin/manage/tags": typeof AuthenticatedFeature_announcementAdminManageTagsRoute;
  "/admin/plan/aggregate_budgeting": typeof AuthenticatedFeature_announcementAdminPlanAggregate_budgetingRoute;
  "/admin/surveys/new": typeof AuthenticatedFeature_announcementAdminSurveysNewRoute;
  "/admin/system/api_access_tokens": typeof AuthenticatedFeature_announcementAdminSystemApi_access_tokensRoute;
  "/admin/system/branding": typeof AuthenticatedFeature_announcementAdminSystemBrandingRouteWithChildren;
  "/admin/system/integrations": typeof AuthenticatedFeature_announcementAdminSystemIntegrationsRouteWithChildren;
  "/admin/system/logs": typeof AuthenticatedFeature_announcementAdminSystemLogsRoute;
  "/admin/system/mcp_connector": typeof AuthenticatedFeature_announcementAdminSystemMcp_connectorRoute;
  "/admin/system/roles": typeof AuthenticatedFeature_announcementAdminSystemRolesRouteWithChildren;
  "/admin/system/settings": typeof AuthenticatedFeature_announcementAdminSystemSettingsRouteWithChildren;
  "/admin/system/users": typeof AuthenticatedFeature_announcementAdminSystemUsersRouteWithChildren;
  "/communities/$communityId/budgeting": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRouteWithChildren;
  "/communities/$communityId/chapters": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdChaptersRoute;
  "/communities/$communityId/folders": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdFoldersRoute;
  "/communities/$communityId/manage": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRouteWithChildren;
  "/communities/$communityId/plan": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRouteWithChildren;
  "/groups/$groupId/$": typeof AuthenticatedFeature_announcementGroupsGroupIdSplatRoute;
  "/invitations/$invitationId/accept": typeof AuthenticatedFeature_announcementInvitationsInvitationIdAcceptRoute;
  "/invitations/$invitationId/decline": typeof AuthenticatedFeature_announcementInvitationsInvitationIdDeclineRoute;
  "/regions/$regionId/$": typeof AuthenticatedFeature_announcementRegionsRegionIdSplatRoute;
  "/cms/manage/communications/$draftId": typeof CmsCmsManageCommunicationsDraftIdRoute;
  "/cms/manage/events/$draftId": typeof CmsCmsManageEventsDraftIdRoute;
  "/cms/manage/events/new": typeof CmsCmsManageEventsNewRoute;
  "/cms/manage/posts/$draftId": typeof CmsCmsManagePostsDraftIdRoute;
  "/cms/manage/publication_requests/$publicationRequestId": typeof CmsCmsManagePublication_requestsPublicationRequestIdRoute;
  "/cms/review/publication_requests/$publicationRequestId": typeof CmsCmsReviewPublication_requestsPublicationRequestIdRoute;
  "/community-lab/": typeof AuthenticatedFeature_announcementUserCommunityLabIndexRoute;
  "/events/": typeof AuthenticatedFeature_announcementUserEventsIndexRoute;
  "/posts/": typeof AuthenticatedFeature_announcementUserPostsIndexRoute;
  "/profile/": typeof AuthenticatedFeature_announcementUserProfileIndexRoute;
  "/admin/analyze/": typeof AuthenticatedFeature_announcementAdminAnalyzeIndexRoute;
  "/admin/context-backfill/": typeof AuthenticatedFeature_announcementAdminContextBackfillIndexRoute;
  "/admin/surveys/": typeof AuthenticatedFeature_announcementAdminSurveysIndexRoute;
  "/communities/$communityId/": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdIndexRoute;
  "/cms/manage/communications/": typeof CmsCmsManageCommunicationsIndexRoute;
  "/cms/manage/events/": typeof CmsCmsManageEventsIndexRoute;
  "/cms/manage/posts/": typeof CmsCmsManagePostsIndexRoute;
  "/cms/manage/publication_requests/": typeof CmsCmsManagePublication_requestsIndexRoute;
  "/cms/review/publication_requests/": typeof CmsCmsReviewPublication_requestsIndexRoute;
  "/communities/$communityId/members/automations": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRouteRouteWithChildren;
  "/enterprises/$enterpriseId/folders/$folderId/resources": typeof compatibilityEnterprisesEnterpriseIdFoldersFolderIdResourcesRoute;
  "/groups/$groupId/folders/$folderId/resources": typeof compatibilityGroupsGroupIdFoldersFolderIdResourcesRoute;
  "/groups/$groupId/news/$type/$postId": typeof compatibilityGroupsGroupIdNewsTypePostIdRoute;
  "/regions/$regionId/news/$type/$postId": typeof compatibilityRegionsRegionIdNewsTypePostIdRoute;
  "/events/$eventId/$": typeof AuthenticatedFeature_announcementUserEventsEventIdSplatRoute;
  "/events/drafts/$draftId": typeof AuthenticatedFeature_announcementUserEventsDraftsDraftIdRoute;
  "/events/drafts/new": typeof AuthenticatedFeature_announcementUserEventsDraftsNewRoute;
  "/network-survey-response/$networkId/$surveyId": typeof AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdRouteWithChildren;
  "/posts/$postId/$": typeof AuthenticatedFeature_announcementUserPostsPostIdSplatRoute;
  "/posts/drafts/$draftId": typeof AuthenticatedFeature_announcementUserPostsDraftsDraftIdRoute;
  "/profile/edit/accessibility": typeof AuthenticatedFeature_announcementUserProfileEditAccessibilityRoute;
  "/profile/edit/engagement-report": typeof AuthenticatedFeature_announcementUserProfileEditEngagementReportRoute;
  "/profile/edit/general": typeof AuthenticatedFeature_announcementUserProfileEditGeneralRoute;
  "/profile/edit/leadership": typeof AuthenticatedFeature_announcementUserProfileEditLeadershipRoute;
  "/profile/edit/notification": typeof AuthenticatedFeature_announcementUserProfileEditNotificationRoute;
  "/profile/edit/outlook": typeof AuthenticatedFeature_announcementUserProfileEditOutlookRoute;
  "/profile/edit/private": typeof AuthenticatedFeature_announcementUserProfileEditPrivateRoute;
  "/user/$userId/achievements": typeof AuthenticatedFeature_announcementUserUserUserIdAchievementsRoute;
  "/user/$userId/edit": typeof AuthenticatedFeature_announcementUserUserUserIdEditRoute;
  "/user/$userId/statistics": typeof AuthenticatedFeature_announcementUserUserUserIdStatisticsRoute;
  "/user/$userId/transactions": typeof AuthenticatedFeature_announcementUserUserUserIdTransactionsRoute;
  "/admin/analyze/dashboards/$": typeof AuthenticatedFeature_announcementAdminAnalyzeDashboardsSplatRoute;
  "/admin/analyze/groups/events": typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsEventsRoute;
  "/admin/analyze/groups/posts": typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsPostsRoute;
  "/admin/analyze/groups/resources": typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsResourcesRoute;
  "/admin/analyze/groups/users": typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsUsersRoute;
  "/admin/analyze/roi-suite/$": typeof AuthenticatedFeature_announcementAdminAnalyzeRoiSuiteSplatRoute;
  "/admin/analyze/users/events": typeof AuthenticatedFeature_announcementAdminAnalyzeUsersEventsRoute;
  "/admin/gamification/achievements/new": typeof AuthenticatedFeature_announcementAdminGamificationAchievementsNewRoute;
  "/admin/gamification/points/manage": typeof AuthenticatedFeature_announcementAdminGamificationPointsManageRoute;
  "/admin/gamification/rewards/new": typeof AuthenticatedFeature_announcementAdminGamificationRewardsNewRoute;
  "/admin/gamification/rewards/pending": typeof AuthenticatedFeature_announcementAdminGamificationRewardsPendingRoute;
  "/admin/manage/calendar/create": typeof AuthenticatedFeature_announcementAdminManageCalendarCreateRoute;
  "/admin/manage/communications/new": typeof AuthenticatedFeature_announcementAdminManageCommunicationsNewRoute;
  "/admin/manage/events/calendar": typeof AuthenticatedFeature_announcementAdminManageEventsCalendarRoute;
  "/admin/manage/events/configuration": typeof AuthenticatedFeature_announcementAdminManageEventsConfigurationRoute;
  "/admin/manage/events/questionnaire": typeof AuthenticatedFeature_announcementAdminManageEventsQuestionnaireRoute;
  "/admin/manage/groups/connections": typeof AuthenticatedFeature_announcementAdminManageGroupsConnectionsRoute;
  "/admin/manage/groups/leader_positions": typeof AuthenticatedFeature_announcementAdminManageGroupsLeader_positionsRoute;
  "/admin/manage/groups/new": typeof AuthenticatedFeature_announcementAdminManageGroupsNewRoute;
  "/admin/manage/segments/new": typeof AuthenticatedFeature_announcementAdminManageSegmentsNewRoute;
  "/admin/surveys/$surveyId/edit": typeof AuthenticatedFeature_announcementAdminSurveysSurveyIdEditRoute;
  "/admin/surveys/$surveyId/responses": typeof AuthenticatedFeature_announcementAdminSurveysSurveyIdResponsesRoute;
  "/admin/system/branding/colors": typeof AuthenticatedFeature_announcementAdminSystemBrandingColorsRoute;
  "/admin/system/branding/home": typeof AuthenticatedFeature_announcementAdminSystemBrandingHomeRoute;
  "/admin/system/branding/logos": typeof AuthenticatedFeature_announcementAdminSystemBrandingLogosRoute;
  "/admin/system/branding/theme": typeof AuthenticatedFeature_announcementAdminSystemBrandingThemeRoute;
  "/admin/system/integrations/mentorcliq": typeof AuthenticatedFeature_announcementAdminSystemIntegrationsMentorcliqRoute;
  "/admin/system/integrations/outlook": typeof AuthenticatedFeature_announcementAdminSystemIntegrationsOutlookRoute;
  "/admin/system/integrations/simpplr": typeof AuthenticatedFeature_announcementAdminSystemIntegrationsSimpplrRoute;
  "/admin/system/integrations/slack": typeof AuthenticatedFeature_announcementAdminSystemIntegrationsSlackRoute;
  "/admin/system/integrations/teams": typeof AuthenticatedFeature_announcementAdminSystemIntegrationsTeamsRoute;
  "/admin/system/integrations/ukg": typeof AuthenticatedFeature_announcementAdminSystemIntegrationsUkgRoute;
  "/admin/system/integrations/viva-engage": typeof AuthenticatedFeature_announcementAdminSystemIntegrationsVivaEngageRoute;
  "/admin/system/roles/role_configuration": typeof AuthenticatedFeature_announcementAdminSystemRolesRole_configurationRoute;
  "/admin/system/settings/custom_texts": typeof AuthenticatedFeature_announcementAdminSystemSettingsCustom_textsRoute;
  "/admin/system/settings/fields": typeof AuthenticatedFeature_announcementAdminSystemSettingsFieldsRoute;
  "/admin/system/settings/sso": typeof AuthenticatedFeature_announcementAdminSystemSettingsSsoRoute;
  "/admin/system/users/import": typeof AuthenticatedFeature_announcementAdminSystemUsersImportRoute;
  "/admin/system/users/list": typeof AuthenticatedFeature_announcementAdminSystemUsersListRoute;
  "/admin/system/users/merge": typeof AuthenticatedFeature_announcementAdminSystemUsersMergeRoute;
  "/admin/system/users/new": typeof AuthenticatedFeature_announcementAdminSystemUsersNewRoute;
  "/communities/$communityId/budgeting/manage": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingManageRoute;
  "/communities/$communityId/budgeting/overview": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingOverviewRoute;
  "/communities/$communityId/budgeting/request": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRequestRoute;
  "/communities/$communityId/events/pending": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsPendingRoute;
  "/communities/$communityId/manage/archives": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageArchivesRoute;
  "/communities/$communityId/manage/community-lab-report": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunityLabReportRoute;
  "/communities/$communityId/manage/review_settings": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageReview_settingsRoute;
  "/communities/$communityId/manage/role_configuration": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRole_configurationRoute;
  "/communities/$communityId/manage/settings": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsRouteWithChildren;
  "/communities/$communityId/members/invitations": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersInvitationsRoute;
  "/communities/$communityId/plan/budgeting": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRouteWithChildren;
  "/communities/$communityId/plan/events": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanEventsRoute;
  "/communities/$communityId/roi-suite/$": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdRoiSuiteSplatRoute;
  "/events/drafts/": typeof AuthenticatedFeature_announcementUserEventsDraftsIndexRoute;
  "/global-survey-response/$surveyId/": typeof AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdIndexRoute;
  "/posts/drafts/": typeof AuthenticatedFeature_announcementUserPostsDraftsIndexRoute;
  "/user/$userId/": typeof AuthenticatedFeature_announcementUserUserUserIdIndexRoute;
  "/admin/analyze/groups/": typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsIndexRoute;
  "/admin/analyze/users/": typeof AuthenticatedFeature_announcementAdminAnalyzeUsersIndexRoute;
  "/admin/gamification/achievements/": typeof AuthenticatedFeature_announcementAdminGamificationAchievementsIndexRoute;
  "/admin/gamification/rewards/": typeof AuthenticatedFeature_announcementAdminGamificationRewardsIndexRoute;
  "/admin/manage/calendar/": typeof AuthenticatedFeature_announcementAdminManageCalendarIndexRoute;
  "/admin/manage/communications/": typeof AuthenticatedFeature_announcementAdminManageCommunicationsIndexRoute;
  "/admin/manage/groups/": typeof AuthenticatedFeature_announcementAdminManageGroupsIndexRoute;
  "/admin/manage/segments/": typeof AuthenticatedFeature_announcementAdminManageSegmentsIndexRoute;
  "/admin/plan/budgeting/": typeof AuthenticatedFeature_announcementAdminPlanBudgetingIndexRoute;
  "/admin/system/integrations/": typeof AuthenticatedFeature_announcementAdminSystemIntegrationsIndexRoute;
  "/communities/$communityId/events/": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsIndexRoute;
  "/communities/$communityId/members/": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersIndexRoute;
  "/communities/$communityId/posts/": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPostsIndexRoute;
  "/global-survey-response/$surveyId/cohorts/$cohortId": typeof AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdCohortsCohortIdRoute;
  "/profile/edit/record-hours/$communityId": typeof AuthenticatedFeature_announcementUserProfileEditRecordHoursCommunityIdRoute;
  "/admin/gamification/achievements/$achievementId/edit": typeof AuthenticatedFeature_announcementAdminGamificationAchievementsAchievementIdEditRoute;
  "/admin/gamification/rewards/$rewardId/edit": typeof AuthenticatedFeature_announcementAdminGamificationRewardsRewardIdEditRoute;
  "/admin/manage/calendar/$calendarId/update": typeof AuthenticatedFeature_announcementAdminManageCalendarCalendarIdUpdateRoute;
  "/admin/manage/communications/$communicationId/distributions": typeof AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdDistributionsRoute;
  "/admin/manage/communications/$communicationId/edit": typeof AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdEditRoute;
  "/admin/manage/communications/$communicationId/recipients": typeof AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdRecipientsRoute;
  "/admin/manage/events/notable_dates_calendar/create": typeof AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCreateRoute;
  "/admin/manage/groups/$groupId/categorize": typeof AuthenticatedFeature_announcementAdminManageGroupsGroupIdCategorizeRoute;
  "/admin/manage/groups/$groupId/edit": typeof AuthenticatedFeature_announcementAdminManageGroupsGroupIdEditRoute;
  "/admin/manage/groups/categories/new": typeof AuthenticatedFeature_announcementAdminManageGroupsCategoriesNewRoute;
  "/admin/manage/segments/$segmentId/edit": typeof AuthenticatedFeature_announcementAdminManageSegmentsSegmentIdEditRoute;
  "/admin/plan/budgeting/fiscal_periods/new": typeof AuthenticatedFeature_announcementAdminPlanBudgetingFiscal_periodsNewRoute;
  "/admin/system/branding/sponsors/new": typeof AuthenticatedFeature_announcementAdminSystemBrandingSponsorsNewRoute;
  "/admin/system/settings/communities": typeof AuthenticatedFeature_announcementAdminSystemSettingsConfigurationCommunitiesRoute;
  "/admin/system/settings/configuration": typeof AuthenticatedFeature_announcementAdminSystemSettingsConfigurationConfigurationRoute;
  "/admin/system/settings/modules": typeof AuthenticatedFeature_announcementAdminSystemSettingsConfigurationModulesRoute;
  "/admin/system/settings/profile_fields": typeof AuthenticatedFeature_announcementAdminSystemSettingsConfigurationProfile_fieldsRoute;
  "/admin/system/settings/policy_documents/new": typeof AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsNewRoute;
  "/admin/system/users/$userId/edit": typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdEditRouteWithChildren;
  "/admin/system/users/$userId/role_assignments": typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdRole_assignmentsRoute;
  "/admin/system/users/$userId/statistics": typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdStatisticsRoute;
  "/admin/system/users/roles/new": typeof AuthenticatedFeature_announcementAdminSystemUsersRolesNewRoute;
  "/communities/$communityId/events/$eventId/edit": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdEditRoute;
  "/communities/$communityId/manage/communications/new": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsNewRoute;
  "/communities/$communityId/manage/events/pending": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageEventsPendingRoute;
  "/communities/$communityId/manage/leaders/new": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersNewRoute;
  "/communities/$communityId/manage/settings/integration": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsIntegrationRoute;
  "/communities/$communityId/manage/settings/welcome_message": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsWelcome_messageRoute;
  "/communities/$communityId/manage/sponsors/new": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsNewRoute;
  "/communities/$communityId/manage/surveys/new": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysNewRoute;
  "/communities/$communityId/members/automations/new": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsNewRoute;
  "/communities/$communityId/plan/budgeting/manage": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingManageRoute;
  "/communities/$communityId/plan/budgeting/overview": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingOverviewRoute;
  "/communities/$communityId/plan/budgeting/request": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRequestRoute;
  "/communities/$communityId/plan/outcomes/new": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesNewRoute;
  "/communities/$communityId/plan/pillars/new": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsNewRoute;
  "/communities/$communityId/posts/$postId/edit": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPostsPostIdEditRoute;
  "/network-survey-response/$networkId/$surveyId/": typeof AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdIndexRoute;
  "/admin/manage/events/notable_dates_calendar/": typeof AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarIndexRoute;
  "/admin/manage/groups/categories/": typeof AuthenticatedFeature_announcementAdminManageGroupsCategoriesIndexRoute;
  "/admin/system/branding/sponsors/": typeof AuthenticatedFeature_announcementAdminSystemBrandingSponsorsIndexRoute;
  "/admin/system/roles/community/": typeof AuthenticatedFeature_announcementAdminSystemRolesCommunityIndexRoute;
  "/admin/system/roles/platform/": typeof AuthenticatedFeature_announcementAdminSystemRolesPlatformIndexRoute;
  "/admin/system/settings/emails/": typeof AuthenticatedFeature_announcementAdminSystemSettingsEmailsIndexRoute;
  "/admin/system/settings/policy_documents/": typeof AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsIndexRoute;
  "/admin/system/users/$userId/": typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdIndexRoute;
  "/admin/system/users/policy_templates/": typeof AuthenticatedFeature_announcementAdminSystemUsersPolicy_templatesIndexRoute;
  "/admin/system/users/roles/": typeof AuthenticatedFeature_announcementAdminSystemUsersRolesIndexRoute;
  "/communities/$communityId/events/$eventId/": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdIndexRoute;
  "/communities/$communityId/manage/communications/": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsIndexRoute;
  "/communities/$communityId/manage/leaders/": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersIndexRoute;
  "/communities/$communityId/manage/settings/": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsIndexRoute;
  "/communities/$communityId/manage/sponsors/": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsIndexRoute;
  "/communities/$communityId/manage/surveys/": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysIndexRoute;
  "/communities/$communityId/members/automations/": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsIndexRoute;
  "/communities/$communityId/plan/outcomes/": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesIndexRoute;
  "/communities/$communityId/plan/pillars/": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsIndexRoute;
  "/communities/$communityId/posts/$postId/": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPostsPostIdIndexRoute;
  "/network-survey-response/$networkId/$surveyId/cohorts/$cohortId": typeof AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdCohortsCohortIdRoute;
  "/admin/manage/calendar/$calendarId/notable_dates/create": typeof AuthenticatedFeature_announcementAdminManageCalendarCalendarIdNotable_datesCreateRoute;
  "/admin/manage/events/notable_dates_calendar/$calendarId/update": typeof AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdUpdateRoute;
  "/admin/manage/groups/$groupId/regions/new": typeof AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsNewRoute;
  "/admin/manage/groups/categories/$categoryId/edit": typeof AuthenticatedFeature_announcementAdminManageGroupsCategoriesCategoryIdEditRoute;
  "/admin/system/branding/sponsors/$sponsorId/edit": typeof AuthenticatedFeature_announcementAdminSystemBrandingSponsorsSponsorIdEditRoute;
  "/admin/system/roles/community/$roleId/permissions": typeof AuthenticatedFeature_announcementAdminSystemRolesCommunityRoleIdPermissionsRoute;
  "/admin/system/roles/platform/$roleId/permissions": typeof AuthenticatedFeature_announcementAdminSystemRolesPlatformRoleIdPermissionsRoute;
  "/admin/system/settings/emails/$emailId/edit": typeof AuthenticatedFeature_announcementAdminSystemSettingsEmailsEmailIdEditRoute;
  "/admin/system/settings/policy_documents/edit/$policyDocumentId": typeof AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsEditPolicyDocumentIdRoute;
  "/admin/system/users/$userId/edit/fields": typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdEditFieldsRoute;
  "/admin/system/users/$userId/edit/general": typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdEditGeneralRoute;
  "/admin/system/users/policy_templates/$policyId/edit": typeof AuthenticatedFeature_announcementAdminSystemUsersPolicy_templatesPolicyIdEditRoute;
  "/admin/system/users/roles/$roleId/edit": typeof AuthenticatedFeature_announcementAdminSystemUsersRolesRoleIdEditRoute;
  "/communities/$communityId/events/$eventId/manage/attendees": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageAttendeesRoute;
  "/communities/$communityId/events/$eventId/manage/budgeting": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageBudgetingRoute;
  "/communities/$communityId/events/$eventId/manage/waitlist": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageWaitlistRoute;
  "/communities/$communityId/manage/communications/$communicationId/distributions": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdDistributionsRoute;
  "/communities/$communityId/manage/communications/$communicationId/edit": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdEditRoute;
  "/communities/$communityId/manage/communications/$communicationId/recipients": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdRecipientsRoute;
  "/communities/$communityId/manage/leaders/$leaderId/edit": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersLeaderIdEditRoute;
  "/communities/$communityId/manage/sponsors/$sponsorId/edit": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsSponsorIdEditRoute;
  "/communities/$communityId/manage/surveys/$surveyId/edit": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysSurveyIdEditRoute;
  "/communities/$communityId/manage/surveys/$surveyId/responses": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysSurveyIdResponsesRoute;
  "/communities/$communityId/members/automations/$ruleId/edit": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRuleIdEditRoute;
  "/communities/$communityId/members/automations/history/$runId": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsHistoryRunIdRoute;
  "/communities/$communityId/plan/outcomes/$outcomeId/edit": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesOutcomeIdEditRoute;
  "/communities/$communityId/plan/pillars/$pillarId/edit": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsPillarIdEditRoute;
  "/communities/$communityId/plan/pillars/$pillarId/events": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsPillarIdEventsRoute;
  "/admin/manage/groups/$groupId/regions/": typeof AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsIndexRoute;
  "/admin/system/roles/community/$roleId/": typeof AuthenticatedFeature_announcementAdminSystemRolesCommunityRoleIdIndexRoute;
  "/admin/system/roles/platform/$roleId/": typeof AuthenticatedFeature_announcementAdminSystemRolesPlatformRoleIdIndexRoute;
  "/communities/$communityId/members/automations/history/": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsHistoryIndexRoute;
  "/admin/manage/calendar/$calendarId/notable_dates/$eventId/update": typeof AuthenticatedFeature_announcementAdminManageCalendarCalendarIdNotable_datesEventIdUpdateRoute;
  "/admin/manage/events/notable_dates_calendar/$calendarId/notable_dates/create": typeof AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdNotable_datesCreateRoute;
  "/admin/manage/groups/$groupId/regions/$regionId/edit": typeof AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsRegionIdEditRoute;
  "/admin/manage/events/notable_dates_calendar/$calendarId/notable_dates/$eventId/update": typeof AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdNotable_datesEventIdUpdateRoute;
}
export interface FileRoutesByTo {
  "/": typeof AuthenticatedFeature_announcementUserIndexRoute;
  "/auto-login": typeof AutoLoginRoute;
  "/onboarding": typeof compatibilityOnboardingRoute;
  "/sign_up": typeof compatibilitySign_upRoute;
  "/mobile_sign_in": typeof AnonymousMobile_sign_inRoute;
  "/unsubscribe": typeof AnonymousUnsubscribeRoute;
  "/forgot": typeof SessionForgotRoute;
  "/enrollment/complete": typeof EnrollmentCompleteRoute;
  "/enrollment/discover": typeof EnrollmentDiscoverRoute;
  "/enrollment/profile": typeof EnrollmentProfileRoute;
  "/enrollment": typeof EnrollmentIndexRoute;
  "/event_checkin/$eventId": typeof AnonymousEvent_checkinEventIdRoute;
  "/verify/$token": typeof AnonymousVerifyTokenRoute;
  "/admin": typeof AuthenticatedFeature_announcementAdminRouteWithChildren;
  "/login/activate": typeof SessionLoginActivateRoute;
  "/login/admin": typeof SessionLoginAdminRoute;
  "/login/credentials": typeof SessionLoginCredentialsRoute;
  "/password_reset/$token": typeof SessionPassword_resetTokenRoute;
  "/cms": typeof CmsCmsIndexRoute;
  "/login": typeof SessionLoginIndexRoute;
  "/password_reset": typeof SessionPassword_resetIndexRoute;
  "/communities": typeof AuthenticatedFeature_announcementUserCommunitiesRoute;
  "/downloads": typeof AuthenticatedFeature_announcementUserDownloadsRoute;
  "/groups": typeof AuthenticatedFeature_announcementUserGroupsRoute;
  "/notifications": typeof AuthenticatedFeature_announcementUserNotificationsRoute;
  "/rewards": typeof AuthenticatedFeature_announcementUserRewardsRoute;
  "/support": typeof AuthenticatedFeature_announcementUserSupportRoute;
  "/admin/support-config": typeof AuthenticatedFeature_announcementAdminSupportConfigRoute;
  "/admin/system": typeof AuthenticatedFeature_announcementAdminSystemRouteWithChildren;
  "/open_invitations/$openInvitationId": typeof AuthenticatedFeature_announcementOpen_invitationsOpenInvitationIdRoute;
  "/cms/review/comment_moderation": typeof CmsCmsReviewComment_moderationRoute;
  "/cms/tools/review_settings": typeof CmsCmsToolsReview_settingsRoute;
  "/community-lab/$": typeof AuthenticatedFeature_announcementUserCommunityLabSplatRoute;
  "/community-lab/session": typeof AuthenticatedFeature_announcementUserCommunityLabSessionRoute;
  "/community-lab/worksheet": typeof AuthenticatedFeature_announcementUserCommunityLabWorksheetRoute;
  "/profile/statistics": typeof AuthenticatedFeature_announcementUserProfileStatisticsRoute;
  "/admin/analyze/community-lab-report": typeof AuthenticatedFeature_announcementAdminAnalyzeCommunityLabReportRoute;
  "/admin/analyze/reports": typeof AuthenticatedFeature_announcementAdminAnalyzeReportsRoute;
  "/admin/analyze/segments": typeof AuthenticatedFeature_announcementAdminAnalyzeSegmentsRoute;
  "/admin/manage/archived": typeof AuthenticatedFeature_announcementAdminManageArchivedRoute;
  "/admin/manage/events": typeof AuthenticatedFeature_announcementAdminManageEventsRouteWithChildren;
  "/admin/manage/folders": typeof AuthenticatedFeature_announcementAdminManageFoldersRoute;
  "/admin/manage/labels": typeof AuthenticatedFeature_announcementAdminManageLabelsRoute;
  "/admin/manage/leaders": typeof AuthenticatedFeature_announcementAdminManageLeadersRoute;
  "/admin/manage/tags": typeof AuthenticatedFeature_announcementAdminManageTagsRoute;
  "/admin/plan/aggregate_budgeting": typeof AuthenticatedFeature_announcementAdminPlanAggregate_budgetingRoute;
  "/admin/surveys/new": typeof AuthenticatedFeature_announcementAdminSurveysNewRoute;
  "/admin/system/api_access_tokens": typeof AuthenticatedFeature_announcementAdminSystemApi_access_tokensRoute;
  "/admin/system/branding": typeof AuthenticatedFeature_announcementAdminSystemBrandingRouteWithChildren;
  "/admin/system/logs": typeof AuthenticatedFeature_announcementAdminSystemLogsRoute;
  "/admin/system/mcp_connector": typeof AuthenticatedFeature_announcementAdminSystemMcp_connectorRoute;
  "/admin/system/roles": typeof AuthenticatedFeature_announcementAdminSystemRolesRouteWithChildren;
  "/admin/system/settings": typeof AuthenticatedFeature_announcementAdminSystemSettingsRouteWithChildren;
  "/admin/system/users": typeof AuthenticatedFeature_announcementAdminSystemUsersRouteWithChildren;
  "/communities/$communityId/budgeting": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRouteWithChildren;
  "/communities/$communityId/chapters": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdChaptersRoute;
  "/communities/$communityId/folders": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdFoldersRoute;
  "/communities/$communityId/manage": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRouteWithChildren;
  "/communities/$communityId/plan": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRouteWithChildren;
  "/groups/$groupId/$": typeof AuthenticatedFeature_announcementGroupsGroupIdSplatRoute;
  "/invitations/$invitationId/accept": typeof AuthenticatedFeature_announcementInvitationsInvitationIdAcceptRoute;
  "/invitations/$invitationId/decline": typeof AuthenticatedFeature_announcementInvitationsInvitationIdDeclineRoute;
  "/regions/$regionId/$": typeof AuthenticatedFeature_announcementRegionsRegionIdSplatRoute;
  "/cms/manage/communications/$draftId": typeof CmsCmsManageCommunicationsDraftIdRoute;
  "/cms/manage/events/$draftId": typeof CmsCmsManageEventsDraftIdRoute;
  "/cms/manage/events/new": typeof CmsCmsManageEventsNewRoute;
  "/cms/manage/posts/$draftId": typeof CmsCmsManagePostsDraftIdRoute;
  "/cms/manage/publication_requests/$publicationRequestId": typeof CmsCmsManagePublication_requestsPublicationRequestIdRoute;
  "/cms/review/publication_requests/$publicationRequestId": typeof CmsCmsReviewPublication_requestsPublicationRequestIdRoute;
  "/community-lab": typeof AuthenticatedFeature_announcementUserCommunityLabIndexRoute;
  "/events": typeof AuthenticatedFeature_announcementUserEventsIndexRoute;
  "/posts": typeof AuthenticatedFeature_announcementUserPostsIndexRoute;
  "/profile": typeof AuthenticatedFeature_announcementUserProfileIndexRoute;
  "/admin/analyze": typeof AuthenticatedFeature_announcementAdminAnalyzeIndexRoute;
  "/admin/context-backfill": typeof AuthenticatedFeature_announcementAdminContextBackfillIndexRoute;
  "/admin/surveys": typeof AuthenticatedFeature_announcementAdminSurveysIndexRoute;
  "/communities/$communityId": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdIndexRoute;
  "/cms/manage/communications": typeof CmsCmsManageCommunicationsIndexRoute;
  "/cms/manage/events": typeof CmsCmsManageEventsIndexRoute;
  "/cms/manage/posts": typeof CmsCmsManagePostsIndexRoute;
  "/cms/manage/publication_requests": typeof CmsCmsManagePublication_requestsIndexRoute;
  "/cms/review/publication_requests": typeof CmsCmsReviewPublication_requestsIndexRoute;
  "/enterprises/$enterpriseId/folders/$folderId/resources": typeof compatibilityEnterprisesEnterpriseIdFoldersFolderIdResourcesRoute;
  "/groups/$groupId/folders/$folderId/resources": typeof compatibilityGroupsGroupIdFoldersFolderIdResourcesRoute;
  "/groups/$groupId/news/$type/$postId": typeof compatibilityGroupsGroupIdNewsTypePostIdRoute;
  "/regions/$regionId/news/$type/$postId": typeof compatibilityRegionsRegionIdNewsTypePostIdRoute;
  "/events/$eventId/$": typeof AuthenticatedFeature_announcementUserEventsEventIdSplatRoute;
  "/events/drafts/$draftId": typeof AuthenticatedFeature_announcementUserEventsDraftsDraftIdRoute;
  "/events/drafts/new": typeof AuthenticatedFeature_announcementUserEventsDraftsNewRoute;
  "/posts/$postId/$": typeof AuthenticatedFeature_announcementUserPostsPostIdSplatRoute;
  "/posts/drafts/$draftId": typeof AuthenticatedFeature_announcementUserPostsDraftsDraftIdRoute;
  "/profile/edit/accessibility": typeof AuthenticatedFeature_announcementUserProfileEditAccessibilityRoute;
  "/profile/edit/engagement-report": typeof AuthenticatedFeature_announcementUserProfileEditEngagementReportRoute;
  "/profile/edit/general": typeof AuthenticatedFeature_announcementUserProfileEditGeneralRoute;
  "/profile/edit/leadership": typeof AuthenticatedFeature_announcementUserProfileEditLeadershipRoute;
  "/profile/edit/notification": typeof AuthenticatedFeature_announcementUserProfileEditNotificationRoute;
  "/profile/edit/outlook": typeof AuthenticatedFeature_announcementUserProfileEditOutlookRoute;
  "/profile/edit/private": typeof AuthenticatedFeature_announcementUserProfileEditPrivateRoute;
  "/user/$userId/achievements": typeof AuthenticatedFeature_announcementUserUserUserIdAchievementsRoute;
  "/user/$userId/edit": typeof AuthenticatedFeature_announcementUserUserUserIdEditRoute;
  "/user/$userId/statistics": typeof AuthenticatedFeature_announcementUserUserUserIdStatisticsRoute;
  "/user/$userId/transactions": typeof AuthenticatedFeature_announcementUserUserUserIdTransactionsRoute;
  "/admin/analyze/dashboards/$": typeof AuthenticatedFeature_announcementAdminAnalyzeDashboardsSplatRoute;
  "/admin/analyze/groups/events": typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsEventsRoute;
  "/admin/analyze/groups/posts": typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsPostsRoute;
  "/admin/analyze/groups/resources": typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsResourcesRoute;
  "/admin/analyze/groups/users": typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsUsersRoute;
  "/admin/analyze/roi-suite/$": typeof AuthenticatedFeature_announcementAdminAnalyzeRoiSuiteSplatRoute;
  "/admin/analyze/users/events": typeof AuthenticatedFeature_announcementAdminAnalyzeUsersEventsRoute;
  "/admin/gamification/achievements/new": typeof AuthenticatedFeature_announcementAdminGamificationAchievementsNewRoute;
  "/admin/gamification/points/manage": typeof AuthenticatedFeature_announcementAdminGamificationPointsManageRoute;
  "/admin/gamification/rewards/new": typeof AuthenticatedFeature_announcementAdminGamificationRewardsNewRoute;
  "/admin/gamification/rewards/pending": typeof AuthenticatedFeature_announcementAdminGamificationRewardsPendingRoute;
  "/admin/manage/calendar/create": typeof AuthenticatedFeature_announcementAdminManageCalendarCreateRoute;
  "/admin/manage/communications/new": typeof AuthenticatedFeature_announcementAdminManageCommunicationsNewRoute;
  "/admin/manage/events/calendar": typeof AuthenticatedFeature_announcementAdminManageEventsCalendarRoute;
  "/admin/manage/events/configuration": typeof AuthenticatedFeature_announcementAdminManageEventsConfigurationRoute;
  "/admin/manage/events/questionnaire": typeof AuthenticatedFeature_announcementAdminManageEventsQuestionnaireRoute;
  "/admin/manage/groups/connections": typeof AuthenticatedFeature_announcementAdminManageGroupsConnectionsRoute;
  "/admin/manage/groups/leader_positions": typeof AuthenticatedFeature_announcementAdminManageGroupsLeader_positionsRoute;
  "/admin/manage/groups/new": typeof AuthenticatedFeature_announcementAdminManageGroupsNewRoute;
  "/admin/manage/segments/new": typeof AuthenticatedFeature_announcementAdminManageSegmentsNewRoute;
  "/admin/surveys/$surveyId/edit": typeof AuthenticatedFeature_announcementAdminSurveysSurveyIdEditRoute;
  "/admin/surveys/$surveyId/responses": typeof AuthenticatedFeature_announcementAdminSurveysSurveyIdResponsesRoute;
  "/admin/system/branding/colors": typeof AuthenticatedFeature_announcementAdminSystemBrandingColorsRoute;
  "/admin/system/branding/home": typeof AuthenticatedFeature_announcementAdminSystemBrandingHomeRoute;
  "/admin/system/branding/logos": typeof AuthenticatedFeature_announcementAdminSystemBrandingLogosRoute;
  "/admin/system/branding/theme": typeof AuthenticatedFeature_announcementAdminSystemBrandingThemeRoute;
  "/admin/system/integrations/mentorcliq": typeof AuthenticatedFeature_announcementAdminSystemIntegrationsMentorcliqRoute;
  "/admin/system/integrations/outlook": typeof AuthenticatedFeature_announcementAdminSystemIntegrationsOutlookRoute;
  "/admin/system/integrations/simpplr": typeof AuthenticatedFeature_announcementAdminSystemIntegrationsSimpplrRoute;
  "/admin/system/integrations/slack": typeof AuthenticatedFeature_announcementAdminSystemIntegrationsSlackRoute;
  "/admin/system/integrations/teams": typeof AuthenticatedFeature_announcementAdminSystemIntegrationsTeamsRoute;
  "/admin/system/integrations/ukg": typeof AuthenticatedFeature_announcementAdminSystemIntegrationsUkgRoute;
  "/admin/system/integrations/viva-engage": typeof AuthenticatedFeature_announcementAdminSystemIntegrationsVivaEngageRoute;
  "/admin/system/roles/role_configuration": typeof AuthenticatedFeature_announcementAdminSystemRolesRole_configurationRoute;
  "/admin/system/settings/custom_texts": typeof AuthenticatedFeature_announcementAdminSystemSettingsCustom_textsRoute;
  "/admin/system/settings/fields": typeof AuthenticatedFeature_announcementAdminSystemSettingsFieldsRoute;
  "/admin/system/settings/sso": typeof AuthenticatedFeature_announcementAdminSystemSettingsSsoRoute;
  "/admin/system/users/import": typeof AuthenticatedFeature_announcementAdminSystemUsersImportRoute;
  "/admin/system/users/list": typeof AuthenticatedFeature_announcementAdminSystemUsersListRoute;
  "/admin/system/users/merge": typeof AuthenticatedFeature_announcementAdminSystemUsersMergeRoute;
  "/admin/system/users/new": typeof AuthenticatedFeature_announcementAdminSystemUsersNewRoute;
  "/communities/$communityId/budgeting/manage": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingManageRoute;
  "/communities/$communityId/budgeting/overview": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingOverviewRoute;
  "/communities/$communityId/budgeting/request": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRequestRoute;
  "/communities/$communityId/events/pending": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsPendingRoute;
  "/communities/$communityId/manage/archives": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageArchivesRoute;
  "/communities/$communityId/manage/community-lab-report": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunityLabReportRoute;
  "/communities/$communityId/manage/review_settings": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageReview_settingsRoute;
  "/communities/$communityId/manage/role_configuration": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRole_configurationRoute;
  "/communities/$communityId/members/invitations": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersInvitationsRoute;
  "/communities/$communityId/plan/budgeting": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRouteWithChildren;
  "/communities/$communityId/plan/events": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanEventsRoute;
  "/communities/$communityId/roi-suite/$": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdRoiSuiteSplatRoute;
  "/events/drafts": typeof AuthenticatedFeature_announcementUserEventsDraftsIndexRoute;
  "/global-survey-response/$surveyId": typeof AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdIndexRoute;
  "/posts/drafts": typeof AuthenticatedFeature_announcementUserPostsDraftsIndexRoute;
  "/user/$userId": typeof AuthenticatedFeature_announcementUserUserUserIdIndexRoute;
  "/admin/analyze/groups": typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsIndexRoute;
  "/admin/analyze/users": typeof AuthenticatedFeature_announcementAdminAnalyzeUsersIndexRoute;
  "/admin/gamification/achievements": typeof AuthenticatedFeature_announcementAdminGamificationAchievementsIndexRoute;
  "/admin/gamification/rewards": typeof AuthenticatedFeature_announcementAdminGamificationRewardsIndexRoute;
  "/admin/manage/calendar": typeof AuthenticatedFeature_announcementAdminManageCalendarIndexRoute;
  "/admin/manage/communications": typeof AuthenticatedFeature_announcementAdminManageCommunicationsIndexRoute;
  "/admin/manage/groups": typeof AuthenticatedFeature_announcementAdminManageGroupsIndexRoute;
  "/admin/manage/segments": typeof AuthenticatedFeature_announcementAdminManageSegmentsIndexRoute;
  "/admin/plan/budgeting": typeof AuthenticatedFeature_announcementAdminPlanBudgetingIndexRoute;
  "/admin/system/integrations": typeof AuthenticatedFeature_announcementAdminSystemIntegrationsIndexRoute;
  "/communities/$communityId/events": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsIndexRoute;
  "/communities/$communityId/members": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersIndexRoute;
  "/communities/$communityId/posts": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPostsIndexRoute;
  "/global-survey-response/$surveyId/cohorts/$cohortId": typeof AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdCohortsCohortIdRoute;
  "/profile/edit/record-hours/$communityId": typeof AuthenticatedFeature_announcementUserProfileEditRecordHoursCommunityIdRoute;
  "/admin/gamification/achievements/$achievementId/edit": typeof AuthenticatedFeature_announcementAdminGamificationAchievementsAchievementIdEditRoute;
  "/admin/gamification/rewards/$rewardId/edit": typeof AuthenticatedFeature_announcementAdminGamificationRewardsRewardIdEditRoute;
  "/admin/manage/calendar/$calendarId/update": typeof AuthenticatedFeature_announcementAdminManageCalendarCalendarIdUpdateRoute;
  "/admin/manage/communications/$communicationId/distributions": typeof AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdDistributionsRoute;
  "/admin/manage/communications/$communicationId/edit": typeof AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdEditRoute;
  "/admin/manage/communications/$communicationId/recipients": typeof AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdRecipientsRoute;
  "/admin/manage/events/notable_dates_calendar/create": typeof AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCreateRoute;
  "/admin/manage/groups/$groupId/categorize": typeof AuthenticatedFeature_announcementAdminManageGroupsGroupIdCategorizeRoute;
  "/admin/manage/groups/$groupId/edit": typeof AuthenticatedFeature_announcementAdminManageGroupsGroupIdEditRoute;
  "/admin/manage/groups/categories/new": typeof AuthenticatedFeature_announcementAdminManageGroupsCategoriesNewRoute;
  "/admin/manage/segments/$segmentId/edit": typeof AuthenticatedFeature_announcementAdminManageSegmentsSegmentIdEditRoute;
  "/admin/plan/budgeting/fiscal_periods/new": typeof AuthenticatedFeature_announcementAdminPlanBudgetingFiscal_periodsNewRoute;
  "/admin/system/branding/sponsors/new": typeof AuthenticatedFeature_announcementAdminSystemBrandingSponsorsNewRoute;
  "/admin/system/settings/communities": typeof AuthenticatedFeature_announcementAdminSystemSettingsConfigurationCommunitiesRoute;
  "/admin/system/settings/configuration": typeof AuthenticatedFeature_announcementAdminSystemSettingsConfigurationConfigurationRoute;
  "/admin/system/settings/modules": typeof AuthenticatedFeature_announcementAdminSystemSettingsConfigurationModulesRoute;
  "/admin/system/settings/profile_fields": typeof AuthenticatedFeature_announcementAdminSystemSettingsConfigurationProfile_fieldsRoute;
  "/admin/system/settings/policy_documents/new": typeof AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsNewRoute;
  "/admin/system/users/$userId/edit": typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdEditRouteWithChildren;
  "/admin/system/users/$userId/role_assignments": typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdRole_assignmentsRoute;
  "/admin/system/users/$userId/statistics": typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdStatisticsRoute;
  "/admin/system/users/roles/new": typeof AuthenticatedFeature_announcementAdminSystemUsersRolesNewRoute;
  "/communities/$communityId/events/$eventId/edit": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdEditRoute;
  "/communities/$communityId/manage/communications/new": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsNewRoute;
  "/communities/$communityId/manage/events/pending": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageEventsPendingRoute;
  "/communities/$communityId/manage/leaders/new": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersNewRoute;
  "/communities/$communityId/manage/settings/integration": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsIntegrationRoute;
  "/communities/$communityId/manage/settings/welcome_message": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsWelcome_messageRoute;
  "/communities/$communityId/manage/sponsors/new": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsNewRoute;
  "/communities/$communityId/manage/surveys/new": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysNewRoute;
  "/communities/$communityId/members/automations/new": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsNewRoute;
  "/communities/$communityId/plan/budgeting/manage": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingManageRoute;
  "/communities/$communityId/plan/budgeting/overview": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingOverviewRoute;
  "/communities/$communityId/plan/budgeting/request": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRequestRoute;
  "/communities/$communityId/plan/outcomes/new": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesNewRoute;
  "/communities/$communityId/plan/pillars/new": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsNewRoute;
  "/communities/$communityId/posts/$postId/edit": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPostsPostIdEditRoute;
  "/network-survey-response/$networkId/$surveyId": typeof AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdIndexRoute;
  "/admin/manage/events/notable_dates_calendar": typeof AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarIndexRoute;
  "/admin/manage/groups/categories": typeof AuthenticatedFeature_announcementAdminManageGroupsCategoriesIndexRoute;
  "/admin/system/branding/sponsors": typeof AuthenticatedFeature_announcementAdminSystemBrandingSponsorsIndexRoute;
  "/admin/system/roles/community": typeof AuthenticatedFeature_announcementAdminSystemRolesCommunityIndexRoute;
  "/admin/system/roles/platform": typeof AuthenticatedFeature_announcementAdminSystemRolesPlatformIndexRoute;
  "/admin/system/settings/emails": typeof AuthenticatedFeature_announcementAdminSystemSettingsEmailsIndexRoute;
  "/admin/system/settings/policy_documents": typeof AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsIndexRoute;
  "/admin/system/users/$userId": typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdIndexRoute;
  "/admin/system/users/policy_templates": typeof AuthenticatedFeature_announcementAdminSystemUsersPolicy_templatesIndexRoute;
  "/admin/system/users/roles": typeof AuthenticatedFeature_announcementAdminSystemUsersRolesIndexRoute;
  "/communities/$communityId/events/$eventId": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdIndexRoute;
  "/communities/$communityId/manage/communications": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsIndexRoute;
  "/communities/$communityId/manage/leaders": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersIndexRoute;
  "/communities/$communityId/manage/settings": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsIndexRoute;
  "/communities/$communityId/manage/sponsors": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsIndexRoute;
  "/communities/$communityId/manage/surveys": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysIndexRoute;
  "/communities/$communityId/members/automations": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsIndexRoute;
  "/communities/$communityId/plan/outcomes": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesIndexRoute;
  "/communities/$communityId/plan/pillars": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsIndexRoute;
  "/communities/$communityId/posts/$postId": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPostsPostIdIndexRoute;
  "/network-survey-response/$networkId/$surveyId/cohorts/$cohortId": typeof AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdCohortsCohortIdRoute;
  "/admin/manage/calendar/$calendarId/notable_dates/create": typeof AuthenticatedFeature_announcementAdminManageCalendarCalendarIdNotable_datesCreateRoute;
  "/admin/manage/events/notable_dates_calendar/$calendarId/update": typeof AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdUpdateRoute;
  "/admin/manage/groups/$groupId/regions/new": typeof AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsNewRoute;
  "/admin/manage/groups/categories/$categoryId/edit": typeof AuthenticatedFeature_announcementAdminManageGroupsCategoriesCategoryIdEditRoute;
  "/admin/system/branding/sponsors/$sponsorId/edit": typeof AuthenticatedFeature_announcementAdminSystemBrandingSponsorsSponsorIdEditRoute;
  "/admin/system/roles/community/$roleId/permissions": typeof AuthenticatedFeature_announcementAdminSystemRolesCommunityRoleIdPermissionsRoute;
  "/admin/system/roles/platform/$roleId/permissions": typeof AuthenticatedFeature_announcementAdminSystemRolesPlatformRoleIdPermissionsRoute;
  "/admin/system/settings/emails/$emailId/edit": typeof AuthenticatedFeature_announcementAdminSystemSettingsEmailsEmailIdEditRoute;
  "/admin/system/settings/policy_documents/edit/$policyDocumentId": typeof AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsEditPolicyDocumentIdRoute;
  "/admin/system/users/$userId/edit/fields": typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdEditFieldsRoute;
  "/admin/system/users/$userId/edit/general": typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdEditGeneralRoute;
  "/admin/system/users/policy_templates/$policyId/edit": typeof AuthenticatedFeature_announcementAdminSystemUsersPolicy_templatesPolicyIdEditRoute;
  "/admin/system/users/roles/$roleId/edit": typeof AuthenticatedFeature_announcementAdminSystemUsersRolesRoleIdEditRoute;
  "/communities/$communityId/events/$eventId/manage/attendees": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageAttendeesRoute;
  "/communities/$communityId/events/$eventId/manage/budgeting": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageBudgetingRoute;
  "/communities/$communityId/events/$eventId/manage/waitlist": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageWaitlistRoute;
  "/communities/$communityId/manage/communications/$communicationId/distributions": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdDistributionsRoute;
  "/communities/$communityId/manage/communications/$communicationId/edit": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdEditRoute;
  "/communities/$communityId/manage/communications/$communicationId/recipients": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdRecipientsRoute;
  "/communities/$communityId/manage/leaders/$leaderId/edit": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersLeaderIdEditRoute;
  "/communities/$communityId/manage/sponsors/$sponsorId/edit": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsSponsorIdEditRoute;
  "/communities/$communityId/manage/surveys/$surveyId/edit": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysSurveyIdEditRoute;
  "/communities/$communityId/manage/surveys/$surveyId/responses": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysSurveyIdResponsesRoute;
  "/communities/$communityId/members/automations/$ruleId/edit": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRuleIdEditRoute;
  "/communities/$communityId/members/automations/history/$runId": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsHistoryRunIdRoute;
  "/communities/$communityId/plan/outcomes/$outcomeId/edit": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesOutcomeIdEditRoute;
  "/communities/$communityId/plan/pillars/$pillarId/edit": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsPillarIdEditRoute;
  "/communities/$communityId/plan/pillars/$pillarId/events": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsPillarIdEventsRoute;
  "/admin/manage/groups/$groupId/regions": typeof AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsIndexRoute;
  "/admin/system/roles/community/$roleId": typeof AuthenticatedFeature_announcementAdminSystemRolesCommunityRoleIdIndexRoute;
  "/admin/system/roles/platform/$roleId": typeof AuthenticatedFeature_announcementAdminSystemRolesPlatformRoleIdIndexRoute;
  "/communities/$communityId/members/automations/history": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsHistoryIndexRoute;
  "/admin/manage/calendar/$calendarId/notable_dates/$eventId/update": typeof AuthenticatedFeature_announcementAdminManageCalendarCalendarIdNotable_datesEventIdUpdateRoute;
  "/admin/manage/events/notable_dates_calendar/$calendarId/notable_dates/create": typeof AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdNotable_datesCreateRoute;
  "/admin/manage/groups/$groupId/regions/$regionId/edit": typeof AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsRegionIdEditRoute;
  "/admin/manage/events/notable_dates_calendar/$calendarId/notable_dates/$eventId/update": typeof AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdNotable_datesEventIdUpdateRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/_anonymous": typeof AnonymousRouteWithChildren;
  "/_authenticated": typeof AuthenticatedRouteWithChildren;
  "/_cms": typeof CmsRouteWithChildren;
  "/_session": typeof SessionRouteWithChildren;
  "/auto-login": typeof AutoLoginRoute;
  "/enrollment": typeof EnrollmentRouteWithChildren;
  "/(compatibility)/onboarding": typeof compatibilityOnboardingRoute;
  "/(compatibility)/sign_up": typeof compatibilitySign_upRoute;
  "/_anonymous/mobile_sign_in": typeof AnonymousMobile_sign_inRoute;
  "/_anonymous/unsubscribe": typeof AnonymousUnsubscribeRoute;
  "/_authenticated/_feature_announcement": typeof AuthenticatedFeature_announcementRouteWithChildren;
  "/_session/forgot": typeof SessionForgotRoute;
  "/enrollment/complete": typeof EnrollmentCompleteRoute;
  "/enrollment/discover": typeof EnrollmentDiscoverRoute;
  "/enrollment/profile": typeof EnrollmentProfileRoute;
  "/enrollment/": typeof EnrollmentIndexRoute;
  "/_anonymous/event_checkin/$eventId": typeof AnonymousEvent_checkinEventIdRoute;
  "/_anonymous/verify/$token": typeof AnonymousVerifyTokenRoute;
  "/_authenticated/_feature_announcement/_user": typeof AuthenticatedFeature_announcementUserRouteWithChildren;
  "/_authenticated/_feature_announcement/admin": typeof AuthenticatedFeature_announcementAdminRouteWithChildren;
  "/_session/login/activate": typeof SessionLoginActivateRoute;
  "/_session/login/admin": typeof SessionLoginAdminRoute;
  "/_session/login/credentials": typeof SessionLoginCredentialsRoute;
  "/_session/password_reset/$token": typeof SessionPassword_resetTokenRoute;
  "/_cms/cms/": typeof CmsCmsIndexRoute;
  "/_session/login/": typeof SessionLoginIndexRoute;
  "/_session/password_reset/": typeof SessionPassword_resetIndexRoute;
  "/_authenticated/_feature_announcement/_user/communities": typeof AuthenticatedFeature_announcementUserCommunitiesRoute;
  "/_authenticated/_feature_announcement/_user/downloads": typeof AuthenticatedFeature_announcementUserDownloadsRoute;
  "/_authenticated/_feature_announcement/_user/groups": typeof AuthenticatedFeature_announcementUserGroupsRoute;
  "/_authenticated/_feature_announcement/_user/notifications": typeof AuthenticatedFeature_announcementUserNotificationsRoute;
  "/_authenticated/_feature_announcement/_user/profile": typeof AuthenticatedFeature_announcementUserProfileRouteWithChildren;
  "/_authenticated/_feature_announcement/_user/rewards": typeof AuthenticatedFeature_announcementUserRewardsRoute;
  "/_authenticated/_feature_announcement/_user/support": typeof AuthenticatedFeature_announcementUserSupportRoute;
  "/_authenticated/_feature_announcement/admin/support-config": typeof AuthenticatedFeature_announcementAdminSupportConfigRoute;
  "/_authenticated/_feature_announcement/admin/system": typeof AuthenticatedFeature_announcementAdminSystemRouteWithChildren;
  "/_authenticated/_feature_announcement/communities/$communityId": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdRouteWithChildren;
  "/_authenticated/_feature_announcement/open_invitations/$openInvitationId": typeof AuthenticatedFeature_announcementOpen_invitationsOpenInvitationIdRoute;
  "/_cms/cms/review/comment_moderation": typeof CmsCmsReviewComment_moderationRoute;
  "/_cms/cms/tools/review_settings": typeof CmsCmsToolsReview_settingsRoute;
  "/_authenticated/_feature_announcement/_user/": typeof AuthenticatedFeature_announcementUserIndexRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/members": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersRouteRouteWithChildren;
  "/_authenticated/_feature_announcement/_user/community-lab/$": typeof AuthenticatedFeature_announcementUserCommunityLabSplatRoute;
  "/_authenticated/_feature_announcement/_user/community-lab/session": typeof AuthenticatedFeature_announcementUserCommunityLabSessionRoute;
  "/_authenticated/_feature_announcement/_user/community-lab/worksheet": typeof AuthenticatedFeature_announcementUserCommunityLabWorksheetRoute;
  "/_authenticated/_feature_announcement/_user/global-survey-response/$surveyId": typeof AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdRouteWithChildren;
  "/_authenticated/_feature_announcement/_user/profile/statistics": typeof AuthenticatedFeature_announcementUserProfileStatisticsRoute;
  "/_authenticated/_feature_announcement/admin/analyze/community-lab-report": typeof AuthenticatedFeature_announcementAdminAnalyzeCommunityLabReportRoute;
  "/_authenticated/_feature_announcement/admin/analyze/groups": typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsRouteWithChildren;
  "/_authenticated/_feature_announcement/admin/analyze/reports": typeof AuthenticatedFeature_announcementAdminAnalyzeReportsRoute;
  "/_authenticated/_feature_announcement/admin/analyze/segments": typeof AuthenticatedFeature_announcementAdminAnalyzeSegmentsRoute;
  "/_authenticated/_feature_announcement/admin/analyze/users": typeof AuthenticatedFeature_announcementAdminAnalyzeUsersRouteWithChildren;
  "/_authenticated/_feature_announcement/admin/gamification/rewards": typeof AuthenticatedFeature_announcementAdminGamificationRewardsRouteWithChildren;
  "/_authenticated/_feature_announcement/admin/manage/archived": typeof AuthenticatedFeature_announcementAdminManageArchivedRoute;
  "/_authenticated/_feature_announcement/admin/manage/events": typeof AuthenticatedFeature_announcementAdminManageEventsRouteWithChildren;
  "/_authenticated/_feature_announcement/admin/manage/folders": typeof AuthenticatedFeature_announcementAdminManageFoldersRoute;
  "/_authenticated/_feature_announcement/admin/manage/labels": typeof AuthenticatedFeature_announcementAdminManageLabelsRoute;
  "/_authenticated/_feature_announcement/admin/manage/leaders": typeof AuthenticatedFeature_announcementAdminManageLeadersRoute;
  "/_authenticated/_feature_announcement/admin/manage/tags": typeof AuthenticatedFeature_announcementAdminManageTagsRoute;
  "/_authenticated/_feature_announcement/admin/plan/aggregate_budgeting": typeof AuthenticatedFeature_announcementAdminPlanAggregate_budgetingRoute;
  "/_authenticated/_feature_announcement/admin/surveys/new": typeof AuthenticatedFeature_announcementAdminSurveysNewRoute;
  "/_authenticated/_feature_announcement/admin/system/api_access_tokens": typeof AuthenticatedFeature_announcementAdminSystemApi_access_tokensRoute;
  "/_authenticated/_feature_announcement/admin/system/branding": typeof AuthenticatedFeature_announcementAdminSystemBrandingRouteWithChildren;
  "/_authenticated/_feature_announcement/admin/system/integrations": typeof AuthenticatedFeature_announcementAdminSystemIntegrationsRouteWithChildren;
  "/_authenticated/_feature_announcement/admin/system/logs": typeof AuthenticatedFeature_announcementAdminSystemLogsRoute;
  "/_authenticated/_feature_announcement/admin/system/mcp_connector": typeof AuthenticatedFeature_announcementAdminSystemMcp_connectorRoute;
  "/_authenticated/_feature_announcement/admin/system/roles": typeof AuthenticatedFeature_announcementAdminSystemRolesRouteWithChildren;
  "/_authenticated/_feature_announcement/admin/system/settings": typeof AuthenticatedFeature_announcementAdminSystemSettingsRouteWithChildren;
  "/_authenticated/_feature_announcement/admin/system/users": typeof AuthenticatedFeature_announcementAdminSystemUsersRouteWithChildren;
  "/_authenticated/_feature_announcement/communities/$communityId/budgeting": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRouteWithChildren;
  "/_authenticated/_feature_announcement/communities/$communityId/chapters": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdChaptersRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/folders": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdFoldersRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/manage": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRouteWithChildren;
  "/_authenticated/_feature_announcement/communities/$communityId/plan": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRouteWithChildren;
  "/_authenticated/_feature_announcement/groups/$groupId/$": typeof AuthenticatedFeature_announcementGroupsGroupIdSplatRoute;
  "/_authenticated/_feature_announcement/invitations/$invitationId/accept": typeof AuthenticatedFeature_announcementInvitationsInvitationIdAcceptRoute;
  "/_authenticated/_feature_announcement/invitations/$invitationId/decline": typeof AuthenticatedFeature_announcementInvitationsInvitationIdDeclineRoute;
  "/_authenticated/_feature_announcement/regions/$regionId/$": typeof AuthenticatedFeature_announcementRegionsRegionIdSplatRoute;
  "/_cms/cms/manage/communications/$draftId": typeof CmsCmsManageCommunicationsDraftIdRoute;
  "/_cms/cms/manage/events/$draftId": typeof CmsCmsManageEventsDraftIdRoute;
  "/_cms/cms/manage/events/new": typeof CmsCmsManageEventsNewRoute;
  "/_cms/cms/manage/posts/$draftId": typeof CmsCmsManagePostsDraftIdRoute;
  "/_cms/cms/manage/publication_requests/$publicationRequestId": typeof CmsCmsManagePublication_requestsPublicationRequestIdRoute;
  "/_cms/cms/review/publication_requests/$publicationRequestId": typeof CmsCmsReviewPublication_requestsPublicationRequestIdRoute;
  "/_authenticated/_feature_announcement/_user/community-lab/": typeof AuthenticatedFeature_announcementUserCommunityLabIndexRoute;
  "/_authenticated/_feature_announcement/_user/events/": typeof AuthenticatedFeature_announcementUserEventsIndexRoute;
  "/_authenticated/_feature_announcement/_user/posts/": typeof AuthenticatedFeature_announcementUserPostsIndexRoute;
  "/_authenticated/_feature_announcement/_user/profile/": typeof AuthenticatedFeature_announcementUserProfileIndexRoute;
  "/_authenticated/_feature_announcement/admin/analyze/": typeof AuthenticatedFeature_announcementAdminAnalyzeIndexRoute;
  "/_authenticated/_feature_announcement/admin/context-backfill/": typeof AuthenticatedFeature_announcementAdminContextBackfillIndexRoute;
  "/_authenticated/_feature_announcement/admin/surveys/": typeof AuthenticatedFeature_announcementAdminSurveysIndexRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdIndexRoute;
  "/_cms/cms/manage/communications/": typeof CmsCmsManageCommunicationsIndexRoute;
  "/_cms/cms/manage/events/": typeof CmsCmsManageEventsIndexRoute;
  "/_cms/cms/manage/posts/": typeof CmsCmsManagePostsIndexRoute;
  "/_cms/cms/manage/publication_requests/": typeof CmsCmsManagePublication_requestsIndexRoute;
  "/_cms/cms/review/publication_requests/": typeof CmsCmsReviewPublication_requestsIndexRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/members/automations": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRouteRouteWithChildren;
  "/(compatibility)/enterprises/$enterpriseId/folders/$folderId/resources": typeof compatibilityEnterprisesEnterpriseIdFoldersFolderIdResourcesRoute;
  "/(compatibility)/groups/$groupId/folders/$folderId/resources": typeof compatibilityGroupsGroupIdFoldersFolderIdResourcesRoute;
  "/(compatibility)/groups/$groupId/news/$type/$postId": typeof compatibilityGroupsGroupIdNewsTypePostIdRoute;
  "/(compatibility)/regions/$regionId/news/$type/$postId": typeof compatibilityRegionsRegionIdNewsTypePostIdRoute;
  "/_authenticated/_feature_announcement/_user/events/$eventId/$": typeof AuthenticatedFeature_announcementUserEventsEventIdSplatRoute;
  "/_authenticated/_feature_announcement/_user/events/drafts/$draftId": typeof AuthenticatedFeature_announcementUserEventsDraftsDraftIdRoute;
  "/_authenticated/_feature_announcement/_user/events/drafts/new": typeof AuthenticatedFeature_announcementUserEventsDraftsNewRoute;
  "/_authenticated/_feature_announcement/_user/network-survey-response/$networkId/$surveyId": typeof AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdRouteWithChildren;
  "/_authenticated/_feature_announcement/_user/posts/$postId/$": typeof AuthenticatedFeature_announcementUserPostsPostIdSplatRoute;
  "/_authenticated/_feature_announcement/_user/posts/drafts/$draftId": typeof AuthenticatedFeature_announcementUserPostsDraftsDraftIdRoute;
  "/_authenticated/_feature_announcement/_user/profile/edit/accessibility": typeof AuthenticatedFeature_announcementUserProfileEditAccessibilityRoute;
  "/_authenticated/_feature_announcement/_user/profile/edit/engagement-report": typeof AuthenticatedFeature_announcementUserProfileEditEngagementReportRoute;
  "/_authenticated/_feature_announcement/_user/profile/edit/general": typeof AuthenticatedFeature_announcementUserProfileEditGeneralRoute;
  "/_authenticated/_feature_announcement/_user/profile/edit/leadership": typeof AuthenticatedFeature_announcementUserProfileEditLeadershipRoute;
  "/_authenticated/_feature_announcement/_user/profile/edit/notification": typeof AuthenticatedFeature_announcementUserProfileEditNotificationRoute;
  "/_authenticated/_feature_announcement/_user/profile/edit/outlook": typeof AuthenticatedFeature_announcementUserProfileEditOutlookRoute;
  "/_authenticated/_feature_announcement/_user/profile/edit/private": typeof AuthenticatedFeature_announcementUserProfileEditPrivateRoute;
  "/_authenticated/_feature_announcement/_user/user/$userId/achievements": typeof AuthenticatedFeature_announcementUserUserUserIdAchievementsRoute;
  "/_authenticated/_feature_announcement/_user/user/$userId/edit": typeof AuthenticatedFeature_announcementUserUserUserIdEditRoute;
  "/_authenticated/_feature_announcement/_user/user/$userId/statistics": typeof AuthenticatedFeature_announcementUserUserUserIdStatisticsRoute;
  "/_authenticated/_feature_announcement/_user/user/$userId/transactions": typeof AuthenticatedFeature_announcementUserUserUserIdTransactionsRoute;
  "/_authenticated/_feature_announcement/admin/analyze/dashboards/$": typeof AuthenticatedFeature_announcementAdminAnalyzeDashboardsSplatRoute;
  "/_authenticated/_feature_announcement/admin/analyze/groups/events": typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsEventsRoute;
  "/_authenticated/_feature_announcement/admin/analyze/groups/posts": typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsPostsRoute;
  "/_authenticated/_feature_announcement/admin/analyze/groups/resources": typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsResourcesRoute;
  "/_authenticated/_feature_announcement/admin/analyze/groups/users": typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsUsersRoute;
  "/_authenticated/_feature_announcement/admin/analyze/roi-suite/$": typeof AuthenticatedFeature_announcementAdminAnalyzeRoiSuiteSplatRoute;
  "/_authenticated/_feature_announcement/admin/analyze/users/events": typeof AuthenticatedFeature_announcementAdminAnalyzeUsersEventsRoute;
  "/_authenticated/_feature_announcement/admin/gamification/achievements/new": typeof AuthenticatedFeature_announcementAdminGamificationAchievementsNewRoute;
  "/_authenticated/_feature_announcement/admin/gamification/points/manage": typeof AuthenticatedFeature_announcementAdminGamificationPointsManageRoute;
  "/_authenticated/_feature_announcement/admin/gamification/rewards/new": typeof AuthenticatedFeature_announcementAdminGamificationRewardsNewRoute;
  "/_authenticated/_feature_announcement/admin/gamification/rewards/pending": typeof AuthenticatedFeature_announcementAdminGamificationRewardsPendingRoute;
  "/_authenticated/_feature_announcement/admin/manage/calendar/create": typeof AuthenticatedFeature_announcementAdminManageCalendarCreateRoute;
  "/_authenticated/_feature_announcement/admin/manage/communications/new": typeof AuthenticatedFeature_announcementAdminManageCommunicationsNewRoute;
  "/_authenticated/_feature_announcement/admin/manage/events/calendar": typeof AuthenticatedFeature_announcementAdminManageEventsCalendarRoute;
  "/_authenticated/_feature_announcement/admin/manage/events/configuration": typeof AuthenticatedFeature_announcementAdminManageEventsConfigurationRoute;
  "/_authenticated/_feature_announcement/admin/manage/events/questionnaire": typeof AuthenticatedFeature_announcementAdminManageEventsQuestionnaireRoute;
  "/_authenticated/_feature_announcement/admin/manage/groups/connections": typeof AuthenticatedFeature_announcementAdminManageGroupsConnectionsRoute;
  "/_authenticated/_feature_announcement/admin/manage/groups/leader_positions": typeof AuthenticatedFeature_announcementAdminManageGroupsLeader_positionsRoute;
  "/_authenticated/_feature_announcement/admin/manage/groups/new": typeof AuthenticatedFeature_announcementAdminManageGroupsNewRoute;
  "/_authenticated/_feature_announcement/admin/manage/segments/new": typeof AuthenticatedFeature_announcementAdminManageSegmentsNewRoute;
  "/_authenticated/_feature_announcement/admin/surveys/$surveyId/edit": typeof AuthenticatedFeature_announcementAdminSurveysSurveyIdEditRoute;
  "/_authenticated/_feature_announcement/admin/surveys/$surveyId/responses": typeof AuthenticatedFeature_announcementAdminSurveysSurveyIdResponsesRoute;
  "/_authenticated/_feature_announcement/admin/system/branding/colors": typeof AuthenticatedFeature_announcementAdminSystemBrandingColorsRoute;
  "/_authenticated/_feature_announcement/admin/system/branding/home": typeof AuthenticatedFeature_announcementAdminSystemBrandingHomeRoute;
  "/_authenticated/_feature_announcement/admin/system/branding/logos": typeof AuthenticatedFeature_announcementAdminSystemBrandingLogosRoute;
  "/_authenticated/_feature_announcement/admin/system/branding/theme": typeof AuthenticatedFeature_announcementAdminSystemBrandingThemeRoute;
  "/_authenticated/_feature_announcement/admin/system/integrations/mentorcliq": typeof AuthenticatedFeature_announcementAdminSystemIntegrationsMentorcliqRoute;
  "/_authenticated/_feature_announcement/admin/system/integrations/outlook": typeof AuthenticatedFeature_announcementAdminSystemIntegrationsOutlookRoute;
  "/_authenticated/_feature_announcement/admin/system/integrations/simpplr": typeof AuthenticatedFeature_announcementAdminSystemIntegrationsSimpplrRoute;
  "/_authenticated/_feature_announcement/admin/system/integrations/slack": typeof AuthenticatedFeature_announcementAdminSystemIntegrationsSlackRoute;
  "/_authenticated/_feature_announcement/admin/system/integrations/teams": typeof AuthenticatedFeature_announcementAdminSystemIntegrationsTeamsRoute;
  "/_authenticated/_feature_announcement/admin/system/integrations/ukg": typeof AuthenticatedFeature_announcementAdminSystemIntegrationsUkgRoute;
  "/_authenticated/_feature_announcement/admin/system/integrations/viva-engage": typeof AuthenticatedFeature_announcementAdminSystemIntegrationsVivaEngageRoute;
  "/_authenticated/_feature_announcement/admin/system/roles/role_configuration": typeof AuthenticatedFeature_announcementAdminSystemRolesRole_configurationRoute;
  "/_authenticated/_feature_announcement/admin/system/settings/_configuration": typeof AuthenticatedFeature_announcementAdminSystemSettingsConfigurationRouteWithChildren;
  "/_authenticated/_feature_announcement/admin/system/settings/custom_texts": typeof AuthenticatedFeature_announcementAdminSystemSettingsCustom_textsRoute;
  "/_authenticated/_feature_announcement/admin/system/settings/fields": typeof AuthenticatedFeature_announcementAdminSystemSettingsFieldsRoute;
  "/_authenticated/_feature_announcement/admin/system/settings/sso": typeof AuthenticatedFeature_announcementAdminSystemSettingsSsoRoute;
  "/_authenticated/_feature_announcement/admin/system/users/import": typeof AuthenticatedFeature_announcementAdminSystemUsersImportRoute;
  "/_authenticated/_feature_announcement/admin/system/users/list": typeof AuthenticatedFeature_announcementAdminSystemUsersListRoute;
  "/_authenticated/_feature_announcement/admin/system/users/merge": typeof AuthenticatedFeature_announcementAdminSystemUsersMergeRoute;
  "/_authenticated/_feature_announcement/admin/system/users/new": typeof AuthenticatedFeature_announcementAdminSystemUsersNewRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/budgeting/manage": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingManageRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/budgeting/overview": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingOverviewRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/budgeting/request": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRequestRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/events/pending": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsPendingRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/manage/archives": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageArchivesRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/manage/community-lab-report": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunityLabReportRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/manage/review_settings": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageReview_settingsRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/manage/role_configuration": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRole_configurationRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/manage/settings": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsRouteWithChildren;
  "/_authenticated/_feature_announcement/communities/$communityId/members/invitations": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersInvitationsRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/plan/budgeting": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRouteWithChildren;
  "/_authenticated/_feature_announcement/communities/$communityId/plan/events": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanEventsRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/roi-suite/$": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdRoiSuiteSplatRoute;
  "/_authenticated/_feature_announcement/_user/events/drafts/": typeof AuthenticatedFeature_announcementUserEventsDraftsIndexRoute;
  "/_authenticated/_feature_announcement/_user/global-survey-response/$surveyId/": typeof AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdIndexRoute;
  "/_authenticated/_feature_announcement/_user/posts/drafts/": typeof AuthenticatedFeature_announcementUserPostsDraftsIndexRoute;
  "/_authenticated/_feature_announcement/_user/user/$userId/": typeof AuthenticatedFeature_announcementUserUserUserIdIndexRoute;
  "/_authenticated/_feature_announcement/admin/analyze/groups/": typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsIndexRoute;
  "/_authenticated/_feature_announcement/admin/analyze/users/": typeof AuthenticatedFeature_announcementAdminAnalyzeUsersIndexRoute;
  "/_authenticated/_feature_announcement/admin/gamification/achievements/": typeof AuthenticatedFeature_announcementAdminGamificationAchievementsIndexRoute;
  "/_authenticated/_feature_announcement/admin/gamification/rewards/": typeof AuthenticatedFeature_announcementAdminGamificationRewardsIndexRoute;
  "/_authenticated/_feature_announcement/admin/manage/calendar/": typeof AuthenticatedFeature_announcementAdminManageCalendarIndexRoute;
  "/_authenticated/_feature_announcement/admin/manage/communications/": typeof AuthenticatedFeature_announcementAdminManageCommunicationsIndexRoute;
  "/_authenticated/_feature_announcement/admin/manage/groups/": typeof AuthenticatedFeature_announcementAdminManageGroupsIndexRoute;
  "/_authenticated/_feature_announcement/admin/manage/segments/": typeof AuthenticatedFeature_announcementAdminManageSegmentsIndexRoute;
  "/_authenticated/_feature_announcement/admin/plan/budgeting/": typeof AuthenticatedFeature_announcementAdminPlanBudgetingIndexRoute;
  "/_authenticated/_feature_announcement/admin/system/integrations/": typeof AuthenticatedFeature_announcementAdminSystemIntegrationsIndexRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/events/": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsIndexRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/members/": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersIndexRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/posts/": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPostsIndexRoute;
  "/_authenticated/_feature_announcement/_user/global-survey-response/$surveyId/cohorts/$cohortId": typeof AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdCohortsCohortIdRoute;
  "/_authenticated/_feature_announcement/_user/profile/edit/record-hours/$communityId": typeof AuthenticatedFeature_announcementUserProfileEditRecordHoursCommunityIdRoute;
  "/_authenticated/_feature_announcement/admin/gamification/achievements/$achievementId/edit": typeof AuthenticatedFeature_announcementAdminGamificationAchievementsAchievementIdEditRoute;
  "/_authenticated/_feature_announcement/admin/gamification/rewards/$rewardId/edit": typeof AuthenticatedFeature_announcementAdminGamificationRewardsRewardIdEditRoute;
  "/_authenticated/_feature_announcement/admin/manage/calendar/$calendarId/update": typeof AuthenticatedFeature_announcementAdminManageCalendarCalendarIdUpdateRoute;
  "/_authenticated/_feature_announcement/admin/manage/communications/$communicationId/distributions": typeof AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdDistributionsRoute;
  "/_authenticated/_feature_announcement/admin/manage/communications/$communicationId/edit": typeof AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdEditRoute;
  "/_authenticated/_feature_announcement/admin/manage/communications/$communicationId/recipients": typeof AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdRecipientsRoute;
  "/_authenticated/_feature_announcement/admin/manage/events/notable_dates_calendar/create": typeof AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCreateRoute;
  "/_authenticated/_feature_announcement/admin/manage/groups/$groupId/categorize": typeof AuthenticatedFeature_announcementAdminManageGroupsGroupIdCategorizeRoute;
  "/_authenticated/_feature_announcement/admin/manage/groups/$groupId/edit": typeof AuthenticatedFeature_announcementAdminManageGroupsGroupIdEditRoute;
  "/_authenticated/_feature_announcement/admin/manage/groups/categories/new": typeof AuthenticatedFeature_announcementAdminManageGroupsCategoriesNewRoute;
  "/_authenticated/_feature_announcement/admin/manage/segments/$segmentId/edit": typeof AuthenticatedFeature_announcementAdminManageSegmentsSegmentIdEditRoute;
  "/_authenticated/_feature_announcement/admin/plan/budgeting/fiscal_periods/new": typeof AuthenticatedFeature_announcementAdminPlanBudgetingFiscal_periodsNewRoute;
  "/_authenticated/_feature_announcement/admin/system/branding/sponsors/new": typeof AuthenticatedFeature_announcementAdminSystemBrandingSponsorsNewRoute;
  "/_authenticated/_feature_announcement/admin/system/settings/_configuration/communities": typeof AuthenticatedFeature_announcementAdminSystemSettingsConfigurationCommunitiesRoute;
  "/_authenticated/_feature_announcement/admin/system/settings/_configuration/configuration": typeof AuthenticatedFeature_announcementAdminSystemSettingsConfigurationConfigurationRoute;
  "/_authenticated/_feature_announcement/admin/system/settings/_configuration/modules": typeof AuthenticatedFeature_announcementAdminSystemSettingsConfigurationModulesRoute;
  "/_authenticated/_feature_announcement/admin/system/settings/_configuration/profile_fields": typeof AuthenticatedFeature_announcementAdminSystemSettingsConfigurationProfile_fieldsRoute;
  "/_authenticated/_feature_announcement/admin/system/settings/policy_documents/new": typeof AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsNewRoute;
  "/_authenticated/_feature_announcement/admin/system/users/$userId/edit": typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdEditRouteWithChildren;
  "/_authenticated/_feature_announcement/admin/system/users/$userId/role_assignments": typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdRole_assignmentsRoute;
  "/_authenticated/_feature_announcement/admin/system/users/$userId/statistics": typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdStatisticsRoute;
  "/_authenticated/_feature_announcement/admin/system/users/roles/new": typeof AuthenticatedFeature_announcementAdminSystemUsersRolesNewRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/events/$eventId/edit": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdEditRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/manage/communications/new": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsNewRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/manage/events/pending": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageEventsPendingRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/manage/leaders/new": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersNewRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/manage/settings/integration": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsIntegrationRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/manage/settings/welcome_message": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsWelcome_messageRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/manage/sponsors/new": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsNewRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/manage/surveys/new": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysNewRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/members/automations/new": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsNewRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/plan/budgeting/manage": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingManageRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/plan/budgeting/overview": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingOverviewRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/plan/budgeting/request": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRequestRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/plan/outcomes/new": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesNewRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/plan/pillars/new": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsNewRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/posts/$postId/edit": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPostsPostIdEditRoute;
  "/_authenticated/_feature_announcement/_user/network-survey-response/$networkId/$surveyId/": typeof AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdIndexRoute;
  "/_authenticated/_feature_announcement/admin/manage/events/notable_dates_calendar/": typeof AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarIndexRoute;
  "/_authenticated/_feature_announcement/admin/manage/groups/categories/": typeof AuthenticatedFeature_announcementAdminManageGroupsCategoriesIndexRoute;
  "/_authenticated/_feature_announcement/admin/system/branding/sponsors/": typeof AuthenticatedFeature_announcementAdminSystemBrandingSponsorsIndexRoute;
  "/_authenticated/_feature_announcement/admin/system/roles/community/": typeof AuthenticatedFeature_announcementAdminSystemRolesCommunityIndexRoute;
  "/_authenticated/_feature_announcement/admin/system/roles/platform/": typeof AuthenticatedFeature_announcementAdminSystemRolesPlatformIndexRoute;
  "/_authenticated/_feature_announcement/admin/system/settings/emails/": typeof AuthenticatedFeature_announcementAdminSystemSettingsEmailsIndexRoute;
  "/_authenticated/_feature_announcement/admin/system/settings/policy_documents/": typeof AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsIndexRoute;
  "/_authenticated/_feature_announcement/admin/system/users/$userId/": typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdIndexRoute;
  "/_authenticated/_feature_announcement/admin/system/users/policy_templates/": typeof AuthenticatedFeature_announcementAdminSystemUsersPolicy_templatesIndexRoute;
  "/_authenticated/_feature_announcement/admin/system/users/roles/": typeof AuthenticatedFeature_announcementAdminSystemUsersRolesIndexRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/events/$eventId/": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdIndexRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/manage/communications/": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsIndexRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/manage/leaders/": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersIndexRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/manage/settings/": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsIndexRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/manage/sponsors/": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsIndexRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/manage/surveys/": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysIndexRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/members/automations/": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsIndexRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/plan/outcomes/": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesIndexRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/plan/pillars/": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsIndexRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/posts/$postId/": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPostsPostIdIndexRoute;
  "/_authenticated/_feature_announcement/_user/network-survey-response/$networkId/$surveyId/cohorts/$cohortId": typeof AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdCohortsCohortIdRoute;
  "/_authenticated/_feature_announcement/admin/manage/calendar/$calendarId/notable_dates/create": typeof AuthenticatedFeature_announcementAdminManageCalendarCalendarIdNotable_datesCreateRoute;
  "/_authenticated/_feature_announcement/admin/manage/events/notable_dates_calendar/$calendarId/update": typeof AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdUpdateRoute;
  "/_authenticated/_feature_announcement/admin/manage/groups/$groupId/regions/new": typeof AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsNewRoute;
  "/_authenticated/_feature_announcement/admin/manage/groups/categories/$categoryId/edit": typeof AuthenticatedFeature_announcementAdminManageGroupsCategoriesCategoryIdEditRoute;
  "/_authenticated/_feature_announcement/admin/system/branding/sponsors/$sponsorId/edit": typeof AuthenticatedFeature_announcementAdminSystemBrandingSponsorsSponsorIdEditRoute;
  "/_authenticated/_feature_announcement/admin/system/roles/community/$roleId/permissions": typeof AuthenticatedFeature_announcementAdminSystemRolesCommunityRoleIdPermissionsRoute;
  "/_authenticated/_feature_announcement/admin/system/roles/platform/$roleId/permissions": typeof AuthenticatedFeature_announcementAdminSystemRolesPlatformRoleIdPermissionsRoute;
  "/_authenticated/_feature_announcement/admin/system/settings/emails/$emailId/edit": typeof AuthenticatedFeature_announcementAdminSystemSettingsEmailsEmailIdEditRoute;
  "/_authenticated/_feature_announcement/admin/system/settings/policy_documents/edit/$policyDocumentId": typeof AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsEditPolicyDocumentIdRoute;
  "/_authenticated/_feature_announcement/admin/system/users/$userId/edit/fields": typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdEditFieldsRoute;
  "/_authenticated/_feature_announcement/admin/system/users/$userId/edit/general": typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdEditGeneralRoute;
  "/_authenticated/_feature_announcement/admin/system/users/policy_templates/$policyId/edit": typeof AuthenticatedFeature_announcementAdminSystemUsersPolicy_templatesPolicyIdEditRoute;
  "/_authenticated/_feature_announcement/admin/system/users/roles/$roleId/edit": typeof AuthenticatedFeature_announcementAdminSystemUsersRolesRoleIdEditRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/events/$eventId/manage/attendees": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageAttendeesRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/events/$eventId/manage/budgeting": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageBudgetingRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/events/$eventId/manage/waitlist": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageWaitlistRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/manage/communications/$communicationId/distributions": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdDistributionsRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/manage/communications/$communicationId/edit": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdEditRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/manage/communications/$communicationId/recipients": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdRecipientsRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/manage/leaders/$leaderId/edit": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersLeaderIdEditRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/manage/sponsors/$sponsorId/edit": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsSponsorIdEditRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/manage/surveys/$surveyId/edit": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysSurveyIdEditRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/manage/surveys/$surveyId/responses": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysSurveyIdResponsesRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/members/automations/$ruleId/edit": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRuleIdEditRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/members/automations/history/$runId": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsHistoryRunIdRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/plan/outcomes/$outcomeId/edit": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesOutcomeIdEditRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/plan/pillars/$pillarId/edit": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsPillarIdEditRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/plan/pillars/$pillarId/events": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsPillarIdEventsRoute;
  "/_authenticated/_feature_announcement/admin/manage/groups/$groupId/regions/": typeof AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsIndexRoute;
  "/_authenticated/_feature_announcement/admin/system/roles/community/$roleId/": typeof AuthenticatedFeature_announcementAdminSystemRolesCommunityRoleIdIndexRoute;
  "/_authenticated/_feature_announcement/admin/system/roles/platform/$roleId/": typeof AuthenticatedFeature_announcementAdminSystemRolesPlatformRoleIdIndexRoute;
  "/_authenticated/_feature_announcement/communities/$communityId/members/automations/history/": typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsHistoryIndexRoute;
  "/_authenticated/_feature_announcement/admin/manage/calendar/$calendarId/notable_dates/$eventId/update": typeof AuthenticatedFeature_announcementAdminManageCalendarCalendarIdNotable_datesEventIdUpdateRoute;
  "/_authenticated/_feature_announcement/admin/manage/events/notable_dates_calendar/$calendarId/notable_dates/create": typeof AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdNotable_datesCreateRoute;
  "/_authenticated/_feature_announcement/admin/manage/groups/$groupId/regions/$regionId/edit": typeof AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsRegionIdEditRoute;
  "/_authenticated/_feature_announcement/admin/manage/events/notable_dates_calendar/$calendarId/notable_dates/$eventId/update": typeof AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdNotable_datesEventIdUpdateRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/auto-login"
    | "/enrollment"
    | "/onboarding"
    | "/sign_up"
    | "/mobile_sign_in"
    | "/unsubscribe"
    | "/forgot"
    | "/enrollment/complete"
    | "/enrollment/discover"
    | "/enrollment/profile"
    | "/enrollment/"
    | "/event_checkin/$eventId"
    | "/verify/$token"
    | "/admin"
    | "/login/activate"
    | "/login/admin"
    | "/login/credentials"
    | "/password_reset/$token"
    | "/cms/"
    | "/login/"
    | "/password_reset/"
    | "/communities"
    | "/downloads"
    | "/groups"
    | "/notifications"
    | "/profile"
    | "/rewards"
    | "/support"
    | "/admin/support-config"
    | "/admin/system"
    | "/communities/$communityId"
    | "/open_invitations/$openInvitationId"
    | "/cms/review/comment_moderation"
    | "/cms/tools/review_settings"
    | "/communities/$communityId/members"
    | "/community-lab/$"
    | "/community-lab/session"
    | "/community-lab/worksheet"
    | "/global-survey-response/$surveyId"
    | "/profile/statistics"
    | "/admin/analyze/community-lab-report"
    | "/admin/analyze/groups"
    | "/admin/analyze/reports"
    | "/admin/analyze/segments"
    | "/admin/analyze/users"
    | "/admin/gamification/rewards"
    | "/admin/manage/archived"
    | "/admin/manage/events"
    | "/admin/manage/folders"
    | "/admin/manage/labels"
    | "/admin/manage/leaders"
    | "/admin/manage/tags"
    | "/admin/plan/aggregate_budgeting"
    | "/admin/surveys/new"
    | "/admin/system/api_access_tokens"
    | "/admin/system/branding"
    | "/admin/system/integrations"
    | "/admin/system/logs"
    | "/admin/system/mcp_connector"
    | "/admin/system/roles"
    | "/admin/system/settings"
    | "/admin/system/users"
    | "/communities/$communityId/budgeting"
    | "/communities/$communityId/chapters"
    | "/communities/$communityId/folders"
    | "/communities/$communityId/manage"
    | "/communities/$communityId/plan"
    | "/groups/$groupId/$"
    | "/invitations/$invitationId/accept"
    | "/invitations/$invitationId/decline"
    | "/regions/$regionId/$"
    | "/cms/manage/communications/$draftId"
    | "/cms/manage/events/$draftId"
    | "/cms/manage/events/new"
    | "/cms/manage/posts/$draftId"
    | "/cms/manage/publication_requests/$publicationRequestId"
    | "/cms/review/publication_requests/$publicationRequestId"
    | "/community-lab/"
    | "/events/"
    | "/posts/"
    | "/profile/"
    | "/admin/analyze/"
    | "/admin/context-backfill/"
    | "/admin/surveys/"
    | "/communities/$communityId/"
    | "/cms/manage/communications/"
    | "/cms/manage/events/"
    | "/cms/manage/posts/"
    | "/cms/manage/publication_requests/"
    | "/cms/review/publication_requests/"
    | "/communities/$communityId/members/automations"
    | "/enterprises/$enterpriseId/folders/$folderId/resources"
    | "/groups/$groupId/folders/$folderId/resources"
    | "/groups/$groupId/news/$type/$postId"
    | "/regions/$regionId/news/$type/$postId"
    | "/events/$eventId/$"
    | "/events/drafts/$draftId"
    | "/events/drafts/new"
    | "/network-survey-response/$networkId/$surveyId"
    | "/posts/$postId/$"
    | "/posts/drafts/$draftId"
    | "/profile/edit/accessibility"
    | "/profile/edit/engagement-report"
    | "/profile/edit/general"
    | "/profile/edit/leadership"
    | "/profile/edit/notification"
    | "/profile/edit/outlook"
    | "/profile/edit/private"
    | "/user/$userId/achievements"
    | "/user/$userId/edit"
    | "/user/$userId/statistics"
    | "/user/$userId/transactions"
    | "/admin/analyze/dashboards/$"
    | "/admin/analyze/groups/events"
    | "/admin/analyze/groups/posts"
    | "/admin/analyze/groups/resources"
    | "/admin/analyze/groups/users"
    | "/admin/analyze/roi-suite/$"
    | "/admin/analyze/users/events"
    | "/admin/gamification/achievements/new"
    | "/admin/gamification/points/manage"
    | "/admin/gamification/rewards/new"
    | "/admin/gamification/rewards/pending"
    | "/admin/manage/calendar/create"
    | "/admin/manage/communications/new"
    | "/admin/manage/events/calendar"
    | "/admin/manage/events/configuration"
    | "/admin/manage/events/questionnaire"
    | "/admin/manage/groups/connections"
    | "/admin/manage/groups/leader_positions"
    | "/admin/manage/groups/new"
    | "/admin/manage/segments/new"
    | "/admin/surveys/$surveyId/edit"
    | "/admin/surveys/$surveyId/responses"
    | "/admin/system/branding/colors"
    | "/admin/system/branding/home"
    | "/admin/system/branding/logos"
    | "/admin/system/branding/theme"
    | "/admin/system/integrations/mentorcliq"
    | "/admin/system/integrations/outlook"
    | "/admin/system/integrations/simpplr"
    | "/admin/system/integrations/slack"
    | "/admin/system/integrations/teams"
    | "/admin/system/integrations/ukg"
    | "/admin/system/integrations/viva-engage"
    | "/admin/system/roles/role_configuration"
    | "/admin/system/settings/custom_texts"
    | "/admin/system/settings/fields"
    | "/admin/system/settings/sso"
    | "/admin/system/users/import"
    | "/admin/system/users/list"
    | "/admin/system/users/merge"
    | "/admin/system/users/new"
    | "/communities/$communityId/budgeting/manage"
    | "/communities/$communityId/budgeting/overview"
    | "/communities/$communityId/budgeting/request"
    | "/communities/$communityId/events/pending"
    | "/communities/$communityId/manage/archives"
    | "/communities/$communityId/manage/community-lab-report"
    | "/communities/$communityId/manage/review_settings"
    | "/communities/$communityId/manage/role_configuration"
    | "/communities/$communityId/manage/settings"
    | "/communities/$communityId/members/invitations"
    | "/communities/$communityId/plan/budgeting"
    | "/communities/$communityId/plan/events"
    | "/communities/$communityId/roi-suite/$"
    | "/events/drafts/"
    | "/global-survey-response/$surveyId/"
    | "/posts/drafts/"
    | "/user/$userId/"
    | "/admin/analyze/groups/"
    | "/admin/analyze/users/"
    | "/admin/gamification/achievements/"
    | "/admin/gamification/rewards/"
    | "/admin/manage/calendar/"
    | "/admin/manage/communications/"
    | "/admin/manage/groups/"
    | "/admin/manage/segments/"
    | "/admin/plan/budgeting/"
    | "/admin/system/integrations/"
    | "/communities/$communityId/events/"
    | "/communities/$communityId/members/"
    | "/communities/$communityId/posts/"
    | "/global-survey-response/$surveyId/cohorts/$cohortId"
    | "/profile/edit/record-hours/$communityId"
    | "/admin/gamification/achievements/$achievementId/edit"
    | "/admin/gamification/rewards/$rewardId/edit"
    | "/admin/manage/calendar/$calendarId/update"
    | "/admin/manage/communications/$communicationId/distributions"
    | "/admin/manage/communications/$communicationId/edit"
    | "/admin/manage/communications/$communicationId/recipients"
    | "/admin/manage/events/notable_dates_calendar/create"
    | "/admin/manage/groups/$groupId/categorize"
    | "/admin/manage/groups/$groupId/edit"
    | "/admin/manage/groups/categories/new"
    | "/admin/manage/segments/$segmentId/edit"
    | "/admin/plan/budgeting/fiscal_periods/new"
    | "/admin/system/branding/sponsors/new"
    | "/admin/system/settings/communities"
    | "/admin/system/settings/configuration"
    | "/admin/system/settings/modules"
    | "/admin/system/settings/profile_fields"
    | "/admin/system/settings/policy_documents/new"
    | "/admin/system/users/$userId/edit"
    | "/admin/system/users/$userId/role_assignments"
    | "/admin/system/users/$userId/statistics"
    | "/admin/system/users/roles/new"
    | "/communities/$communityId/events/$eventId/edit"
    | "/communities/$communityId/manage/communications/new"
    | "/communities/$communityId/manage/events/pending"
    | "/communities/$communityId/manage/leaders/new"
    | "/communities/$communityId/manage/settings/integration"
    | "/communities/$communityId/manage/settings/welcome_message"
    | "/communities/$communityId/manage/sponsors/new"
    | "/communities/$communityId/manage/surveys/new"
    | "/communities/$communityId/members/automations/new"
    | "/communities/$communityId/plan/budgeting/manage"
    | "/communities/$communityId/plan/budgeting/overview"
    | "/communities/$communityId/plan/budgeting/request"
    | "/communities/$communityId/plan/outcomes/new"
    | "/communities/$communityId/plan/pillars/new"
    | "/communities/$communityId/posts/$postId/edit"
    | "/network-survey-response/$networkId/$surveyId/"
    | "/admin/manage/events/notable_dates_calendar/"
    | "/admin/manage/groups/categories/"
    | "/admin/system/branding/sponsors/"
    | "/admin/system/roles/community/"
    | "/admin/system/roles/platform/"
    | "/admin/system/settings/emails/"
    | "/admin/system/settings/policy_documents/"
    | "/admin/system/users/$userId/"
    | "/admin/system/users/policy_templates/"
    | "/admin/system/users/roles/"
    | "/communities/$communityId/events/$eventId/"
    | "/communities/$communityId/manage/communications/"
    | "/communities/$communityId/manage/leaders/"
    | "/communities/$communityId/manage/settings/"
    | "/communities/$communityId/manage/sponsors/"
    | "/communities/$communityId/manage/surveys/"
    | "/communities/$communityId/members/automations/"
    | "/communities/$communityId/plan/outcomes/"
    | "/communities/$communityId/plan/pillars/"
    | "/communities/$communityId/posts/$postId/"
    | "/network-survey-response/$networkId/$surveyId/cohorts/$cohortId"
    | "/admin/manage/calendar/$calendarId/notable_dates/create"
    | "/admin/manage/events/notable_dates_calendar/$calendarId/update"
    | "/admin/manage/groups/$groupId/regions/new"
    | "/admin/manage/groups/categories/$categoryId/edit"
    | "/admin/system/branding/sponsors/$sponsorId/edit"
    | "/admin/system/roles/community/$roleId/permissions"
    | "/admin/system/roles/platform/$roleId/permissions"
    | "/admin/system/settings/emails/$emailId/edit"
    | "/admin/system/settings/policy_documents/edit/$policyDocumentId"
    | "/admin/system/users/$userId/edit/fields"
    | "/admin/system/users/$userId/edit/general"
    | "/admin/system/users/policy_templates/$policyId/edit"
    | "/admin/system/users/roles/$roleId/edit"
    | "/communities/$communityId/events/$eventId/manage/attendees"
    | "/communities/$communityId/events/$eventId/manage/budgeting"
    | "/communities/$communityId/events/$eventId/manage/waitlist"
    | "/communities/$communityId/manage/communications/$communicationId/distributions"
    | "/communities/$communityId/manage/communications/$communicationId/edit"
    | "/communities/$communityId/manage/communications/$communicationId/recipients"
    | "/communities/$communityId/manage/leaders/$leaderId/edit"
    | "/communities/$communityId/manage/sponsors/$sponsorId/edit"
    | "/communities/$communityId/manage/surveys/$surveyId/edit"
    | "/communities/$communityId/manage/surveys/$surveyId/responses"
    | "/communities/$communityId/members/automations/$ruleId/edit"
    | "/communities/$communityId/members/automations/history/$runId"
    | "/communities/$communityId/plan/outcomes/$outcomeId/edit"
    | "/communities/$communityId/plan/pillars/$pillarId/edit"
    | "/communities/$communityId/plan/pillars/$pillarId/events"
    | "/admin/manage/groups/$groupId/regions/"
    | "/admin/system/roles/community/$roleId/"
    | "/admin/system/roles/platform/$roleId/"
    | "/communities/$communityId/members/automations/history/"
    | "/admin/manage/calendar/$calendarId/notable_dates/$eventId/update"
    | "/admin/manage/events/notable_dates_calendar/$calendarId/notable_dates/create"
    | "/admin/manage/groups/$groupId/regions/$regionId/edit"
    | "/admin/manage/events/notable_dates_calendar/$calendarId/notable_dates/$eventId/update";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/auto-login"
    | "/onboarding"
    | "/sign_up"
    | "/mobile_sign_in"
    | "/unsubscribe"
    | "/forgot"
    | "/enrollment/complete"
    | "/enrollment/discover"
    | "/enrollment/profile"
    | "/enrollment"
    | "/event_checkin/$eventId"
    | "/verify/$token"
    | "/admin"
    | "/login/activate"
    | "/login/admin"
    | "/login/credentials"
    | "/password_reset/$token"
    | "/cms"
    | "/login"
    | "/password_reset"
    | "/communities"
    | "/downloads"
    | "/groups"
    | "/notifications"
    | "/rewards"
    | "/support"
    | "/admin/support-config"
    | "/admin/system"
    | "/open_invitations/$openInvitationId"
    | "/cms/review/comment_moderation"
    | "/cms/tools/review_settings"
    | "/community-lab/$"
    | "/community-lab/session"
    | "/community-lab/worksheet"
    | "/profile/statistics"
    | "/admin/analyze/community-lab-report"
    | "/admin/analyze/reports"
    | "/admin/analyze/segments"
    | "/admin/manage/archived"
    | "/admin/manage/events"
    | "/admin/manage/folders"
    | "/admin/manage/labels"
    | "/admin/manage/leaders"
    | "/admin/manage/tags"
    | "/admin/plan/aggregate_budgeting"
    | "/admin/surveys/new"
    | "/admin/system/api_access_tokens"
    | "/admin/system/branding"
    | "/admin/system/logs"
    | "/admin/system/mcp_connector"
    | "/admin/system/roles"
    | "/admin/system/settings"
    | "/admin/system/users"
    | "/communities/$communityId/budgeting"
    | "/communities/$communityId/chapters"
    | "/communities/$communityId/folders"
    | "/communities/$communityId/manage"
    | "/communities/$communityId/plan"
    | "/groups/$groupId/$"
    | "/invitations/$invitationId/accept"
    | "/invitations/$invitationId/decline"
    | "/regions/$regionId/$"
    | "/cms/manage/communications/$draftId"
    | "/cms/manage/events/$draftId"
    | "/cms/manage/events/new"
    | "/cms/manage/posts/$draftId"
    | "/cms/manage/publication_requests/$publicationRequestId"
    | "/cms/review/publication_requests/$publicationRequestId"
    | "/community-lab"
    | "/events"
    | "/posts"
    | "/profile"
    | "/admin/analyze"
    | "/admin/context-backfill"
    | "/admin/surveys"
    | "/communities/$communityId"
    | "/cms/manage/communications"
    | "/cms/manage/events"
    | "/cms/manage/posts"
    | "/cms/manage/publication_requests"
    | "/cms/review/publication_requests"
    | "/enterprises/$enterpriseId/folders/$folderId/resources"
    | "/groups/$groupId/folders/$folderId/resources"
    | "/groups/$groupId/news/$type/$postId"
    | "/regions/$regionId/news/$type/$postId"
    | "/events/$eventId/$"
    | "/events/drafts/$draftId"
    | "/events/drafts/new"
    | "/posts/$postId/$"
    | "/posts/drafts/$draftId"
    | "/profile/edit/accessibility"
    | "/profile/edit/engagement-report"
    | "/profile/edit/general"
    | "/profile/edit/leadership"
    | "/profile/edit/notification"
    | "/profile/edit/outlook"
    | "/profile/edit/private"
    | "/user/$userId/achievements"
    | "/user/$userId/edit"
    | "/user/$userId/statistics"
    | "/user/$userId/transactions"
    | "/admin/analyze/dashboards/$"
    | "/admin/analyze/groups/events"
    | "/admin/analyze/groups/posts"
    | "/admin/analyze/groups/resources"
    | "/admin/analyze/groups/users"
    | "/admin/analyze/roi-suite/$"
    | "/admin/analyze/users/events"
    | "/admin/gamification/achievements/new"
    | "/admin/gamification/points/manage"
    | "/admin/gamification/rewards/new"
    | "/admin/gamification/rewards/pending"
    | "/admin/manage/calendar/create"
    | "/admin/manage/communications/new"
    | "/admin/manage/events/calendar"
    | "/admin/manage/events/configuration"
    | "/admin/manage/events/questionnaire"
    | "/admin/manage/groups/connections"
    | "/admin/manage/groups/leader_positions"
    | "/admin/manage/groups/new"
    | "/admin/manage/segments/new"
    | "/admin/surveys/$surveyId/edit"
    | "/admin/surveys/$surveyId/responses"
    | "/admin/system/branding/colors"
    | "/admin/system/branding/home"
    | "/admin/system/branding/logos"
    | "/admin/system/branding/theme"
    | "/admin/system/integrations/mentorcliq"
    | "/admin/system/integrations/outlook"
    | "/admin/system/integrations/simpplr"
    | "/admin/system/integrations/slack"
    | "/admin/system/integrations/teams"
    | "/admin/system/integrations/ukg"
    | "/admin/system/integrations/viva-engage"
    | "/admin/system/roles/role_configuration"
    | "/admin/system/settings/custom_texts"
    | "/admin/system/settings/fields"
    | "/admin/system/settings/sso"
    | "/admin/system/users/import"
    | "/admin/system/users/list"
    | "/admin/system/users/merge"
    | "/admin/system/users/new"
    | "/communities/$communityId/budgeting/manage"
    | "/communities/$communityId/budgeting/overview"
    | "/communities/$communityId/budgeting/request"
    | "/communities/$communityId/events/pending"
    | "/communities/$communityId/manage/archives"
    | "/communities/$communityId/manage/community-lab-report"
    | "/communities/$communityId/manage/review_settings"
    | "/communities/$communityId/manage/role_configuration"
    | "/communities/$communityId/members/invitations"
    | "/communities/$communityId/plan/budgeting"
    | "/communities/$communityId/plan/events"
    | "/communities/$communityId/roi-suite/$"
    | "/events/drafts"
    | "/global-survey-response/$surveyId"
    | "/posts/drafts"
    | "/user/$userId"
    | "/admin/analyze/groups"
    | "/admin/analyze/users"
    | "/admin/gamification/achievements"
    | "/admin/gamification/rewards"
    | "/admin/manage/calendar"
    | "/admin/manage/communications"
    | "/admin/manage/groups"
    | "/admin/manage/segments"
    | "/admin/plan/budgeting"
    | "/admin/system/integrations"
    | "/communities/$communityId/events"
    | "/communities/$communityId/members"
    | "/communities/$communityId/posts"
    | "/global-survey-response/$surveyId/cohorts/$cohortId"
    | "/profile/edit/record-hours/$communityId"
    | "/admin/gamification/achievements/$achievementId/edit"
    | "/admin/gamification/rewards/$rewardId/edit"
    | "/admin/manage/calendar/$calendarId/update"
    | "/admin/manage/communications/$communicationId/distributions"
    | "/admin/manage/communications/$communicationId/edit"
    | "/admin/manage/communications/$communicationId/recipients"
    | "/admin/manage/events/notable_dates_calendar/create"
    | "/admin/manage/groups/$groupId/categorize"
    | "/admin/manage/groups/$groupId/edit"
    | "/admin/manage/groups/categories/new"
    | "/admin/manage/segments/$segmentId/edit"
    | "/admin/plan/budgeting/fiscal_periods/new"
    | "/admin/system/branding/sponsors/new"
    | "/admin/system/settings/communities"
    | "/admin/system/settings/configuration"
    | "/admin/system/settings/modules"
    | "/admin/system/settings/profile_fields"
    | "/admin/system/settings/policy_documents/new"
    | "/admin/system/users/$userId/edit"
    | "/admin/system/users/$userId/role_assignments"
    | "/admin/system/users/$userId/statistics"
    | "/admin/system/users/roles/new"
    | "/communities/$communityId/events/$eventId/edit"
    | "/communities/$communityId/manage/communications/new"
    | "/communities/$communityId/manage/events/pending"
    | "/communities/$communityId/manage/leaders/new"
    | "/communities/$communityId/manage/settings/integration"
    | "/communities/$communityId/manage/settings/welcome_message"
    | "/communities/$communityId/manage/sponsors/new"
    | "/communities/$communityId/manage/surveys/new"
    | "/communities/$communityId/members/automations/new"
    | "/communities/$communityId/plan/budgeting/manage"
    | "/communities/$communityId/plan/budgeting/overview"
    | "/communities/$communityId/plan/budgeting/request"
    | "/communities/$communityId/plan/outcomes/new"
    | "/communities/$communityId/plan/pillars/new"
    | "/communities/$communityId/posts/$postId/edit"
    | "/network-survey-response/$networkId/$surveyId"
    | "/admin/manage/events/notable_dates_calendar"
    | "/admin/manage/groups/categories"
    | "/admin/system/branding/sponsors"
    | "/admin/system/roles/community"
    | "/admin/system/roles/platform"
    | "/admin/system/settings/emails"
    | "/admin/system/settings/policy_documents"
    | "/admin/system/users/$userId"
    | "/admin/system/users/policy_templates"
    | "/admin/system/users/roles"
    | "/communities/$communityId/events/$eventId"
    | "/communities/$communityId/manage/communications"
    | "/communities/$communityId/manage/leaders"
    | "/communities/$communityId/manage/settings"
    | "/communities/$communityId/manage/sponsors"
    | "/communities/$communityId/manage/surveys"
    | "/communities/$communityId/members/automations"
    | "/communities/$communityId/plan/outcomes"
    | "/communities/$communityId/plan/pillars"
    | "/communities/$communityId/posts/$postId"
    | "/network-survey-response/$networkId/$surveyId/cohorts/$cohortId"
    | "/admin/manage/calendar/$calendarId/notable_dates/create"
    | "/admin/manage/events/notable_dates_calendar/$calendarId/update"
    | "/admin/manage/groups/$groupId/regions/new"
    | "/admin/manage/groups/categories/$categoryId/edit"
    | "/admin/system/branding/sponsors/$sponsorId/edit"
    | "/admin/system/roles/community/$roleId/permissions"
    | "/admin/system/roles/platform/$roleId/permissions"
    | "/admin/system/settings/emails/$emailId/edit"
    | "/admin/system/settings/policy_documents/edit/$policyDocumentId"
    | "/admin/system/users/$userId/edit/fields"
    | "/admin/system/users/$userId/edit/general"
    | "/admin/system/users/policy_templates/$policyId/edit"
    | "/admin/system/users/roles/$roleId/edit"
    | "/communities/$communityId/events/$eventId/manage/attendees"
    | "/communities/$communityId/events/$eventId/manage/budgeting"
    | "/communities/$communityId/events/$eventId/manage/waitlist"
    | "/communities/$communityId/manage/communications/$communicationId/distributions"
    | "/communities/$communityId/manage/communications/$communicationId/edit"
    | "/communities/$communityId/manage/communications/$communicationId/recipients"
    | "/communities/$communityId/manage/leaders/$leaderId/edit"
    | "/communities/$communityId/manage/sponsors/$sponsorId/edit"
    | "/communities/$communityId/manage/surveys/$surveyId/edit"
    | "/communities/$communityId/manage/surveys/$surveyId/responses"
    | "/communities/$communityId/members/automations/$ruleId/edit"
    | "/communities/$communityId/members/automations/history/$runId"
    | "/communities/$communityId/plan/outcomes/$outcomeId/edit"
    | "/communities/$communityId/plan/pillars/$pillarId/edit"
    | "/communities/$communityId/plan/pillars/$pillarId/events"
    | "/admin/manage/groups/$groupId/regions"
    | "/admin/system/roles/community/$roleId"
    | "/admin/system/roles/platform/$roleId"
    | "/communities/$communityId/members/automations/history"
    | "/admin/manage/calendar/$calendarId/notable_dates/$eventId/update"
    | "/admin/manage/events/notable_dates_calendar/$calendarId/notable_dates/create"
    | "/admin/manage/groups/$groupId/regions/$regionId/edit"
    | "/admin/manage/events/notable_dates_calendar/$calendarId/notable_dates/$eventId/update";
  id:
    | "__root__"
    | "/_anonymous"
    | "/_authenticated"
    | "/_cms"
    | "/_session"
    | "/auto-login"
    | "/enrollment"
    | "/(compatibility)/onboarding"
    | "/(compatibility)/sign_up"
    | "/_anonymous/mobile_sign_in"
    | "/_anonymous/unsubscribe"
    | "/_authenticated/_feature_announcement"
    | "/_session/forgot"
    | "/enrollment/complete"
    | "/enrollment/discover"
    | "/enrollment/profile"
    | "/enrollment/"
    | "/_anonymous/event_checkin/$eventId"
    | "/_anonymous/verify/$token"
    | "/_authenticated/_feature_announcement/_user"
    | "/_authenticated/_feature_announcement/admin"
    | "/_session/login/activate"
    | "/_session/login/admin"
    | "/_session/login/credentials"
    | "/_session/password_reset/$token"
    | "/_cms/cms/"
    | "/_session/login/"
    | "/_session/password_reset/"
    | "/_authenticated/_feature_announcement/_user/communities"
    | "/_authenticated/_feature_announcement/_user/downloads"
    | "/_authenticated/_feature_announcement/_user/groups"
    | "/_authenticated/_feature_announcement/_user/notifications"
    | "/_authenticated/_feature_announcement/_user/profile"
    | "/_authenticated/_feature_announcement/_user/rewards"
    | "/_authenticated/_feature_announcement/_user/support"
    | "/_authenticated/_feature_announcement/admin/support-config"
    | "/_authenticated/_feature_announcement/admin/system"
    | "/_authenticated/_feature_announcement/communities/$communityId"
    | "/_authenticated/_feature_announcement/open_invitations/$openInvitationId"
    | "/_cms/cms/review/comment_moderation"
    | "/_cms/cms/tools/review_settings"
    | "/_authenticated/_feature_announcement/_user/"
    | "/_authenticated/_feature_announcement/communities/$communityId/members"
    | "/_authenticated/_feature_announcement/_user/community-lab/$"
    | "/_authenticated/_feature_announcement/_user/community-lab/session"
    | "/_authenticated/_feature_announcement/_user/community-lab/worksheet"
    | "/_authenticated/_feature_announcement/_user/global-survey-response/$surveyId"
    | "/_authenticated/_feature_announcement/_user/profile/statistics"
    | "/_authenticated/_feature_announcement/admin/analyze/community-lab-report"
    | "/_authenticated/_feature_announcement/admin/analyze/groups"
    | "/_authenticated/_feature_announcement/admin/analyze/reports"
    | "/_authenticated/_feature_announcement/admin/analyze/segments"
    | "/_authenticated/_feature_announcement/admin/analyze/users"
    | "/_authenticated/_feature_announcement/admin/gamification/rewards"
    | "/_authenticated/_feature_announcement/admin/manage/archived"
    | "/_authenticated/_feature_announcement/admin/manage/events"
    | "/_authenticated/_feature_announcement/admin/manage/folders"
    | "/_authenticated/_feature_announcement/admin/manage/labels"
    | "/_authenticated/_feature_announcement/admin/manage/leaders"
    | "/_authenticated/_feature_announcement/admin/manage/tags"
    | "/_authenticated/_feature_announcement/admin/plan/aggregate_budgeting"
    | "/_authenticated/_feature_announcement/admin/surveys/new"
    | "/_authenticated/_feature_announcement/admin/system/api_access_tokens"
    | "/_authenticated/_feature_announcement/admin/system/branding"
    | "/_authenticated/_feature_announcement/admin/system/integrations"
    | "/_authenticated/_feature_announcement/admin/system/logs"
    | "/_authenticated/_feature_announcement/admin/system/mcp_connector"
    | "/_authenticated/_feature_announcement/admin/system/roles"
    | "/_authenticated/_feature_announcement/admin/system/settings"
    | "/_authenticated/_feature_announcement/admin/system/users"
    | "/_authenticated/_feature_announcement/communities/$communityId/budgeting"
    | "/_authenticated/_feature_announcement/communities/$communityId/chapters"
    | "/_authenticated/_feature_announcement/communities/$communityId/folders"
    | "/_authenticated/_feature_announcement/communities/$communityId/manage"
    | "/_authenticated/_feature_announcement/communities/$communityId/plan"
    | "/_authenticated/_feature_announcement/groups/$groupId/$"
    | "/_authenticated/_feature_announcement/invitations/$invitationId/accept"
    | "/_authenticated/_feature_announcement/invitations/$invitationId/decline"
    | "/_authenticated/_feature_announcement/regions/$regionId/$"
    | "/_cms/cms/manage/communications/$draftId"
    | "/_cms/cms/manage/events/$draftId"
    | "/_cms/cms/manage/events/new"
    | "/_cms/cms/manage/posts/$draftId"
    | "/_cms/cms/manage/publication_requests/$publicationRequestId"
    | "/_cms/cms/review/publication_requests/$publicationRequestId"
    | "/_authenticated/_feature_announcement/_user/community-lab/"
    | "/_authenticated/_feature_announcement/_user/events/"
    | "/_authenticated/_feature_announcement/_user/posts/"
    | "/_authenticated/_feature_announcement/_user/profile/"
    | "/_authenticated/_feature_announcement/admin/analyze/"
    | "/_authenticated/_feature_announcement/admin/context-backfill/"
    | "/_authenticated/_feature_announcement/admin/surveys/"
    | "/_authenticated/_feature_announcement/communities/$communityId/"
    | "/_cms/cms/manage/communications/"
    | "/_cms/cms/manage/events/"
    | "/_cms/cms/manage/posts/"
    | "/_cms/cms/manage/publication_requests/"
    | "/_cms/cms/review/publication_requests/"
    | "/_authenticated/_feature_announcement/communities/$communityId/members/automations"
    | "/(compatibility)/enterprises/$enterpriseId/folders/$folderId/resources"
    | "/(compatibility)/groups/$groupId/folders/$folderId/resources"
    | "/(compatibility)/groups/$groupId/news/$type/$postId"
    | "/(compatibility)/regions/$regionId/news/$type/$postId"
    | "/_authenticated/_feature_announcement/_user/events/$eventId/$"
    | "/_authenticated/_feature_announcement/_user/events/drafts/$draftId"
    | "/_authenticated/_feature_announcement/_user/events/drafts/new"
    | "/_authenticated/_feature_announcement/_user/network-survey-response/$networkId/$surveyId"
    | "/_authenticated/_feature_announcement/_user/posts/$postId/$"
    | "/_authenticated/_feature_announcement/_user/posts/drafts/$draftId"
    | "/_authenticated/_feature_announcement/_user/profile/edit/accessibility"
    | "/_authenticated/_feature_announcement/_user/profile/edit/engagement-report"
    | "/_authenticated/_feature_announcement/_user/profile/edit/general"
    | "/_authenticated/_feature_announcement/_user/profile/edit/leadership"
    | "/_authenticated/_feature_announcement/_user/profile/edit/notification"
    | "/_authenticated/_feature_announcement/_user/profile/edit/outlook"
    | "/_authenticated/_feature_announcement/_user/profile/edit/private"
    | "/_authenticated/_feature_announcement/_user/user/$userId/achievements"
    | "/_authenticated/_feature_announcement/_user/user/$userId/edit"
    | "/_authenticated/_feature_announcement/_user/user/$userId/statistics"
    | "/_authenticated/_feature_announcement/_user/user/$userId/transactions"
    | "/_authenticated/_feature_announcement/admin/analyze/dashboards/$"
    | "/_authenticated/_feature_announcement/admin/analyze/groups/events"
    | "/_authenticated/_feature_announcement/admin/analyze/groups/posts"
    | "/_authenticated/_feature_announcement/admin/analyze/groups/resources"
    | "/_authenticated/_feature_announcement/admin/analyze/groups/users"
    | "/_authenticated/_feature_announcement/admin/analyze/roi-suite/$"
    | "/_authenticated/_feature_announcement/admin/analyze/users/events"
    | "/_authenticated/_feature_announcement/admin/gamification/achievements/new"
    | "/_authenticated/_feature_announcement/admin/gamification/points/manage"
    | "/_authenticated/_feature_announcement/admin/gamification/rewards/new"
    | "/_authenticated/_feature_announcement/admin/gamification/rewards/pending"
    | "/_authenticated/_feature_announcement/admin/manage/calendar/create"
    | "/_authenticated/_feature_announcement/admin/manage/communications/new"
    | "/_authenticated/_feature_announcement/admin/manage/events/calendar"
    | "/_authenticated/_feature_announcement/admin/manage/events/configuration"
    | "/_authenticated/_feature_announcement/admin/manage/events/questionnaire"
    | "/_authenticated/_feature_announcement/admin/manage/groups/connections"
    | "/_authenticated/_feature_announcement/admin/manage/groups/leader_positions"
    | "/_authenticated/_feature_announcement/admin/manage/groups/new"
    | "/_authenticated/_feature_announcement/admin/manage/segments/new"
    | "/_authenticated/_feature_announcement/admin/surveys/$surveyId/edit"
    | "/_authenticated/_feature_announcement/admin/surveys/$surveyId/responses"
    | "/_authenticated/_feature_announcement/admin/system/branding/colors"
    | "/_authenticated/_feature_announcement/admin/system/branding/home"
    | "/_authenticated/_feature_announcement/admin/system/branding/logos"
    | "/_authenticated/_feature_announcement/admin/system/branding/theme"
    | "/_authenticated/_feature_announcement/admin/system/integrations/mentorcliq"
    | "/_authenticated/_feature_announcement/admin/system/integrations/outlook"
    | "/_authenticated/_feature_announcement/admin/system/integrations/simpplr"
    | "/_authenticated/_feature_announcement/admin/system/integrations/slack"
    | "/_authenticated/_feature_announcement/admin/system/integrations/teams"
    | "/_authenticated/_feature_announcement/admin/system/integrations/ukg"
    | "/_authenticated/_feature_announcement/admin/system/integrations/viva-engage"
    | "/_authenticated/_feature_announcement/admin/system/roles/role_configuration"
    | "/_authenticated/_feature_announcement/admin/system/settings/_configuration"
    | "/_authenticated/_feature_announcement/admin/system/settings/custom_texts"
    | "/_authenticated/_feature_announcement/admin/system/settings/fields"
    | "/_authenticated/_feature_announcement/admin/system/settings/sso"
    | "/_authenticated/_feature_announcement/admin/system/users/import"
    | "/_authenticated/_feature_announcement/admin/system/users/list"
    | "/_authenticated/_feature_announcement/admin/system/users/merge"
    | "/_authenticated/_feature_announcement/admin/system/users/new"
    | "/_authenticated/_feature_announcement/communities/$communityId/budgeting/manage"
    | "/_authenticated/_feature_announcement/communities/$communityId/budgeting/overview"
    | "/_authenticated/_feature_announcement/communities/$communityId/budgeting/request"
    | "/_authenticated/_feature_announcement/communities/$communityId/events/pending"
    | "/_authenticated/_feature_announcement/communities/$communityId/manage/archives"
    | "/_authenticated/_feature_announcement/communities/$communityId/manage/community-lab-report"
    | "/_authenticated/_feature_announcement/communities/$communityId/manage/review_settings"
    | "/_authenticated/_feature_announcement/communities/$communityId/manage/role_configuration"
    | "/_authenticated/_feature_announcement/communities/$communityId/manage/settings"
    | "/_authenticated/_feature_announcement/communities/$communityId/members/invitations"
    | "/_authenticated/_feature_announcement/communities/$communityId/plan/budgeting"
    | "/_authenticated/_feature_announcement/communities/$communityId/plan/events"
    | "/_authenticated/_feature_announcement/communities/$communityId/roi-suite/$"
    | "/_authenticated/_feature_announcement/_user/events/drafts/"
    | "/_authenticated/_feature_announcement/_user/global-survey-response/$surveyId/"
    | "/_authenticated/_feature_announcement/_user/posts/drafts/"
    | "/_authenticated/_feature_announcement/_user/user/$userId/"
    | "/_authenticated/_feature_announcement/admin/analyze/groups/"
    | "/_authenticated/_feature_announcement/admin/analyze/users/"
    | "/_authenticated/_feature_announcement/admin/gamification/achievements/"
    | "/_authenticated/_feature_announcement/admin/gamification/rewards/"
    | "/_authenticated/_feature_announcement/admin/manage/calendar/"
    | "/_authenticated/_feature_announcement/admin/manage/communications/"
    | "/_authenticated/_feature_announcement/admin/manage/groups/"
    | "/_authenticated/_feature_announcement/admin/manage/segments/"
    | "/_authenticated/_feature_announcement/admin/plan/budgeting/"
    | "/_authenticated/_feature_announcement/admin/system/integrations/"
    | "/_authenticated/_feature_announcement/communities/$communityId/events/"
    | "/_authenticated/_feature_announcement/communities/$communityId/members/"
    | "/_authenticated/_feature_announcement/communities/$communityId/posts/"
    | "/_authenticated/_feature_announcement/_user/global-survey-response/$surveyId/cohorts/$cohortId"
    | "/_authenticated/_feature_announcement/_user/profile/edit/record-hours/$communityId"
    | "/_authenticated/_feature_announcement/admin/gamification/achievements/$achievementId/edit"
    | "/_authenticated/_feature_announcement/admin/gamification/rewards/$rewardId/edit"
    | "/_authenticated/_feature_announcement/admin/manage/calendar/$calendarId/update"
    | "/_authenticated/_feature_announcement/admin/manage/communications/$communicationId/distributions"
    | "/_authenticated/_feature_announcement/admin/manage/communications/$communicationId/edit"
    | "/_authenticated/_feature_announcement/admin/manage/communications/$communicationId/recipients"
    | "/_authenticated/_feature_announcement/admin/manage/events/notable_dates_calendar/create"
    | "/_authenticated/_feature_announcement/admin/manage/groups/$groupId/categorize"
    | "/_authenticated/_feature_announcement/admin/manage/groups/$groupId/edit"
    | "/_authenticated/_feature_announcement/admin/manage/groups/categories/new"
    | "/_authenticated/_feature_announcement/admin/manage/segments/$segmentId/edit"
    | "/_authenticated/_feature_announcement/admin/plan/budgeting/fiscal_periods/new"
    | "/_authenticated/_feature_announcement/admin/system/branding/sponsors/new"
    | "/_authenticated/_feature_announcement/admin/system/settings/_configuration/communities"
    | "/_authenticated/_feature_announcement/admin/system/settings/_configuration/configuration"
    | "/_authenticated/_feature_announcement/admin/system/settings/_configuration/modules"
    | "/_authenticated/_feature_announcement/admin/system/settings/_configuration/profile_fields"
    | "/_authenticated/_feature_announcement/admin/system/settings/policy_documents/new"
    | "/_authenticated/_feature_announcement/admin/system/users/$userId/edit"
    | "/_authenticated/_feature_announcement/admin/system/users/$userId/role_assignments"
    | "/_authenticated/_feature_announcement/admin/system/users/$userId/statistics"
    | "/_authenticated/_feature_announcement/admin/system/users/roles/new"
    | "/_authenticated/_feature_announcement/communities/$communityId/events/$eventId/edit"
    | "/_authenticated/_feature_announcement/communities/$communityId/manage/communications/new"
    | "/_authenticated/_feature_announcement/communities/$communityId/manage/events/pending"
    | "/_authenticated/_feature_announcement/communities/$communityId/manage/leaders/new"
    | "/_authenticated/_feature_announcement/communities/$communityId/manage/settings/integration"
    | "/_authenticated/_feature_announcement/communities/$communityId/manage/settings/welcome_message"
    | "/_authenticated/_feature_announcement/communities/$communityId/manage/sponsors/new"
    | "/_authenticated/_feature_announcement/communities/$communityId/manage/surveys/new"
    | "/_authenticated/_feature_announcement/communities/$communityId/members/automations/new"
    | "/_authenticated/_feature_announcement/communities/$communityId/plan/budgeting/manage"
    | "/_authenticated/_feature_announcement/communities/$communityId/plan/budgeting/overview"
    | "/_authenticated/_feature_announcement/communities/$communityId/plan/budgeting/request"
    | "/_authenticated/_feature_announcement/communities/$communityId/plan/outcomes/new"
    | "/_authenticated/_feature_announcement/communities/$communityId/plan/pillars/new"
    | "/_authenticated/_feature_announcement/communities/$communityId/posts/$postId/edit"
    | "/_authenticated/_feature_announcement/_user/network-survey-response/$networkId/$surveyId/"
    | "/_authenticated/_feature_announcement/admin/manage/events/notable_dates_calendar/"
    | "/_authenticated/_feature_announcement/admin/manage/groups/categories/"
    | "/_authenticated/_feature_announcement/admin/system/branding/sponsors/"
    | "/_authenticated/_feature_announcement/admin/system/roles/community/"
    | "/_authenticated/_feature_announcement/admin/system/roles/platform/"
    | "/_authenticated/_feature_announcement/admin/system/settings/emails/"
    | "/_authenticated/_feature_announcement/admin/system/settings/policy_documents/"
    | "/_authenticated/_feature_announcement/admin/system/users/$userId/"
    | "/_authenticated/_feature_announcement/admin/system/users/policy_templates/"
    | "/_authenticated/_feature_announcement/admin/system/users/roles/"
    | "/_authenticated/_feature_announcement/communities/$communityId/events/$eventId/"
    | "/_authenticated/_feature_announcement/communities/$communityId/manage/communications/"
    | "/_authenticated/_feature_announcement/communities/$communityId/manage/leaders/"
    | "/_authenticated/_feature_announcement/communities/$communityId/manage/settings/"
    | "/_authenticated/_feature_announcement/communities/$communityId/manage/sponsors/"
    | "/_authenticated/_feature_announcement/communities/$communityId/manage/surveys/"
    | "/_authenticated/_feature_announcement/communities/$communityId/members/automations/"
    | "/_authenticated/_feature_announcement/communities/$communityId/plan/outcomes/"
    | "/_authenticated/_feature_announcement/communities/$communityId/plan/pillars/"
    | "/_authenticated/_feature_announcement/communities/$communityId/posts/$postId/"
    | "/_authenticated/_feature_announcement/_user/network-survey-response/$networkId/$surveyId/cohorts/$cohortId"
    | "/_authenticated/_feature_announcement/admin/manage/calendar/$calendarId/notable_dates/create"
    | "/_authenticated/_feature_announcement/admin/manage/events/notable_dates_calendar/$calendarId/update"
    | "/_authenticated/_feature_announcement/admin/manage/groups/$groupId/regions/new"
    | "/_authenticated/_feature_announcement/admin/manage/groups/categories/$categoryId/edit"
    | "/_authenticated/_feature_announcement/admin/system/branding/sponsors/$sponsorId/edit"
    | "/_authenticated/_feature_announcement/admin/system/roles/community/$roleId/permissions"
    | "/_authenticated/_feature_announcement/admin/system/roles/platform/$roleId/permissions"
    | "/_authenticated/_feature_announcement/admin/system/settings/emails/$emailId/edit"
    | "/_authenticated/_feature_announcement/admin/system/settings/policy_documents/edit/$policyDocumentId"
    | "/_authenticated/_feature_announcement/admin/system/users/$userId/edit/fields"
    | "/_authenticated/_feature_announcement/admin/system/users/$userId/edit/general"
    | "/_authenticated/_feature_announcement/admin/system/users/policy_templates/$policyId/edit"
    | "/_authenticated/_feature_announcement/admin/system/users/roles/$roleId/edit"
    | "/_authenticated/_feature_announcement/communities/$communityId/events/$eventId/manage/attendees"
    | "/_authenticated/_feature_announcement/communities/$communityId/events/$eventId/manage/budgeting"
    | "/_authenticated/_feature_announcement/communities/$communityId/events/$eventId/manage/waitlist"
    | "/_authenticated/_feature_announcement/communities/$communityId/manage/communications/$communicationId/distributions"
    | "/_authenticated/_feature_announcement/communities/$communityId/manage/communications/$communicationId/edit"
    | "/_authenticated/_feature_announcement/communities/$communityId/manage/communications/$communicationId/recipients"
    | "/_authenticated/_feature_announcement/communities/$communityId/manage/leaders/$leaderId/edit"
    | "/_authenticated/_feature_announcement/communities/$communityId/manage/sponsors/$sponsorId/edit"
    | "/_authenticated/_feature_announcement/communities/$communityId/manage/surveys/$surveyId/edit"
    | "/_authenticated/_feature_announcement/communities/$communityId/manage/surveys/$surveyId/responses"
    | "/_authenticated/_feature_announcement/communities/$communityId/members/automations/$ruleId/edit"
    | "/_authenticated/_feature_announcement/communities/$communityId/members/automations/history/$runId"
    | "/_authenticated/_feature_announcement/communities/$communityId/plan/outcomes/$outcomeId/edit"
    | "/_authenticated/_feature_announcement/communities/$communityId/plan/pillars/$pillarId/edit"
    | "/_authenticated/_feature_announcement/communities/$communityId/plan/pillars/$pillarId/events"
    | "/_authenticated/_feature_announcement/admin/manage/groups/$groupId/regions/"
    | "/_authenticated/_feature_announcement/admin/system/roles/community/$roleId/"
    | "/_authenticated/_feature_announcement/admin/system/roles/platform/$roleId/"
    | "/_authenticated/_feature_announcement/communities/$communityId/members/automations/history/"
    | "/_authenticated/_feature_announcement/admin/manage/calendar/$calendarId/notable_dates/$eventId/update"
    | "/_authenticated/_feature_announcement/admin/manage/events/notable_dates_calendar/$calendarId/notable_dates/create"
    | "/_authenticated/_feature_announcement/admin/manage/groups/$groupId/regions/$regionId/edit"
    | "/_authenticated/_feature_announcement/admin/manage/events/notable_dates_calendar/$calendarId/notable_dates/$eventId/update";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  AnonymousRoute: typeof AnonymousRouteWithChildren;
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren;
  CmsRoute: typeof CmsRouteWithChildren;
  SessionRoute: typeof SessionRouteWithChildren;
  AutoLoginRoute: typeof AutoLoginRoute;
  EnrollmentRoute: typeof EnrollmentRouteWithChildren;
  compatibilityOnboardingRoute: typeof compatibilityOnboardingRoute;
  compatibilitySign_upRoute: typeof compatibilitySign_upRoute;
  compatibilityEnterprisesEnterpriseIdFoldersFolderIdResourcesRoute: typeof compatibilityEnterprisesEnterpriseIdFoldersFolderIdResourcesRoute;
  compatibilityGroupsGroupIdFoldersFolderIdResourcesRoute: typeof compatibilityGroupsGroupIdFoldersFolderIdResourcesRoute;
  compatibilityGroupsGroupIdNewsTypePostIdRoute: typeof compatibilityGroupsGroupIdNewsTypePostIdRoute;
  compatibilityRegionsRegionIdNewsTypePostIdRoute: typeof compatibilityRegionsRegionIdNewsTypePostIdRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_anonymous": {
      id: "/_anonymous";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AnonymousRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authenticated": {
      id: "/_authenticated";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AuthenticatedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_cms": {
      id: "/_cms";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof CmsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_session": {
      id: "/_session";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof SessionRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/auto-login": {
      id: "/auto-login";
      path: "/auto-login";
      fullPath: "/auto-login";
      preLoaderRoute: typeof AutoLoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/enrollment": {
      id: "/enrollment";
      path: "/enrollment";
      fullPath: "/enrollment";
      preLoaderRoute: typeof EnrollmentRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/(compatibility)/onboarding": {
      id: "/(compatibility)/onboarding";
      path: "/onboarding";
      fullPath: "/onboarding";
      preLoaderRoute: typeof compatibilityOnboardingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/(compatibility)/sign_up": {
      id: "/(compatibility)/sign_up";
      path: "/sign_up";
      fullPath: "/sign_up";
      preLoaderRoute: typeof compatibilitySign_upRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_anonymous/mobile_sign_in": {
      id: "/_anonymous/mobile_sign_in";
      path: "/mobile_sign_in";
      fullPath: "/mobile_sign_in";
      preLoaderRoute: typeof AnonymousMobile_sign_inRouteImport;
      parentRoute: typeof AnonymousRoute;
    };
    "/_anonymous/unsubscribe": {
      id: "/_anonymous/unsubscribe";
      path: "/unsubscribe";
      fullPath: "/unsubscribe";
      preLoaderRoute: typeof AnonymousUnsubscribeRouteImport;
      parentRoute: typeof AnonymousRoute;
    };
    "/_authenticated/_feature_announcement": {
      id: "/_authenticated/_feature_announcement";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_session/forgot": {
      id: "/_session/forgot";
      path: "/forgot";
      fullPath: "/forgot";
      preLoaderRoute: typeof SessionForgotRouteImport;
      parentRoute: typeof SessionRoute;
    };
    "/enrollment/": {
      id: "/enrollment/";
      path: "/";
      fullPath: "/enrollment/";
      preLoaderRoute: typeof EnrollmentIndexRouteImport;
      parentRoute: typeof EnrollmentRoute;
    };
    "/enrollment/complete": {
      id: "/enrollment/complete";
      path: "/complete";
      fullPath: "/enrollment/complete";
      preLoaderRoute: typeof EnrollmentCompleteRouteImport;
      parentRoute: typeof EnrollmentRoute;
    };
    "/enrollment/discover": {
      id: "/enrollment/discover";
      path: "/discover";
      fullPath: "/enrollment/discover";
      preLoaderRoute: typeof EnrollmentDiscoverRouteImport;
      parentRoute: typeof EnrollmentRoute;
    };
    "/enrollment/profile": {
      id: "/enrollment/profile";
      path: "/profile";
      fullPath: "/enrollment/profile";
      preLoaderRoute: typeof EnrollmentProfileRouteImport;
      parentRoute: typeof EnrollmentRoute;
    };
    "/_anonymous/event_checkin/$eventId": {
      id: "/_anonymous/event_checkin/$eventId";
      path: "/event_checkin/$eventId";
      fullPath: "/event_checkin/$eventId";
      preLoaderRoute: typeof AnonymousEvent_checkinEventIdRouteImport;
      parentRoute: typeof AnonymousRoute;
    };
    "/_anonymous/verify/$token": {
      id: "/_anonymous/verify/$token";
      path: "/verify/$token";
      fullPath: "/verify/$token";
      preLoaderRoute: typeof AnonymousVerifyTokenRouteImport;
      parentRoute: typeof AnonymousRoute;
    };
    "/_authenticated/_feature_announcement/_user": {
      id: "/_authenticated/_feature_announcement/_user";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementRoute;
    };
    "/_authenticated/_feature_announcement/admin": {
      id: "/_authenticated/_feature_announcement/admin";
      path: "/admin";
      fullPath: "/admin";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementRoute;
    };
    "/_cms/cms/": {
      id: "/_cms/cms/";
      path: "/cms";
      fullPath: "/cms/";
      preLoaderRoute: typeof CmsCmsIndexRouteImport;
      parentRoute: typeof CmsRoute;
    };
    "/_session/login/": {
      id: "/_session/login/";
      path: "/login";
      fullPath: "/login/";
      preLoaderRoute: typeof SessionLoginIndexRouteImport;
      parentRoute: typeof SessionRoute;
    };
    "/_session/login/activate": {
      id: "/_session/login/activate";
      path: "/login/activate";
      fullPath: "/login/activate";
      preLoaderRoute: typeof SessionLoginActivateRouteImport;
      parentRoute: typeof SessionRoute;
    };
    "/_session/login/admin": {
      id: "/_session/login/admin";
      path: "/login/admin";
      fullPath: "/login/admin";
      preLoaderRoute: typeof SessionLoginAdminRouteImport;
      parentRoute: typeof SessionRoute;
    };
    "/_session/login/credentials": {
      id: "/_session/login/credentials";
      path: "/login/credentials";
      fullPath: "/login/credentials";
      preLoaderRoute: typeof SessionLoginCredentialsRouteImport;
      parentRoute: typeof SessionRoute;
    };
    "/_session/password_reset/": {
      id: "/_session/password_reset/";
      path: "/password_reset";
      fullPath: "/password_reset/";
      preLoaderRoute: typeof SessionPassword_resetIndexRouteImport;
      parentRoute: typeof SessionRoute;
    };
    "/_session/password_reset/$token": {
      id: "/_session/password_reset/$token";
      path: "/password_reset/$token";
      fullPath: "/password_reset/$token";
      preLoaderRoute: typeof SessionPassword_resetTokenRouteImport;
      parentRoute: typeof SessionRoute;
    };
    "/_authenticated/_feature_announcement/_user/": {
      id: "/_authenticated/_feature_announcement/_user/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserRoute;
    };
    "/_authenticated/_feature_announcement/_user/communities": {
      id: "/_authenticated/_feature_announcement/_user/communities";
      path: "/communities";
      fullPath: "/communities";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserCommunitiesRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserRoute;
    };
    "/_authenticated/_feature_announcement/_user/downloads": {
      id: "/_authenticated/_feature_announcement/_user/downloads";
      path: "/downloads";
      fullPath: "/downloads";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserDownloadsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserRoute;
    };
    "/_authenticated/_feature_announcement/_user/groups": {
      id: "/_authenticated/_feature_announcement/_user/groups";
      path: "/groups";
      fullPath: "/groups";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserGroupsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserRoute;
    };
    "/_authenticated/_feature_announcement/_user/notifications": {
      id: "/_authenticated/_feature_announcement/_user/notifications";
      path: "/notifications";
      fullPath: "/notifications";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserNotificationsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserRoute;
    };
    "/_authenticated/_feature_announcement/_user/profile": {
      id: "/_authenticated/_feature_announcement/_user/profile";
      path: "/profile";
      fullPath: "/profile";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserProfileRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserRoute;
    };
    "/_authenticated/_feature_announcement/_user/rewards": {
      id: "/_authenticated/_feature_announcement/_user/rewards";
      path: "/rewards";
      fullPath: "/rewards";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserRewardsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserRoute;
    };
    "/_authenticated/_feature_announcement/_user/support": {
      id: "/_authenticated/_feature_announcement/_user/support";
      path: "/support";
      fullPath: "/support";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserSupportRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserRoute;
    };
    "/_authenticated/_feature_announcement/admin/support-config": {
      id: "/_authenticated/_feature_announcement/admin/support-config";
      path: "/support-config";
      fullPath: "/admin/support-config";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSupportConfigRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/system": {
      id: "/_authenticated/_feature_announcement/admin/system";
      path: "/system";
      fullPath: "/admin/system";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId": {
      id: "/_authenticated/_feature_announcement/communities/$communityId";
      path: "/communities/$communityId";
      fullPath: "/communities/$communityId";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementRoute;
    };
    "/_authenticated/_feature_announcement/open_invitations/$openInvitationId": {
      id: "/_authenticated/_feature_announcement/open_invitations/$openInvitationId";
      path: "/open_invitations/$openInvitationId";
      fullPath: "/open_invitations/$openInvitationId";
      preLoaderRoute: typeof AuthenticatedFeature_announcementOpen_invitationsOpenInvitationIdRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementRoute;
    };
    "/_cms/cms/review/comment_moderation": {
      id: "/_cms/cms/review/comment_moderation";
      path: "/cms/review/comment_moderation";
      fullPath: "/cms/review/comment_moderation";
      preLoaderRoute: typeof CmsCmsReviewComment_moderationRouteImport;
      parentRoute: typeof CmsRoute;
    };
    "/_cms/cms/tools/review_settings": {
      id: "/_cms/cms/tools/review_settings";
      path: "/cms/tools/review_settings";
      fullPath: "/cms/tools/review_settings";
      preLoaderRoute: typeof CmsCmsToolsReview_settingsRouteImport;
      parentRoute: typeof CmsRoute;
    };
    "/_authenticated/_feature_announcement/_user/community-lab/": {
      id: "/_authenticated/_feature_announcement/_user/community-lab/";
      path: "/community-lab";
      fullPath: "/community-lab/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserCommunityLabIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserRoute;
    };
    "/_authenticated/_feature_announcement/_user/community-lab/$": {
      id: "/_authenticated/_feature_announcement/_user/community-lab/$";
      path: "/community-lab/$";
      fullPath: "/community-lab/$";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserCommunityLabSplatRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserRoute;
    };
    "/_authenticated/_feature_announcement/_user/community-lab/session": {
      id: "/_authenticated/_feature_announcement/_user/community-lab/session";
      path: "/community-lab/session";
      fullPath: "/community-lab/session";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserCommunityLabSessionRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserRoute;
    };
    "/_authenticated/_feature_announcement/_user/community-lab/worksheet": {
      id: "/_authenticated/_feature_announcement/_user/community-lab/worksheet";
      path: "/community-lab/worksheet";
      fullPath: "/community-lab/worksheet";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserCommunityLabWorksheetRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserRoute;
    };
    "/_authenticated/_feature_announcement/_user/events/": {
      id: "/_authenticated/_feature_announcement/_user/events/";
      path: "/events";
      fullPath: "/events/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserEventsIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserRoute;
    };
    "/_authenticated/_feature_announcement/_user/global-survey-response/$surveyId": {
      id: "/_authenticated/_feature_announcement/_user/global-survey-response/$surveyId";
      path: "/global-survey-response/$surveyId";
      fullPath: "/global-survey-response/$surveyId";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserRoute;
    };
    "/_authenticated/_feature_announcement/_user/posts/": {
      id: "/_authenticated/_feature_announcement/_user/posts/";
      path: "/posts";
      fullPath: "/posts/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserPostsIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserRoute;
    };
    "/_authenticated/_feature_announcement/_user/profile/": {
      id: "/_authenticated/_feature_announcement/_user/profile/";
      path: "/";
      fullPath: "/profile/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserProfileIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserProfileRoute;
    };
    "/_authenticated/_feature_announcement/_user/profile/statistics": {
      id: "/_authenticated/_feature_announcement/_user/profile/statistics";
      path: "/statistics";
      fullPath: "/profile/statistics";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserProfileStatisticsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserProfileRoute;
    };
    "/_authenticated/_feature_announcement/admin/analyze/": {
      id: "/_authenticated/_feature_announcement/admin/analyze/";
      path: "/analyze";
      fullPath: "/admin/analyze/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/analyze/community-lab-report": {
      id: "/_authenticated/_feature_announcement/admin/analyze/community-lab-report";
      path: "/analyze/community-lab-report";
      fullPath: "/admin/analyze/community-lab-report";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeCommunityLabReportRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/analyze/groups": {
      id: "/_authenticated/_feature_announcement/admin/analyze/groups";
      path: "/analyze/groups";
      fullPath: "/admin/analyze/groups";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/analyze/reports": {
      id: "/_authenticated/_feature_announcement/admin/analyze/reports";
      path: "/analyze/reports";
      fullPath: "/admin/analyze/reports";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeReportsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/analyze/segments": {
      id: "/_authenticated/_feature_announcement/admin/analyze/segments";
      path: "/analyze/segments";
      fullPath: "/admin/analyze/segments";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeSegmentsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/analyze/users": {
      id: "/_authenticated/_feature_announcement/admin/analyze/users";
      path: "/analyze/users";
      fullPath: "/admin/analyze/users";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeUsersRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/context-backfill/": {
      id: "/_authenticated/_feature_announcement/admin/context-backfill/";
      path: "/context-backfill";
      fullPath: "/admin/context-backfill/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminContextBackfillIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/gamification/rewards": {
      id: "/_authenticated/_feature_announcement/admin/gamification/rewards";
      path: "/gamification/rewards";
      fullPath: "/admin/gamification/rewards";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminGamificationRewardsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/archived": {
      id: "/_authenticated/_feature_announcement/admin/manage/archived";
      path: "/manage/archived";
      fullPath: "/admin/manage/archived";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageArchivedRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/events": {
      id: "/_authenticated/_feature_announcement/admin/manage/events";
      path: "/manage/events";
      fullPath: "/admin/manage/events";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageEventsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/folders": {
      id: "/_authenticated/_feature_announcement/admin/manage/folders";
      path: "/manage/folders";
      fullPath: "/admin/manage/folders";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageFoldersRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/labels": {
      id: "/_authenticated/_feature_announcement/admin/manage/labels";
      path: "/manage/labels";
      fullPath: "/admin/manage/labels";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageLabelsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/leaders": {
      id: "/_authenticated/_feature_announcement/admin/manage/leaders";
      path: "/manage/leaders";
      fullPath: "/admin/manage/leaders";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageLeadersRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/tags": {
      id: "/_authenticated/_feature_announcement/admin/manage/tags";
      path: "/manage/tags";
      fullPath: "/admin/manage/tags";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageTagsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/plan/aggregate_budgeting": {
      id: "/_authenticated/_feature_announcement/admin/plan/aggregate_budgeting";
      path: "/plan/aggregate_budgeting";
      fullPath: "/admin/plan/aggregate_budgeting";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminPlanAggregate_budgetingRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/surveys/": {
      id: "/_authenticated/_feature_announcement/admin/surveys/";
      path: "/surveys";
      fullPath: "/admin/surveys/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSurveysIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/surveys/new": {
      id: "/_authenticated/_feature_announcement/admin/surveys/new";
      path: "/surveys/new";
      fullPath: "/admin/surveys/new";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSurveysNewRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/api_access_tokens": {
      id: "/_authenticated/_feature_announcement/admin/system/api_access_tokens";
      path: "/api_access_tokens";
      fullPath: "/admin/system/api_access_tokens";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemApi_access_tokensRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/branding": {
      id: "/_authenticated/_feature_announcement/admin/system/branding";
      path: "/branding";
      fullPath: "/admin/system/branding";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemBrandingRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/integrations": {
      id: "/_authenticated/_feature_announcement/admin/system/integrations";
      path: "/integrations";
      fullPath: "/admin/system/integrations";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemIntegrationsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/logs": {
      id: "/_authenticated/_feature_announcement/admin/system/logs";
      path: "/logs";
      fullPath: "/admin/system/logs";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemLogsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/mcp_connector": {
      id: "/_authenticated/_feature_announcement/admin/system/mcp_connector";
      path: "/mcp_connector";
      fullPath: "/admin/system/mcp_connector";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemMcp_connectorRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/roles": {
      id: "/_authenticated/_feature_announcement/admin/system/roles";
      path: "/roles";
      fullPath: "/admin/system/roles";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemRolesRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/settings": {
      id: "/_authenticated/_feature_announcement/admin/system/settings";
      path: "/settings";
      fullPath: "/admin/system/settings";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/users": {
      id: "/_authenticated/_feature_announcement/admin/system/users";
      path: "/users";
      fullPath: "/admin/system/users";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/";
      path: "/";
      fullPath: "/communities/$communityId/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/budgeting": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/budgeting";
      path: "/budgeting";
      fullPath: "/communities/$communityId/budgeting";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/chapters": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/chapters";
      path: "/chapters";
      fullPath: "/communities/$communityId/chapters";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdChaptersRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/folders": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/folders";
      path: "/folders";
      fullPath: "/communities/$communityId/folders";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdFoldersRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/manage": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/manage";
      path: "/manage";
      fullPath: "/communities/$communityId/manage";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/members": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/members";
      path: "/members";
      fullPath: "/communities/$communityId/members";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersRouteRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/plan": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/plan";
      path: "/plan";
      fullPath: "/communities/$communityId/plan";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdRoute;
    };
    "/_authenticated/_feature_announcement/groups/$groupId/$": {
      id: "/_authenticated/_feature_announcement/groups/$groupId/$";
      path: "/groups/$groupId/$";
      fullPath: "/groups/$groupId/$";
      preLoaderRoute: typeof AuthenticatedFeature_announcementGroupsGroupIdSplatRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementRoute;
    };
    "/_authenticated/_feature_announcement/invitations/$invitationId/accept": {
      id: "/_authenticated/_feature_announcement/invitations/$invitationId/accept";
      path: "/invitations/$invitationId/accept";
      fullPath: "/invitations/$invitationId/accept";
      preLoaderRoute: typeof AuthenticatedFeature_announcementInvitationsInvitationIdAcceptRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementRoute;
    };
    "/_authenticated/_feature_announcement/invitations/$invitationId/decline": {
      id: "/_authenticated/_feature_announcement/invitations/$invitationId/decline";
      path: "/invitations/$invitationId/decline";
      fullPath: "/invitations/$invitationId/decline";
      preLoaderRoute: typeof AuthenticatedFeature_announcementInvitationsInvitationIdDeclineRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementRoute;
    };
    "/_authenticated/_feature_announcement/regions/$regionId/$": {
      id: "/_authenticated/_feature_announcement/regions/$regionId/$";
      path: "/regions/$regionId/$";
      fullPath: "/regions/$regionId/$";
      preLoaderRoute: typeof AuthenticatedFeature_announcementRegionsRegionIdSplatRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementRoute;
    };
    "/_cms/cms/manage/communications/": {
      id: "/_cms/cms/manage/communications/";
      path: "/cms/manage/communications";
      fullPath: "/cms/manage/communications/";
      preLoaderRoute: typeof CmsCmsManageCommunicationsIndexRouteImport;
      parentRoute: typeof CmsRoute;
    };
    "/_cms/cms/manage/communications/$draftId": {
      id: "/_cms/cms/manage/communications/$draftId";
      path: "/cms/manage/communications/$draftId";
      fullPath: "/cms/manage/communications/$draftId";
      preLoaderRoute: typeof CmsCmsManageCommunicationsDraftIdRouteImport;
      parentRoute: typeof CmsRoute;
    };
    "/_cms/cms/manage/events/": {
      id: "/_cms/cms/manage/events/";
      path: "/cms/manage/events";
      fullPath: "/cms/manage/events/";
      preLoaderRoute: typeof CmsCmsManageEventsIndexRouteImport;
      parentRoute: typeof CmsRoute;
    };
    "/_cms/cms/manage/events/$draftId": {
      id: "/_cms/cms/manage/events/$draftId";
      path: "/cms/manage/events/$draftId";
      fullPath: "/cms/manage/events/$draftId";
      preLoaderRoute: typeof CmsCmsManageEventsDraftIdRouteImport;
      parentRoute: typeof CmsRoute;
    };
    "/_cms/cms/manage/events/new": {
      id: "/_cms/cms/manage/events/new";
      path: "/cms/manage/events/new";
      fullPath: "/cms/manage/events/new";
      preLoaderRoute: typeof CmsCmsManageEventsNewRouteImport;
      parentRoute: typeof CmsRoute;
    };
    "/_cms/cms/manage/posts/": {
      id: "/_cms/cms/manage/posts/";
      path: "/cms/manage/posts";
      fullPath: "/cms/manage/posts/";
      preLoaderRoute: typeof CmsCmsManagePostsIndexRouteImport;
      parentRoute: typeof CmsRoute;
    };
    "/_cms/cms/manage/posts/$draftId": {
      id: "/_cms/cms/manage/posts/$draftId";
      path: "/cms/manage/posts/$draftId";
      fullPath: "/cms/manage/posts/$draftId";
      preLoaderRoute: typeof CmsCmsManagePostsDraftIdRouteImport;
      parentRoute: typeof CmsRoute;
    };
    "/_cms/cms/manage/publication_requests/": {
      id: "/_cms/cms/manage/publication_requests/";
      path: "/cms/manage/publication_requests";
      fullPath: "/cms/manage/publication_requests/";
      preLoaderRoute: typeof CmsCmsManagePublication_requestsIndexRouteImport;
      parentRoute: typeof CmsRoute;
    };
    "/_cms/cms/manage/publication_requests/$publicationRequestId": {
      id: "/_cms/cms/manage/publication_requests/$publicationRequestId";
      path: "/cms/manage/publication_requests/$publicationRequestId";
      fullPath: "/cms/manage/publication_requests/$publicationRequestId";
      preLoaderRoute: typeof CmsCmsManagePublication_requestsPublicationRequestIdRouteImport;
      parentRoute: typeof CmsRoute;
    };
    "/_cms/cms/review/publication_requests/": {
      id: "/_cms/cms/review/publication_requests/";
      path: "/cms/review/publication_requests";
      fullPath: "/cms/review/publication_requests/";
      preLoaderRoute: typeof CmsCmsReviewPublication_requestsIndexRouteImport;
      parentRoute: typeof CmsRoute;
    };
    "/_cms/cms/review/publication_requests/$publicationRequestId": {
      id: "/_cms/cms/review/publication_requests/$publicationRequestId";
      path: "/cms/review/publication_requests/$publicationRequestId";
      fullPath: "/cms/review/publication_requests/$publicationRequestId";
      preLoaderRoute: typeof CmsCmsReviewPublication_requestsPublicationRequestIdRouteImport;
      parentRoute: typeof CmsRoute;
    };
    "/(compatibility)/enterprises/$enterpriseId/folders/$folderId/resources": {
      id: "/(compatibility)/enterprises/$enterpriseId/folders/$folderId/resources";
      path: "/enterprises/$enterpriseId/folders/$folderId/resources";
      fullPath: "/enterprises/$enterpriseId/folders/$folderId/resources";
      preLoaderRoute: typeof compatibilityEnterprisesEnterpriseIdFoldersFolderIdResourcesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/(compatibility)/groups/$groupId/folders/$folderId/resources": {
      id: "/(compatibility)/groups/$groupId/folders/$folderId/resources";
      path: "/groups/$groupId/folders/$folderId/resources";
      fullPath: "/groups/$groupId/folders/$folderId/resources";
      preLoaderRoute: typeof compatibilityGroupsGroupIdFoldersFolderIdResourcesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/(compatibility)/groups/$groupId/news/$type/$postId": {
      id: "/(compatibility)/groups/$groupId/news/$type/$postId";
      path: "/groups/$groupId/news/$type/$postId";
      fullPath: "/groups/$groupId/news/$type/$postId";
      preLoaderRoute: typeof compatibilityGroupsGroupIdNewsTypePostIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/(compatibility)/regions/$regionId/news/$type/$postId": {
      id: "/(compatibility)/regions/$regionId/news/$type/$postId";
      path: "/regions/$regionId/news/$type/$postId";
      fullPath: "/regions/$regionId/news/$type/$postId";
      preLoaderRoute: typeof compatibilityRegionsRegionIdNewsTypePostIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authenticated/_feature_announcement/_user/events/$eventId/$": {
      id: "/_authenticated/_feature_announcement/_user/events/$eventId/$";
      path: "/events/$eventId/$";
      fullPath: "/events/$eventId/$";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserEventsEventIdSplatRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserRoute;
    };
    "/_authenticated/_feature_announcement/_user/events/drafts/": {
      id: "/_authenticated/_feature_announcement/_user/events/drafts/";
      path: "/events/drafts";
      fullPath: "/events/drafts/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserEventsDraftsIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserRoute;
    };
    "/_authenticated/_feature_announcement/_user/events/drafts/$draftId": {
      id: "/_authenticated/_feature_announcement/_user/events/drafts/$draftId";
      path: "/events/drafts/$draftId";
      fullPath: "/events/drafts/$draftId";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserEventsDraftsDraftIdRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserRoute;
    };
    "/_authenticated/_feature_announcement/_user/events/drafts/new": {
      id: "/_authenticated/_feature_announcement/_user/events/drafts/new";
      path: "/events/drafts/new";
      fullPath: "/events/drafts/new";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserEventsDraftsNewRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserRoute;
    };
    "/_authenticated/_feature_announcement/_user/global-survey-response/$surveyId/": {
      id: "/_authenticated/_feature_announcement/_user/global-survey-response/$surveyId/";
      path: "/";
      fullPath: "/global-survey-response/$surveyId/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdRoute;
    };
    "/_authenticated/_feature_announcement/_user/network-survey-response/$networkId/$surveyId": {
      id: "/_authenticated/_feature_announcement/_user/network-survey-response/$networkId/$surveyId";
      path: "/network-survey-response/$networkId/$surveyId";
      fullPath: "/network-survey-response/$networkId/$surveyId";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserRoute;
    };
    "/_authenticated/_feature_announcement/_user/posts/$postId/$": {
      id: "/_authenticated/_feature_announcement/_user/posts/$postId/$";
      path: "/posts/$postId/$";
      fullPath: "/posts/$postId/$";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserPostsPostIdSplatRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserRoute;
    };
    "/_authenticated/_feature_announcement/_user/posts/drafts/": {
      id: "/_authenticated/_feature_announcement/_user/posts/drafts/";
      path: "/posts/drafts";
      fullPath: "/posts/drafts/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserPostsDraftsIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserRoute;
    };
    "/_authenticated/_feature_announcement/_user/posts/drafts/$draftId": {
      id: "/_authenticated/_feature_announcement/_user/posts/drafts/$draftId";
      path: "/posts/drafts/$draftId";
      fullPath: "/posts/drafts/$draftId";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserPostsDraftsDraftIdRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserRoute;
    };
    "/_authenticated/_feature_announcement/_user/profile/edit/accessibility": {
      id: "/_authenticated/_feature_announcement/_user/profile/edit/accessibility";
      path: "/edit/accessibility";
      fullPath: "/profile/edit/accessibility";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserProfileEditAccessibilityRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserProfileRoute;
    };
    "/_authenticated/_feature_announcement/_user/profile/edit/engagement-report": {
      id: "/_authenticated/_feature_announcement/_user/profile/edit/engagement-report";
      path: "/edit/engagement-report";
      fullPath: "/profile/edit/engagement-report";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserProfileEditEngagementReportRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserProfileRoute;
    };
    "/_authenticated/_feature_announcement/_user/profile/edit/general": {
      id: "/_authenticated/_feature_announcement/_user/profile/edit/general";
      path: "/edit/general";
      fullPath: "/profile/edit/general";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserProfileEditGeneralRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserProfileRoute;
    };
    "/_authenticated/_feature_announcement/_user/profile/edit/leadership": {
      id: "/_authenticated/_feature_announcement/_user/profile/edit/leadership";
      path: "/edit/leadership";
      fullPath: "/profile/edit/leadership";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserProfileEditLeadershipRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserProfileRoute;
    };
    "/_authenticated/_feature_announcement/_user/profile/edit/notification": {
      id: "/_authenticated/_feature_announcement/_user/profile/edit/notification";
      path: "/edit/notification";
      fullPath: "/profile/edit/notification";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserProfileEditNotificationRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserProfileRoute;
    };
    "/_authenticated/_feature_announcement/_user/profile/edit/outlook": {
      id: "/_authenticated/_feature_announcement/_user/profile/edit/outlook";
      path: "/edit/outlook";
      fullPath: "/profile/edit/outlook";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserProfileEditOutlookRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserProfileRoute;
    };
    "/_authenticated/_feature_announcement/_user/profile/edit/private": {
      id: "/_authenticated/_feature_announcement/_user/profile/edit/private";
      path: "/edit/private";
      fullPath: "/profile/edit/private";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserProfileEditPrivateRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserProfileRoute;
    };
    "/_authenticated/_feature_announcement/_user/user/$userId/": {
      id: "/_authenticated/_feature_announcement/_user/user/$userId/";
      path: "/user/$userId";
      fullPath: "/user/$userId/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserUserUserIdIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserRoute;
    };
    "/_authenticated/_feature_announcement/_user/user/$userId/achievements": {
      id: "/_authenticated/_feature_announcement/_user/user/$userId/achievements";
      path: "/user/$userId/achievements";
      fullPath: "/user/$userId/achievements";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserUserUserIdAchievementsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserRoute;
    };
    "/_authenticated/_feature_announcement/_user/user/$userId/edit": {
      id: "/_authenticated/_feature_announcement/_user/user/$userId/edit";
      path: "/user/$userId/edit";
      fullPath: "/user/$userId/edit";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserUserUserIdEditRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserRoute;
    };
    "/_authenticated/_feature_announcement/_user/user/$userId/statistics": {
      id: "/_authenticated/_feature_announcement/_user/user/$userId/statistics";
      path: "/user/$userId/statistics";
      fullPath: "/user/$userId/statistics";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserUserUserIdStatisticsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserRoute;
    };
    "/_authenticated/_feature_announcement/_user/user/$userId/transactions": {
      id: "/_authenticated/_feature_announcement/_user/user/$userId/transactions";
      path: "/user/$userId/transactions";
      fullPath: "/user/$userId/transactions";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserUserUserIdTransactionsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserRoute;
    };
    "/_authenticated/_feature_announcement/admin/analyze/dashboards/$": {
      id: "/_authenticated/_feature_announcement/admin/analyze/dashboards/$";
      path: "/analyze/dashboards/$";
      fullPath: "/admin/analyze/dashboards/$";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeDashboardsSplatRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/analyze/groups/": {
      id: "/_authenticated/_feature_announcement/admin/analyze/groups/";
      path: "/";
      fullPath: "/admin/analyze/groups/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsRoute;
    };
    "/_authenticated/_feature_announcement/admin/analyze/groups/events": {
      id: "/_authenticated/_feature_announcement/admin/analyze/groups/events";
      path: "/events";
      fullPath: "/admin/analyze/groups/events";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsEventsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsRoute;
    };
    "/_authenticated/_feature_announcement/admin/analyze/groups/posts": {
      id: "/_authenticated/_feature_announcement/admin/analyze/groups/posts";
      path: "/posts";
      fullPath: "/admin/analyze/groups/posts";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsPostsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsRoute;
    };
    "/_authenticated/_feature_announcement/admin/analyze/groups/resources": {
      id: "/_authenticated/_feature_announcement/admin/analyze/groups/resources";
      path: "/resources";
      fullPath: "/admin/analyze/groups/resources";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsResourcesRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsRoute;
    };
    "/_authenticated/_feature_announcement/admin/analyze/groups/users": {
      id: "/_authenticated/_feature_announcement/admin/analyze/groups/users";
      path: "/users";
      fullPath: "/admin/analyze/groups/users";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsUsersRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsRoute;
    };
    "/_authenticated/_feature_announcement/admin/analyze/roi-suite/$": {
      id: "/_authenticated/_feature_announcement/admin/analyze/roi-suite/$";
      path: "/analyze/roi-suite/$";
      fullPath: "/admin/analyze/roi-suite/$";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeRoiSuiteSplatRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/analyze/users/": {
      id: "/_authenticated/_feature_announcement/admin/analyze/users/";
      path: "/";
      fullPath: "/admin/analyze/users/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeUsersIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeUsersRoute;
    };
    "/_authenticated/_feature_announcement/admin/analyze/users/events": {
      id: "/_authenticated/_feature_announcement/admin/analyze/users/events";
      path: "/events";
      fullPath: "/admin/analyze/users/events";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeUsersEventsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeUsersRoute;
    };
    "/_authenticated/_feature_announcement/admin/gamification/achievements/": {
      id: "/_authenticated/_feature_announcement/admin/gamification/achievements/";
      path: "/gamification/achievements";
      fullPath: "/admin/gamification/achievements/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminGamificationAchievementsIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/gamification/achievements/new": {
      id: "/_authenticated/_feature_announcement/admin/gamification/achievements/new";
      path: "/gamification/achievements/new";
      fullPath: "/admin/gamification/achievements/new";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminGamificationAchievementsNewRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/gamification/points/manage": {
      id: "/_authenticated/_feature_announcement/admin/gamification/points/manage";
      path: "/gamification/points/manage";
      fullPath: "/admin/gamification/points/manage";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminGamificationPointsManageRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/gamification/rewards/": {
      id: "/_authenticated/_feature_announcement/admin/gamification/rewards/";
      path: "/";
      fullPath: "/admin/gamification/rewards/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminGamificationRewardsIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminGamificationRewardsRoute;
    };
    "/_authenticated/_feature_announcement/admin/gamification/rewards/new": {
      id: "/_authenticated/_feature_announcement/admin/gamification/rewards/new";
      path: "/new";
      fullPath: "/admin/gamification/rewards/new";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminGamificationRewardsNewRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminGamificationRewardsRoute;
    };
    "/_authenticated/_feature_announcement/admin/gamification/rewards/pending": {
      id: "/_authenticated/_feature_announcement/admin/gamification/rewards/pending";
      path: "/pending";
      fullPath: "/admin/gamification/rewards/pending";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminGamificationRewardsPendingRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminGamificationRewardsRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/calendar/": {
      id: "/_authenticated/_feature_announcement/admin/manage/calendar/";
      path: "/manage/calendar";
      fullPath: "/admin/manage/calendar/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageCalendarIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/calendar/create": {
      id: "/_authenticated/_feature_announcement/admin/manage/calendar/create";
      path: "/manage/calendar/create";
      fullPath: "/admin/manage/calendar/create";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageCalendarCreateRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/communications/": {
      id: "/_authenticated/_feature_announcement/admin/manage/communications/";
      path: "/manage/communications";
      fullPath: "/admin/manage/communications/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageCommunicationsIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/communications/new": {
      id: "/_authenticated/_feature_announcement/admin/manage/communications/new";
      path: "/manage/communications/new";
      fullPath: "/admin/manage/communications/new";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageCommunicationsNewRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/events/calendar": {
      id: "/_authenticated/_feature_announcement/admin/manage/events/calendar";
      path: "/calendar";
      fullPath: "/admin/manage/events/calendar";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageEventsCalendarRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminManageEventsRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/events/configuration": {
      id: "/_authenticated/_feature_announcement/admin/manage/events/configuration";
      path: "/configuration";
      fullPath: "/admin/manage/events/configuration";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageEventsConfigurationRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminManageEventsRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/events/questionnaire": {
      id: "/_authenticated/_feature_announcement/admin/manage/events/questionnaire";
      path: "/questionnaire";
      fullPath: "/admin/manage/events/questionnaire";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageEventsQuestionnaireRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminManageEventsRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/groups/": {
      id: "/_authenticated/_feature_announcement/admin/manage/groups/";
      path: "/manage/groups";
      fullPath: "/admin/manage/groups/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageGroupsIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/groups/connections": {
      id: "/_authenticated/_feature_announcement/admin/manage/groups/connections";
      path: "/manage/groups/connections";
      fullPath: "/admin/manage/groups/connections";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageGroupsConnectionsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/groups/leader_positions": {
      id: "/_authenticated/_feature_announcement/admin/manage/groups/leader_positions";
      path: "/manage/groups/leader_positions";
      fullPath: "/admin/manage/groups/leader_positions";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageGroupsLeader_positionsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/groups/new": {
      id: "/_authenticated/_feature_announcement/admin/manage/groups/new";
      path: "/manage/groups/new";
      fullPath: "/admin/manage/groups/new";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageGroupsNewRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/segments/": {
      id: "/_authenticated/_feature_announcement/admin/manage/segments/";
      path: "/manage/segments";
      fullPath: "/admin/manage/segments/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageSegmentsIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/segments/new": {
      id: "/_authenticated/_feature_announcement/admin/manage/segments/new";
      path: "/manage/segments/new";
      fullPath: "/admin/manage/segments/new";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageSegmentsNewRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/plan/budgeting/": {
      id: "/_authenticated/_feature_announcement/admin/plan/budgeting/";
      path: "/plan/budgeting";
      fullPath: "/admin/plan/budgeting/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminPlanBudgetingIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/surveys/$surveyId/edit": {
      id: "/_authenticated/_feature_announcement/admin/surveys/$surveyId/edit";
      path: "/surveys/$surveyId/edit";
      fullPath: "/admin/surveys/$surveyId/edit";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSurveysSurveyIdEditRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/surveys/$surveyId/responses": {
      id: "/_authenticated/_feature_announcement/admin/surveys/$surveyId/responses";
      path: "/surveys/$surveyId/responses";
      fullPath: "/admin/surveys/$surveyId/responses";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSurveysSurveyIdResponsesRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/branding/colors": {
      id: "/_authenticated/_feature_announcement/admin/system/branding/colors";
      path: "/colors";
      fullPath: "/admin/system/branding/colors";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemBrandingColorsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemBrandingRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/branding/home": {
      id: "/_authenticated/_feature_announcement/admin/system/branding/home";
      path: "/home";
      fullPath: "/admin/system/branding/home";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemBrandingHomeRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemBrandingRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/branding/logos": {
      id: "/_authenticated/_feature_announcement/admin/system/branding/logos";
      path: "/logos";
      fullPath: "/admin/system/branding/logos";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemBrandingLogosRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemBrandingRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/branding/theme": {
      id: "/_authenticated/_feature_announcement/admin/system/branding/theme";
      path: "/theme";
      fullPath: "/admin/system/branding/theme";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemBrandingThemeRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemBrandingRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/integrations/": {
      id: "/_authenticated/_feature_announcement/admin/system/integrations/";
      path: "/";
      fullPath: "/admin/system/integrations/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemIntegrationsIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemIntegrationsRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/integrations/mentorcliq": {
      id: "/_authenticated/_feature_announcement/admin/system/integrations/mentorcliq";
      path: "/mentorcliq";
      fullPath: "/admin/system/integrations/mentorcliq";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemIntegrationsMentorcliqRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemIntegrationsRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/integrations/outlook": {
      id: "/_authenticated/_feature_announcement/admin/system/integrations/outlook";
      path: "/outlook";
      fullPath: "/admin/system/integrations/outlook";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemIntegrationsOutlookRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemIntegrationsRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/integrations/simpplr": {
      id: "/_authenticated/_feature_announcement/admin/system/integrations/simpplr";
      path: "/simpplr";
      fullPath: "/admin/system/integrations/simpplr";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemIntegrationsSimpplrRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemIntegrationsRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/integrations/slack": {
      id: "/_authenticated/_feature_announcement/admin/system/integrations/slack";
      path: "/slack";
      fullPath: "/admin/system/integrations/slack";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemIntegrationsSlackRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemIntegrationsRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/integrations/teams": {
      id: "/_authenticated/_feature_announcement/admin/system/integrations/teams";
      path: "/teams";
      fullPath: "/admin/system/integrations/teams";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemIntegrationsTeamsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemIntegrationsRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/integrations/ukg": {
      id: "/_authenticated/_feature_announcement/admin/system/integrations/ukg";
      path: "/ukg";
      fullPath: "/admin/system/integrations/ukg";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemIntegrationsUkgRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemIntegrationsRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/integrations/viva-engage": {
      id: "/_authenticated/_feature_announcement/admin/system/integrations/viva-engage";
      path: "/viva-engage";
      fullPath: "/admin/system/integrations/viva-engage";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemIntegrationsVivaEngageRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemIntegrationsRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/roles/role_configuration": {
      id: "/_authenticated/_feature_announcement/admin/system/roles/role_configuration";
      path: "/role_configuration";
      fullPath: "/admin/system/roles/role_configuration";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemRolesRole_configurationRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemRolesRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/settings/_configuration": {
      id: "/_authenticated/_feature_announcement/admin/system/settings/_configuration";
      path: "";
      fullPath: "/admin/system/settings";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsConfigurationRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/settings/custom_texts": {
      id: "/_authenticated/_feature_announcement/admin/system/settings/custom_texts";
      path: "/custom_texts";
      fullPath: "/admin/system/settings/custom_texts";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsCustom_textsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/settings/fields": {
      id: "/_authenticated/_feature_announcement/admin/system/settings/fields";
      path: "/fields";
      fullPath: "/admin/system/settings/fields";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsFieldsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/settings/sso": {
      id: "/_authenticated/_feature_announcement/admin/system/settings/sso";
      path: "/sso";
      fullPath: "/admin/system/settings/sso";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsSsoRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/users/import": {
      id: "/_authenticated/_feature_announcement/admin/system/users/import";
      path: "/import";
      fullPath: "/admin/system/users/import";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersImportRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/users/list": {
      id: "/_authenticated/_feature_announcement/admin/system/users/list";
      path: "/list";
      fullPath: "/admin/system/users/list";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersListRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/users/merge": {
      id: "/_authenticated/_feature_announcement/admin/system/users/merge";
      path: "/merge";
      fullPath: "/admin/system/users/merge";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersMergeRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/users/new": {
      id: "/_authenticated/_feature_announcement/admin/system/users/new";
      path: "/new";
      fullPath: "/admin/system/users/new";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersNewRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/budgeting/manage": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/budgeting/manage";
      path: "/manage";
      fullPath: "/communities/$communityId/budgeting/manage";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingManageRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/budgeting/overview": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/budgeting/overview";
      path: "/overview";
      fullPath: "/communities/$communityId/budgeting/overview";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingOverviewRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/budgeting/request": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/budgeting/request";
      path: "/request";
      fullPath: "/communities/$communityId/budgeting/request";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRequestRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/events/": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/events/";
      path: "/events";
      fullPath: "/communities/$communityId/events/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/events/pending": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/events/pending";
      path: "/events/pending";
      fullPath: "/communities/$communityId/events/pending";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsPendingRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/manage/archives": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/manage/archives";
      path: "/archives";
      fullPath: "/communities/$communityId/manage/archives";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageArchivesRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/manage/community-lab-report": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/manage/community-lab-report";
      path: "/community-lab-report";
      fullPath: "/communities/$communityId/manage/community-lab-report";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunityLabReportRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/manage/review_settings": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/manage/review_settings";
      path: "/review_settings";
      fullPath: "/communities/$communityId/manage/review_settings";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageReview_settingsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/manage/role_configuration": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/manage/role_configuration";
      path: "/role_configuration";
      fullPath: "/communities/$communityId/manage/role_configuration";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRole_configurationRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/manage/settings": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/manage/settings";
      path: "/settings";
      fullPath: "/communities/$communityId/manage/settings";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/members/": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/members/";
      path: "/";
      fullPath: "/communities/$communityId/members/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersRouteRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/members/automations": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/members/automations";
      path: "/automations";
      fullPath: "/communities/$communityId/members/automations";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRouteRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersRouteRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/members/invitations": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/members/invitations";
      path: "/invitations";
      fullPath: "/communities/$communityId/members/invitations";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersInvitationsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersRouteRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/plan/budgeting": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/plan/budgeting";
      path: "/budgeting";
      fullPath: "/communities/$communityId/plan/budgeting";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/plan/events": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/plan/events";
      path: "/events";
      fullPath: "/communities/$communityId/plan/events";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanEventsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/posts/": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/posts/";
      path: "/posts";
      fullPath: "/communities/$communityId/posts/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPostsIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/roi-suite/$": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/roi-suite/$";
      path: "/roi-suite/$";
      fullPath: "/communities/$communityId/roi-suite/$";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdRoiSuiteSplatRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdRoute;
    };
    "/_authenticated/_feature_announcement/_user/global-survey-response/$surveyId/cohorts/$cohortId": {
      id: "/_authenticated/_feature_announcement/_user/global-survey-response/$surveyId/cohorts/$cohortId";
      path: "/cohorts/$cohortId";
      fullPath: "/global-survey-response/$surveyId/cohorts/$cohortId";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdCohortsCohortIdRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdRoute;
    };
    "/_authenticated/_feature_announcement/_user/network-survey-response/$networkId/$surveyId/": {
      id: "/_authenticated/_feature_announcement/_user/network-survey-response/$networkId/$surveyId/";
      path: "/";
      fullPath: "/network-survey-response/$networkId/$surveyId/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdRoute;
    };
    "/_authenticated/_feature_announcement/_user/profile/edit/record-hours/$communityId": {
      id: "/_authenticated/_feature_announcement/_user/profile/edit/record-hours/$communityId";
      path: "/edit/record-hours/$communityId";
      fullPath: "/profile/edit/record-hours/$communityId";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserProfileEditRecordHoursCommunityIdRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserProfileRoute;
    };
    "/_authenticated/_feature_announcement/admin/gamification/achievements/$achievementId/edit": {
      id: "/_authenticated/_feature_announcement/admin/gamification/achievements/$achievementId/edit";
      path: "/gamification/achievements/$achievementId/edit";
      fullPath: "/admin/gamification/achievements/$achievementId/edit";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminGamificationAchievementsAchievementIdEditRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/gamification/rewards/$rewardId/edit": {
      id: "/_authenticated/_feature_announcement/admin/gamification/rewards/$rewardId/edit";
      path: "/$rewardId/edit";
      fullPath: "/admin/gamification/rewards/$rewardId/edit";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminGamificationRewardsRewardIdEditRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminGamificationRewardsRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/calendar/$calendarId/update": {
      id: "/_authenticated/_feature_announcement/admin/manage/calendar/$calendarId/update";
      path: "/manage/calendar/$calendarId/update";
      fullPath: "/admin/manage/calendar/$calendarId/update";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageCalendarCalendarIdUpdateRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/communications/$communicationId/distributions": {
      id: "/_authenticated/_feature_announcement/admin/manage/communications/$communicationId/distributions";
      path: "/manage/communications/$communicationId/distributions";
      fullPath: "/admin/manage/communications/$communicationId/distributions";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdDistributionsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/communications/$communicationId/edit": {
      id: "/_authenticated/_feature_announcement/admin/manage/communications/$communicationId/edit";
      path: "/manage/communications/$communicationId/edit";
      fullPath: "/admin/manage/communications/$communicationId/edit";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdEditRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/communications/$communicationId/recipients": {
      id: "/_authenticated/_feature_announcement/admin/manage/communications/$communicationId/recipients";
      path: "/manage/communications/$communicationId/recipients";
      fullPath: "/admin/manage/communications/$communicationId/recipients";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdRecipientsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/events/notable_dates_calendar/": {
      id: "/_authenticated/_feature_announcement/admin/manage/events/notable_dates_calendar/";
      path: "/notable_dates_calendar";
      fullPath: "/admin/manage/events/notable_dates_calendar/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminManageEventsRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/events/notable_dates_calendar/create": {
      id: "/_authenticated/_feature_announcement/admin/manage/events/notable_dates_calendar/create";
      path: "/notable_dates_calendar/create";
      fullPath: "/admin/manage/events/notable_dates_calendar/create";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCreateRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminManageEventsRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/groups/$groupId/categorize": {
      id: "/_authenticated/_feature_announcement/admin/manage/groups/$groupId/categorize";
      path: "/manage/groups/$groupId/categorize";
      fullPath: "/admin/manage/groups/$groupId/categorize";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageGroupsGroupIdCategorizeRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/groups/$groupId/edit": {
      id: "/_authenticated/_feature_announcement/admin/manage/groups/$groupId/edit";
      path: "/manage/groups/$groupId/edit";
      fullPath: "/admin/manage/groups/$groupId/edit";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageGroupsGroupIdEditRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/groups/categories/": {
      id: "/_authenticated/_feature_announcement/admin/manage/groups/categories/";
      path: "/manage/groups/categories";
      fullPath: "/admin/manage/groups/categories/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageGroupsCategoriesIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/groups/categories/new": {
      id: "/_authenticated/_feature_announcement/admin/manage/groups/categories/new";
      path: "/manage/groups/categories/new";
      fullPath: "/admin/manage/groups/categories/new";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageGroupsCategoriesNewRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/segments/$segmentId/edit": {
      id: "/_authenticated/_feature_announcement/admin/manage/segments/$segmentId/edit";
      path: "/manage/segments/$segmentId/edit";
      fullPath: "/admin/manage/segments/$segmentId/edit";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageSegmentsSegmentIdEditRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/plan/budgeting/fiscal_periods/new": {
      id: "/_authenticated/_feature_announcement/admin/plan/budgeting/fiscal_periods/new";
      path: "/plan/budgeting/fiscal_periods/new";
      fullPath: "/admin/plan/budgeting/fiscal_periods/new";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminPlanBudgetingFiscal_periodsNewRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/branding/sponsors/": {
      id: "/_authenticated/_feature_announcement/admin/system/branding/sponsors/";
      path: "/sponsors";
      fullPath: "/admin/system/branding/sponsors/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemBrandingSponsorsIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemBrandingRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/branding/sponsors/new": {
      id: "/_authenticated/_feature_announcement/admin/system/branding/sponsors/new";
      path: "/sponsors/new";
      fullPath: "/admin/system/branding/sponsors/new";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemBrandingSponsorsNewRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemBrandingRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/roles/community/": {
      id: "/_authenticated/_feature_announcement/admin/system/roles/community/";
      path: "/community";
      fullPath: "/admin/system/roles/community/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemRolesCommunityIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemRolesRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/roles/platform/": {
      id: "/_authenticated/_feature_announcement/admin/system/roles/platform/";
      path: "/platform";
      fullPath: "/admin/system/roles/platform/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemRolesPlatformIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemRolesRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/settings/_configuration/communities": {
      id: "/_authenticated/_feature_announcement/admin/system/settings/_configuration/communities";
      path: "/communities";
      fullPath: "/admin/system/settings/communities";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsConfigurationCommunitiesRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsConfigurationRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/settings/_configuration/configuration": {
      id: "/_authenticated/_feature_announcement/admin/system/settings/_configuration/configuration";
      path: "/configuration";
      fullPath: "/admin/system/settings/configuration";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsConfigurationConfigurationRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsConfigurationRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/settings/_configuration/modules": {
      id: "/_authenticated/_feature_announcement/admin/system/settings/_configuration/modules";
      path: "/modules";
      fullPath: "/admin/system/settings/modules";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsConfigurationModulesRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsConfigurationRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/settings/_configuration/profile_fields": {
      id: "/_authenticated/_feature_announcement/admin/system/settings/_configuration/profile_fields";
      path: "/profile_fields";
      fullPath: "/admin/system/settings/profile_fields";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsConfigurationProfile_fieldsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsConfigurationRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/settings/emails/": {
      id: "/_authenticated/_feature_announcement/admin/system/settings/emails/";
      path: "/emails";
      fullPath: "/admin/system/settings/emails/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsEmailsIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/settings/policy_documents/": {
      id: "/_authenticated/_feature_announcement/admin/system/settings/policy_documents/";
      path: "/policy_documents";
      fullPath: "/admin/system/settings/policy_documents/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/settings/policy_documents/new": {
      id: "/_authenticated/_feature_announcement/admin/system/settings/policy_documents/new";
      path: "/policy_documents/new";
      fullPath: "/admin/system/settings/policy_documents/new";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsNewRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/users/$userId/": {
      id: "/_authenticated/_feature_announcement/admin/system/users/$userId/";
      path: "/$userId";
      fullPath: "/admin/system/users/$userId/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/users/$userId/edit": {
      id: "/_authenticated/_feature_announcement/admin/system/users/$userId/edit";
      path: "/$userId/edit";
      fullPath: "/admin/system/users/$userId/edit";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdEditRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/users/$userId/role_assignments": {
      id: "/_authenticated/_feature_announcement/admin/system/users/$userId/role_assignments";
      path: "/$userId/role_assignments";
      fullPath: "/admin/system/users/$userId/role_assignments";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdRole_assignmentsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/users/$userId/statistics": {
      id: "/_authenticated/_feature_announcement/admin/system/users/$userId/statistics";
      path: "/$userId/statistics";
      fullPath: "/admin/system/users/$userId/statistics";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdStatisticsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/users/policy_templates/": {
      id: "/_authenticated/_feature_announcement/admin/system/users/policy_templates/";
      path: "/policy_templates";
      fullPath: "/admin/system/users/policy_templates/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersPolicy_templatesIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/users/roles/": {
      id: "/_authenticated/_feature_announcement/admin/system/users/roles/";
      path: "/roles";
      fullPath: "/admin/system/users/roles/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersRolesIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/users/roles/new": {
      id: "/_authenticated/_feature_announcement/admin/system/users/roles/new";
      path: "/roles/new";
      fullPath: "/admin/system/users/roles/new";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersRolesNewRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/events/$eventId/": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/events/$eventId/";
      path: "/events/$eventId";
      fullPath: "/communities/$communityId/events/$eventId/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/events/$eventId/edit": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/events/$eventId/edit";
      path: "/events/$eventId/edit";
      fullPath: "/communities/$communityId/events/$eventId/edit";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdEditRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/manage/communications/": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/manage/communications/";
      path: "/communications";
      fullPath: "/communities/$communityId/manage/communications/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/manage/communications/new": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/manage/communications/new";
      path: "/communications/new";
      fullPath: "/communities/$communityId/manage/communications/new";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsNewRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/manage/events/pending": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/manage/events/pending";
      path: "/events/pending";
      fullPath: "/communities/$communityId/manage/events/pending";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageEventsPendingRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/manage/leaders/": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/manage/leaders/";
      path: "/leaders";
      fullPath: "/communities/$communityId/manage/leaders/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/manage/leaders/new": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/manage/leaders/new";
      path: "/leaders/new";
      fullPath: "/communities/$communityId/manage/leaders/new";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersNewRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/manage/settings/": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/manage/settings/";
      path: "/";
      fullPath: "/communities/$communityId/manage/settings/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/manage/settings/integration": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/manage/settings/integration";
      path: "/integration";
      fullPath: "/communities/$communityId/manage/settings/integration";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsIntegrationRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/manage/settings/welcome_message": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/manage/settings/welcome_message";
      path: "/welcome_message";
      fullPath: "/communities/$communityId/manage/settings/welcome_message";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsWelcome_messageRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/manage/sponsors/": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/manage/sponsors/";
      path: "/sponsors";
      fullPath: "/communities/$communityId/manage/sponsors/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/manage/sponsors/new": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/manage/sponsors/new";
      path: "/sponsors/new";
      fullPath: "/communities/$communityId/manage/sponsors/new";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsNewRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/manage/surveys/": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/manage/surveys/";
      path: "/surveys";
      fullPath: "/communities/$communityId/manage/surveys/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/manage/surveys/new": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/manage/surveys/new";
      path: "/surveys/new";
      fullPath: "/communities/$communityId/manage/surveys/new";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysNewRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/members/automations/": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/members/automations/";
      path: "/";
      fullPath: "/communities/$communityId/members/automations/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRouteRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/members/automations/new": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/members/automations/new";
      path: "/new";
      fullPath: "/communities/$communityId/members/automations/new";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsNewRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRouteRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/plan/budgeting/manage": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/plan/budgeting/manage";
      path: "/manage";
      fullPath: "/communities/$communityId/plan/budgeting/manage";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingManageRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/plan/budgeting/overview": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/plan/budgeting/overview";
      path: "/overview";
      fullPath: "/communities/$communityId/plan/budgeting/overview";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingOverviewRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/plan/budgeting/request": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/plan/budgeting/request";
      path: "/request";
      fullPath: "/communities/$communityId/plan/budgeting/request";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRequestRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/plan/outcomes/": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/plan/outcomes/";
      path: "/outcomes";
      fullPath: "/communities/$communityId/plan/outcomes/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/plan/outcomes/new": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/plan/outcomes/new";
      path: "/outcomes/new";
      fullPath: "/communities/$communityId/plan/outcomes/new";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesNewRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/plan/pillars/": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/plan/pillars/";
      path: "/pillars";
      fullPath: "/communities/$communityId/plan/pillars/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/plan/pillars/new": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/plan/pillars/new";
      path: "/pillars/new";
      fullPath: "/communities/$communityId/plan/pillars/new";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsNewRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/posts/$postId/": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/posts/$postId/";
      path: "/posts/$postId";
      fullPath: "/communities/$communityId/posts/$postId/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPostsPostIdIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/posts/$postId/edit": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/posts/$postId/edit";
      path: "/posts/$postId/edit";
      fullPath: "/communities/$communityId/posts/$postId/edit";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPostsPostIdEditRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdRoute;
    };
    "/_authenticated/_feature_announcement/_user/network-survey-response/$networkId/$surveyId/cohorts/$cohortId": {
      id: "/_authenticated/_feature_announcement/_user/network-survey-response/$networkId/$surveyId/cohorts/$cohortId";
      path: "/cohorts/$cohortId";
      fullPath: "/network-survey-response/$networkId/$surveyId/cohorts/$cohortId";
      preLoaderRoute: typeof AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdCohortsCohortIdRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/calendar/$calendarId/notable_dates/create": {
      id: "/_authenticated/_feature_announcement/admin/manage/calendar/$calendarId/notable_dates/create";
      path: "/manage/calendar/$calendarId/notable_dates/create";
      fullPath: "/admin/manage/calendar/$calendarId/notable_dates/create";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageCalendarCalendarIdNotable_datesCreateRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/events/notable_dates_calendar/$calendarId/update": {
      id: "/_authenticated/_feature_announcement/admin/manage/events/notable_dates_calendar/$calendarId/update";
      path: "/notable_dates_calendar/$calendarId/update";
      fullPath: "/admin/manage/events/notable_dates_calendar/$calendarId/update";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdUpdateRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminManageEventsRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/groups/$groupId/regions/": {
      id: "/_authenticated/_feature_announcement/admin/manage/groups/$groupId/regions/";
      path: "/manage/groups/$groupId/regions";
      fullPath: "/admin/manage/groups/$groupId/regions/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/groups/$groupId/regions/new": {
      id: "/_authenticated/_feature_announcement/admin/manage/groups/$groupId/regions/new";
      path: "/manage/groups/$groupId/regions/new";
      fullPath: "/admin/manage/groups/$groupId/regions/new";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsNewRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/groups/categories/$categoryId/edit": {
      id: "/_authenticated/_feature_announcement/admin/manage/groups/categories/$categoryId/edit";
      path: "/manage/groups/categories/$categoryId/edit";
      fullPath: "/admin/manage/groups/categories/$categoryId/edit";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageGroupsCategoriesCategoryIdEditRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/branding/sponsors/$sponsorId/edit": {
      id: "/_authenticated/_feature_announcement/admin/system/branding/sponsors/$sponsorId/edit";
      path: "/sponsors/$sponsorId/edit";
      fullPath: "/admin/system/branding/sponsors/$sponsorId/edit";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemBrandingSponsorsSponsorIdEditRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemBrandingRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/roles/community/$roleId/": {
      id: "/_authenticated/_feature_announcement/admin/system/roles/community/$roleId/";
      path: "/community/$roleId";
      fullPath: "/admin/system/roles/community/$roleId/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemRolesCommunityRoleIdIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemRolesRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/roles/community/$roleId/permissions": {
      id: "/_authenticated/_feature_announcement/admin/system/roles/community/$roleId/permissions";
      path: "/community/$roleId/permissions";
      fullPath: "/admin/system/roles/community/$roleId/permissions";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemRolesCommunityRoleIdPermissionsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemRolesRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/roles/platform/$roleId/": {
      id: "/_authenticated/_feature_announcement/admin/system/roles/platform/$roleId/";
      path: "/platform/$roleId";
      fullPath: "/admin/system/roles/platform/$roleId/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemRolesPlatformRoleIdIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemRolesRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/roles/platform/$roleId/permissions": {
      id: "/_authenticated/_feature_announcement/admin/system/roles/platform/$roleId/permissions";
      path: "/platform/$roleId/permissions";
      fullPath: "/admin/system/roles/platform/$roleId/permissions";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemRolesPlatformRoleIdPermissionsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemRolesRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/settings/emails/$emailId/edit": {
      id: "/_authenticated/_feature_announcement/admin/system/settings/emails/$emailId/edit";
      path: "/emails/$emailId/edit";
      fullPath: "/admin/system/settings/emails/$emailId/edit";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsEmailsEmailIdEditRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/settings/policy_documents/edit/$policyDocumentId": {
      id: "/_authenticated/_feature_announcement/admin/system/settings/policy_documents/edit/$policyDocumentId";
      path: "/policy_documents/edit/$policyDocumentId";
      fullPath: "/admin/system/settings/policy_documents/edit/$policyDocumentId";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsEditPolicyDocumentIdRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/users/$userId/edit/fields": {
      id: "/_authenticated/_feature_announcement/admin/system/users/$userId/edit/fields";
      path: "/fields";
      fullPath: "/admin/system/users/$userId/edit/fields";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdEditFieldsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdEditRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/users/$userId/edit/general": {
      id: "/_authenticated/_feature_announcement/admin/system/users/$userId/edit/general";
      path: "/general";
      fullPath: "/admin/system/users/$userId/edit/general";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdEditGeneralRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdEditRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/users/policy_templates/$policyId/edit": {
      id: "/_authenticated/_feature_announcement/admin/system/users/policy_templates/$policyId/edit";
      path: "/policy_templates/$policyId/edit";
      fullPath: "/admin/system/users/policy_templates/$policyId/edit";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersPolicy_templatesPolicyIdEditRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersRoute;
    };
    "/_authenticated/_feature_announcement/admin/system/users/roles/$roleId/edit": {
      id: "/_authenticated/_feature_announcement/admin/system/users/roles/$roleId/edit";
      path: "/roles/$roleId/edit";
      fullPath: "/admin/system/users/roles/$roleId/edit";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersRolesRoleIdEditRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/events/$eventId/manage/attendees": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/events/$eventId/manage/attendees";
      path: "/events/$eventId/manage/attendees";
      fullPath: "/communities/$communityId/events/$eventId/manage/attendees";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageAttendeesRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/events/$eventId/manage/budgeting": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/events/$eventId/manage/budgeting";
      path: "/events/$eventId/manage/budgeting";
      fullPath: "/communities/$communityId/events/$eventId/manage/budgeting";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageBudgetingRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/events/$eventId/manage/waitlist": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/events/$eventId/manage/waitlist";
      path: "/events/$eventId/manage/waitlist";
      fullPath: "/communities/$communityId/events/$eventId/manage/waitlist";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageWaitlistRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/manage/communications/$communicationId/distributions": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/manage/communications/$communicationId/distributions";
      path: "/communications/$communicationId/distributions";
      fullPath: "/communities/$communityId/manage/communications/$communicationId/distributions";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdDistributionsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/manage/communications/$communicationId/edit": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/manage/communications/$communicationId/edit";
      path: "/communications/$communicationId/edit";
      fullPath: "/communities/$communityId/manage/communications/$communicationId/edit";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdEditRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/manage/communications/$communicationId/recipients": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/manage/communications/$communicationId/recipients";
      path: "/communications/$communicationId/recipients";
      fullPath: "/communities/$communityId/manage/communications/$communicationId/recipients";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdRecipientsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/manage/leaders/$leaderId/edit": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/manage/leaders/$leaderId/edit";
      path: "/leaders/$leaderId/edit";
      fullPath: "/communities/$communityId/manage/leaders/$leaderId/edit";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersLeaderIdEditRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/manage/sponsors/$sponsorId/edit": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/manage/sponsors/$sponsorId/edit";
      path: "/sponsors/$sponsorId/edit";
      fullPath: "/communities/$communityId/manage/sponsors/$sponsorId/edit";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsSponsorIdEditRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/manage/surveys/$surveyId/edit": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/manage/surveys/$surveyId/edit";
      path: "/surveys/$surveyId/edit";
      fullPath: "/communities/$communityId/manage/surveys/$surveyId/edit";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysSurveyIdEditRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/manage/surveys/$surveyId/responses": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/manage/surveys/$surveyId/responses";
      path: "/surveys/$surveyId/responses";
      fullPath: "/communities/$communityId/manage/surveys/$surveyId/responses";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysSurveyIdResponsesRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/members/automations/$ruleId/edit": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/members/automations/$ruleId/edit";
      path: "/$ruleId/edit";
      fullPath: "/communities/$communityId/members/automations/$ruleId/edit";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRuleIdEditRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRouteRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/members/automations/history/": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/members/automations/history/";
      path: "/history";
      fullPath: "/communities/$communityId/members/automations/history/";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsHistoryIndexRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRouteRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/members/automations/history/$runId": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/members/automations/history/$runId";
      path: "/history/$runId";
      fullPath: "/communities/$communityId/members/automations/history/$runId";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsHistoryRunIdRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRouteRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/plan/outcomes/$outcomeId/edit": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/plan/outcomes/$outcomeId/edit";
      path: "/outcomes/$outcomeId/edit";
      fullPath: "/communities/$communityId/plan/outcomes/$outcomeId/edit";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesOutcomeIdEditRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/plan/pillars/$pillarId/edit": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/plan/pillars/$pillarId/edit";
      path: "/pillars/$pillarId/edit";
      fullPath: "/communities/$communityId/plan/pillars/$pillarId/edit";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsPillarIdEditRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRoute;
    };
    "/_authenticated/_feature_announcement/communities/$communityId/plan/pillars/$pillarId/events": {
      id: "/_authenticated/_feature_announcement/communities/$communityId/plan/pillars/$pillarId/events";
      path: "/pillars/$pillarId/events";
      fullPath: "/communities/$communityId/plan/pillars/$pillarId/events";
      preLoaderRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsPillarIdEventsRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/calendar/$calendarId/notable_dates/$eventId/update": {
      id: "/_authenticated/_feature_announcement/admin/manage/calendar/$calendarId/notable_dates/$eventId/update";
      path: "/manage/calendar/$calendarId/notable_dates/$eventId/update";
      fullPath: "/admin/manage/calendar/$calendarId/notable_dates/$eventId/update";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageCalendarCalendarIdNotable_datesEventIdUpdateRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/events/notable_dates_calendar/$calendarId/notable_dates/create": {
      id: "/_authenticated/_feature_announcement/admin/manage/events/notable_dates_calendar/$calendarId/notable_dates/create";
      path: "/notable_dates_calendar/$calendarId/notable_dates/create";
      fullPath: "/admin/manage/events/notable_dates_calendar/$calendarId/notable_dates/create";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdNotable_datesCreateRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminManageEventsRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/groups/$groupId/regions/$regionId/edit": {
      id: "/_authenticated/_feature_announcement/admin/manage/groups/$groupId/regions/$regionId/edit";
      path: "/manage/groups/$groupId/regions/$regionId/edit";
      fullPath: "/admin/manage/groups/$groupId/regions/$regionId/edit";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsRegionIdEditRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminRoute;
    };
    "/_authenticated/_feature_announcement/admin/manage/events/notable_dates_calendar/$calendarId/notable_dates/$eventId/update": {
      id: "/_authenticated/_feature_announcement/admin/manage/events/notable_dates_calendar/$calendarId/notable_dates/$eventId/update";
      path: "/notable_dates_calendar/$calendarId/notable_dates/$eventId/update";
      fullPath: "/admin/manage/events/notable_dates_calendar/$calendarId/notable_dates/$eventId/update";
      preLoaderRoute: typeof AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdNotable_datesEventIdUpdateRouteImport;
      parentRoute: typeof AuthenticatedFeature_announcementAdminManageEventsRoute;
    };
  }
}

interface AnonymousRouteChildren {
  AnonymousMobile_sign_inRoute: typeof AnonymousMobile_sign_inRoute;
  AnonymousUnsubscribeRoute: typeof AnonymousUnsubscribeRoute;
  AnonymousEvent_checkinEventIdRoute: typeof AnonymousEvent_checkinEventIdRoute;
  AnonymousVerifyTokenRoute: typeof AnonymousVerifyTokenRoute;
}

const AnonymousRouteChildren: AnonymousRouteChildren = {
  AnonymousMobile_sign_inRoute: AnonymousMobile_sign_inRoute,
  AnonymousUnsubscribeRoute: AnonymousUnsubscribeRoute,
  AnonymousEvent_checkinEventIdRoute: AnonymousEvent_checkinEventIdRoute,
  AnonymousVerifyTokenRoute: AnonymousVerifyTokenRoute,
};

const AnonymousRouteWithChildren = AnonymousRoute._addFileChildren(
  AnonymousRouteChildren,
);

interface AuthenticatedFeature_announcementUserProfileRouteChildren {
  AuthenticatedFeature_announcementUserProfileStatisticsRoute: typeof AuthenticatedFeature_announcementUserProfileStatisticsRoute;
  AuthenticatedFeature_announcementUserProfileIndexRoute: typeof AuthenticatedFeature_announcementUserProfileIndexRoute;
  AuthenticatedFeature_announcementUserProfileEditAccessibilityRoute: typeof AuthenticatedFeature_announcementUserProfileEditAccessibilityRoute;
  AuthenticatedFeature_announcementUserProfileEditEngagementReportRoute: typeof AuthenticatedFeature_announcementUserProfileEditEngagementReportRoute;
  AuthenticatedFeature_announcementUserProfileEditGeneralRoute: typeof AuthenticatedFeature_announcementUserProfileEditGeneralRoute;
  AuthenticatedFeature_announcementUserProfileEditLeadershipRoute: typeof AuthenticatedFeature_announcementUserProfileEditLeadershipRoute;
  AuthenticatedFeature_announcementUserProfileEditNotificationRoute: typeof AuthenticatedFeature_announcementUserProfileEditNotificationRoute;
  AuthenticatedFeature_announcementUserProfileEditOutlookRoute: typeof AuthenticatedFeature_announcementUserProfileEditOutlookRoute;
  AuthenticatedFeature_announcementUserProfileEditPrivateRoute: typeof AuthenticatedFeature_announcementUserProfileEditPrivateRoute;
  AuthenticatedFeature_announcementUserProfileEditRecordHoursCommunityIdRoute: typeof AuthenticatedFeature_announcementUserProfileEditRecordHoursCommunityIdRoute;
}

const AuthenticatedFeature_announcementUserProfileRouteChildren: AuthenticatedFeature_announcementUserProfileRouteChildren =
  {
    AuthenticatedFeature_announcementUserProfileStatisticsRoute:
      AuthenticatedFeature_announcementUserProfileStatisticsRoute,
    AuthenticatedFeature_announcementUserProfileIndexRoute:
      AuthenticatedFeature_announcementUserProfileIndexRoute,
    AuthenticatedFeature_announcementUserProfileEditAccessibilityRoute:
      AuthenticatedFeature_announcementUserProfileEditAccessibilityRoute,
    AuthenticatedFeature_announcementUserProfileEditEngagementReportRoute:
      AuthenticatedFeature_announcementUserProfileEditEngagementReportRoute,
    AuthenticatedFeature_announcementUserProfileEditGeneralRoute:
      AuthenticatedFeature_announcementUserProfileEditGeneralRoute,
    AuthenticatedFeature_announcementUserProfileEditLeadershipRoute:
      AuthenticatedFeature_announcementUserProfileEditLeadershipRoute,
    AuthenticatedFeature_announcementUserProfileEditNotificationRoute:
      AuthenticatedFeature_announcementUserProfileEditNotificationRoute,
    AuthenticatedFeature_announcementUserProfileEditOutlookRoute:
      AuthenticatedFeature_announcementUserProfileEditOutlookRoute,
    AuthenticatedFeature_announcementUserProfileEditPrivateRoute:
      AuthenticatedFeature_announcementUserProfileEditPrivateRoute,
    AuthenticatedFeature_announcementUserProfileEditRecordHoursCommunityIdRoute:
      AuthenticatedFeature_announcementUserProfileEditRecordHoursCommunityIdRoute,
  };

const AuthenticatedFeature_announcementUserProfileRouteWithChildren =
  AuthenticatedFeature_announcementUserProfileRoute._addFileChildren(
    AuthenticatedFeature_announcementUserProfileRouteChildren,
  );

interface AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdRouteChildren {
  AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdIndexRoute: typeof AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdIndexRoute;
  AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdCohortsCohortIdRoute: typeof AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdCohortsCohortIdRoute;
}

const AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdRouteChildren: AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdRouteChildren =
  {
    AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdIndexRoute:
      AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdIndexRoute,
    AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdCohortsCohortIdRoute:
      AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdCohortsCohortIdRoute,
  };

const AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdRouteWithChildren =
  AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdRoute._addFileChildren(
    AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdRouteChildren,
  );

interface AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdRouteChildren {
  AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdIndexRoute: typeof AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdIndexRoute;
  AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdCohortsCohortIdRoute: typeof AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdCohortsCohortIdRoute;
}

const AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdRouteChildren: AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdRouteChildren =
  {
    AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdIndexRoute:
      AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdIndexRoute,
    AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdCohortsCohortIdRoute:
      AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdCohortsCohortIdRoute,
  };

const AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdRouteWithChildren =
  AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdRoute._addFileChildren(
    AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdRouteChildren,
  );

interface AuthenticatedFeature_announcementUserRouteChildren {
  AuthenticatedFeature_announcementUserCommunitiesRoute: typeof AuthenticatedFeature_announcementUserCommunitiesRoute;
  AuthenticatedFeature_announcementUserDownloadsRoute: typeof AuthenticatedFeature_announcementUserDownloadsRoute;
  AuthenticatedFeature_announcementUserGroupsRoute: typeof AuthenticatedFeature_announcementUserGroupsRoute;
  AuthenticatedFeature_announcementUserNotificationsRoute: typeof AuthenticatedFeature_announcementUserNotificationsRoute;
  AuthenticatedFeature_announcementUserProfileRoute: typeof AuthenticatedFeature_announcementUserProfileRouteWithChildren;
  AuthenticatedFeature_announcementUserRewardsRoute: typeof AuthenticatedFeature_announcementUserRewardsRoute;
  AuthenticatedFeature_announcementUserSupportRoute: typeof AuthenticatedFeature_announcementUserSupportRoute;
  AuthenticatedFeature_announcementUserIndexRoute: typeof AuthenticatedFeature_announcementUserIndexRoute;
  AuthenticatedFeature_announcementUserCommunityLabSplatRoute: typeof AuthenticatedFeature_announcementUserCommunityLabSplatRoute;
  AuthenticatedFeature_announcementUserCommunityLabSessionRoute: typeof AuthenticatedFeature_announcementUserCommunityLabSessionRoute;
  AuthenticatedFeature_announcementUserCommunityLabWorksheetRoute: typeof AuthenticatedFeature_announcementUserCommunityLabWorksheetRoute;
  AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdRoute: typeof AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdRouteWithChildren;
  AuthenticatedFeature_announcementUserCommunityLabIndexRoute: typeof AuthenticatedFeature_announcementUserCommunityLabIndexRoute;
  AuthenticatedFeature_announcementUserEventsIndexRoute: typeof AuthenticatedFeature_announcementUserEventsIndexRoute;
  AuthenticatedFeature_announcementUserPostsIndexRoute: typeof AuthenticatedFeature_announcementUserPostsIndexRoute;
  AuthenticatedFeature_announcementUserEventsEventIdSplatRoute: typeof AuthenticatedFeature_announcementUserEventsEventIdSplatRoute;
  AuthenticatedFeature_announcementUserEventsDraftsDraftIdRoute: typeof AuthenticatedFeature_announcementUserEventsDraftsDraftIdRoute;
  AuthenticatedFeature_announcementUserEventsDraftsNewRoute: typeof AuthenticatedFeature_announcementUserEventsDraftsNewRoute;
  AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdRoute: typeof AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdRouteWithChildren;
  AuthenticatedFeature_announcementUserPostsPostIdSplatRoute: typeof AuthenticatedFeature_announcementUserPostsPostIdSplatRoute;
  AuthenticatedFeature_announcementUserPostsDraftsDraftIdRoute: typeof AuthenticatedFeature_announcementUserPostsDraftsDraftIdRoute;
  AuthenticatedFeature_announcementUserUserUserIdAchievementsRoute: typeof AuthenticatedFeature_announcementUserUserUserIdAchievementsRoute;
  AuthenticatedFeature_announcementUserUserUserIdEditRoute: typeof AuthenticatedFeature_announcementUserUserUserIdEditRoute;
  AuthenticatedFeature_announcementUserUserUserIdStatisticsRoute: typeof AuthenticatedFeature_announcementUserUserUserIdStatisticsRoute;
  AuthenticatedFeature_announcementUserUserUserIdTransactionsRoute: typeof AuthenticatedFeature_announcementUserUserUserIdTransactionsRoute;
  AuthenticatedFeature_announcementUserEventsDraftsIndexRoute: typeof AuthenticatedFeature_announcementUserEventsDraftsIndexRoute;
  AuthenticatedFeature_announcementUserPostsDraftsIndexRoute: typeof AuthenticatedFeature_announcementUserPostsDraftsIndexRoute;
  AuthenticatedFeature_announcementUserUserUserIdIndexRoute: typeof AuthenticatedFeature_announcementUserUserUserIdIndexRoute;
}

const AuthenticatedFeature_announcementUserRouteChildren: AuthenticatedFeature_announcementUserRouteChildren =
  {
    AuthenticatedFeature_announcementUserCommunitiesRoute:
      AuthenticatedFeature_announcementUserCommunitiesRoute,
    AuthenticatedFeature_announcementUserDownloadsRoute:
      AuthenticatedFeature_announcementUserDownloadsRoute,
    AuthenticatedFeature_announcementUserGroupsRoute:
      AuthenticatedFeature_announcementUserGroupsRoute,
    AuthenticatedFeature_announcementUserNotificationsRoute:
      AuthenticatedFeature_announcementUserNotificationsRoute,
    AuthenticatedFeature_announcementUserProfileRoute:
      AuthenticatedFeature_announcementUserProfileRouteWithChildren,
    AuthenticatedFeature_announcementUserRewardsRoute:
      AuthenticatedFeature_announcementUserRewardsRoute,
    AuthenticatedFeature_announcementUserSupportRoute:
      AuthenticatedFeature_announcementUserSupportRoute,
    AuthenticatedFeature_announcementUserIndexRoute:
      AuthenticatedFeature_announcementUserIndexRoute,
    AuthenticatedFeature_announcementUserCommunityLabSplatRoute:
      AuthenticatedFeature_announcementUserCommunityLabSplatRoute,
    AuthenticatedFeature_announcementUserCommunityLabSessionRoute:
      AuthenticatedFeature_announcementUserCommunityLabSessionRoute,
    AuthenticatedFeature_announcementUserCommunityLabWorksheetRoute:
      AuthenticatedFeature_announcementUserCommunityLabWorksheetRoute,
    AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdRoute:
      AuthenticatedFeature_announcementUserGlobalSurveyResponseSurveyIdRouteWithChildren,
    AuthenticatedFeature_announcementUserCommunityLabIndexRoute:
      AuthenticatedFeature_announcementUserCommunityLabIndexRoute,
    AuthenticatedFeature_announcementUserEventsIndexRoute:
      AuthenticatedFeature_announcementUserEventsIndexRoute,
    AuthenticatedFeature_announcementUserPostsIndexRoute:
      AuthenticatedFeature_announcementUserPostsIndexRoute,
    AuthenticatedFeature_announcementUserEventsEventIdSplatRoute:
      AuthenticatedFeature_announcementUserEventsEventIdSplatRoute,
    AuthenticatedFeature_announcementUserEventsDraftsDraftIdRoute:
      AuthenticatedFeature_announcementUserEventsDraftsDraftIdRoute,
    AuthenticatedFeature_announcementUserEventsDraftsNewRoute:
      AuthenticatedFeature_announcementUserEventsDraftsNewRoute,
    AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdRoute:
      AuthenticatedFeature_announcementUserNetworkSurveyResponseNetworkIdSurveyIdRouteWithChildren,
    AuthenticatedFeature_announcementUserPostsPostIdSplatRoute:
      AuthenticatedFeature_announcementUserPostsPostIdSplatRoute,
    AuthenticatedFeature_announcementUserPostsDraftsDraftIdRoute:
      AuthenticatedFeature_announcementUserPostsDraftsDraftIdRoute,
    AuthenticatedFeature_announcementUserUserUserIdAchievementsRoute:
      AuthenticatedFeature_announcementUserUserUserIdAchievementsRoute,
    AuthenticatedFeature_announcementUserUserUserIdEditRoute:
      AuthenticatedFeature_announcementUserUserUserIdEditRoute,
    AuthenticatedFeature_announcementUserUserUserIdStatisticsRoute:
      AuthenticatedFeature_announcementUserUserUserIdStatisticsRoute,
    AuthenticatedFeature_announcementUserUserUserIdTransactionsRoute:
      AuthenticatedFeature_announcementUserUserUserIdTransactionsRoute,
    AuthenticatedFeature_announcementUserEventsDraftsIndexRoute:
      AuthenticatedFeature_announcementUserEventsDraftsIndexRoute,
    AuthenticatedFeature_announcementUserPostsDraftsIndexRoute:
      AuthenticatedFeature_announcementUserPostsDraftsIndexRoute,
    AuthenticatedFeature_announcementUserUserUserIdIndexRoute:
      AuthenticatedFeature_announcementUserUserUserIdIndexRoute,
  };

const AuthenticatedFeature_announcementUserRouteWithChildren =
  AuthenticatedFeature_announcementUserRoute._addFileChildren(
    AuthenticatedFeature_announcementUserRouteChildren,
  );

interface AuthenticatedFeature_announcementAdminSystemBrandingRouteChildren {
  AuthenticatedFeature_announcementAdminSystemBrandingColorsRoute: typeof AuthenticatedFeature_announcementAdminSystemBrandingColorsRoute;
  AuthenticatedFeature_announcementAdminSystemBrandingHomeRoute: typeof AuthenticatedFeature_announcementAdminSystemBrandingHomeRoute;
  AuthenticatedFeature_announcementAdminSystemBrandingLogosRoute: typeof AuthenticatedFeature_announcementAdminSystemBrandingLogosRoute;
  AuthenticatedFeature_announcementAdminSystemBrandingThemeRoute: typeof AuthenticatedFeature_announcementAdminSystemBrandingThemeRoute;
  AuthenticatedFeature_announcementAdminSystemBrandingSponsorsNewRoute: typeof AuthenticatedFeature_announcementAdminSystemBrandingSponsorsNewRoute;
  AuthenticatedFeature_announcementAdminSystemBrandingSponsorsIndexRoute: typeof AuthenticatedFeature_announcementAdminSystemBrandingSponsorsIndexRoute;
  AuthenticatedFeature_announcementAdminSystemBrandingSponsorsSponsorIdEditRoute: typeof AuthenticatedFeature_announcementAdminSystemBrandingSponsorsSponsorIdEditRoute;
}

const AuthenticatedFeature_announcementAdminSystemBrandingRouteChildren: AuthenticatedFeature_announcementAdminSystemBrandingRouteChildren =
  {
    AuthenticatedFeature_announcementAdminSystemBrandingColorsRoute:
      AuthenticatedFeature_announcementAdminSystemBrandingColorsRoute,
    AuthenticatedFeature_announcementAdminSystemBrandingHomeRoute:
      AuthenticatedFeature_announcementAdminSystemBrandingHomeRoute,
    AuthenticatedFeature_announcementAdminSystemBrandingLogosRoute:
      AuthenticatedFeature_announcementAdminSystemBrandingLogosRoute,
    AuthenticatedFeature_announcementAdminSystemBrandingThemeRoute:
      AuthenticatedFeature_announcementAdminSystemBrandingThemeRoute,
    AuthenticatedFeature_announcementAdminSystemBrandingSponsorsNewRoute:
      AuthenticatedFeature_announcementAdminSystemBrandingSponsorsNewRoute,
    AuthenticatedFeature_announcementAdminSystemBrandingSponsorsIndexRoute:
      AuthenticatedFeature_announcementAdminSystemBrandingSponsorsIndexRoute,
    AuthenticatedFeature_announcementAdminSystemBrandingSponsorsSponsorIdEditRoute:
      AuthenticatedFeature_announcementAdminSystemBrandingSponsorsSponsorIdEditRoute,
  };

const AuthenticatedFeature_announcementAdminSystemBrandingRouteWithChildren =
  AuthenticatedFeature_announcementAdminSystemBrandingRoute._addFileChildren(
    AuthenticatedFeature_announcementAdminSystemBrandingRouteChildren,
  );

interface AuthenticatedFeature_announcementAdminSystemIntegrationsRouteChildren {
  AuthenticatedFeature_announcementAdminSystemIntegrationsMentorcliqRoute: typeof AuthenticatedFeature_announcementAdminSystemIntegrationsMentorcliqRoute;
  AuthenticatedFeature_announcementAdminSystemIntegrationsOutlookRoute: typeof AuthenticatedFeature_announcementAdminSystemIntegrationsOutlookRoute;
  AuthenticatedFeature_announcementAdminSystemIntegrationsSimpplrRoute: typeof AuthenticatedFeature_announcementAdminSystemIntegrationsSimpplrRoute;
  AuthenticatedFeature_announcementAdminSystemIntegrationsSlackRoute: typeof AuthenticatedFeature_announcementAdminSystemIntegrationsSlackRoute;
  AuthenticatedFeature_announcementAdminSystemIntegrationsTeamsRoute: typeof AuthenticatedFeature_announcementAdminSystemIntegrationsTeamsRoute;
  AuthenticatedFeature_announcementAdminSystemIntegrationsUkgRoute: typeof AuthenticatedFeature_announcementAdminSystemIntegrationsUkgRoute;
  AuthenticatedFeature_announcementAdminSystemIntegrationsVivaEngageRoute: typeof AuthenticatedFeature_announcementAdminSystemIntegrationsVivaEngageRoute;
  AuthenticatedFeature_announcementAdminSystemIntegrationsIndexRoute: typeof AuthenticatedFeature_announcementAdminSystemIntegrationsIndexRoute;
}

const AuthenticatedFeature_announcementAdminSystemIntegrationsRouteChildren: AuthenticatedFeature_announcementAdminSystemIntegrationsRouteChildren =
  {
    AuthenticatedFeature_announcementAdminSystemIntegrationsMentorcliqRoute:
      AuthenticatedFeature_announcementAdminSystemIntegrationsMentorcliqRoute,
    AuthenticatedFeature_announcementAdminSystemIntegrationsOutlookRoute:
      AuthenticatedFeature_announcementAdminSystemIntegrationsOutlookRoute,
    AuthenticatedFeature_announcementAdminSystemIntegrationsSimpplrRoute:
      AuthenticatedFeature_announcementAdminSystemIntegrationsSimpplrRoute,
    AuthenticatedFeature_announcementAdminSystemIntegrationsSlackRoute:
      AuthenticatedFeature_announcementAdminSystemIntegrationsSlackRoute,
    AuthenticatedFeature_announcementAdminSystemIntegrationsTeamsRoute:
      AuthenticatedFeature_announcementAdminSystemIntegrationsTeamsRoute,
    AuthenticatedFeature_announcementAdminSystemIntegrationsUkgRoute:
      AuthenticatedFeature_announcementAdminSystemIntegrationsUkgRoute,
    AuthenticatedFeature_announcementAdminSystemIntegrationsVivaEngageRoute:
      AuthenticatedFeature_announcementAdminSystemIntegrationsVivaEngageRoute,
    AuthenticatedFeature_announcementAdminSystemIntegrationsIndexRoute:
      AuthenticatedFeature_announcementAdminSystemIntegrationsIndexRoute,
  };

const AuthenticatedFeature_announcementAdminSystemIntegrationsRouteWithChildren =
  AuthenticatedFeature_announcementAdminSystemIntegrationsRoute._addFileChildren(
    AuthenticatedFeature_announcementAdminSystemIntegrationsRouteChildren,
  );

interface AuthenticatedFeature_announcementAdminSystemRolesRouteChildren {
  AuthenticatedFeature_announcementAdminSystemRolesRole_configurationRoute: typeof AuthenticatedFeature_announcementAdminSystemRolesRole_configurationRoute;
  AuthenticatedFeature_announcementAdminSystemRolesCommunityIndexRoute: typeof AuthenticatedFeature_announcementAdminSystemRolesCommunityIndexRoute;
  AuthenticatedFeature_announcementAdminSystemRolesPlatformIndexRoute: typeof AuthenticatedFeature_announcementAdminSystemRolesPlatformIndexRoute;
  AuthenticatedFeature_announcementAdminSystemRolesCommunityRoleIdPermissionsRoute: typeof AuthenticatedFeature_announcementAdminSystemRolesCommunityRoleIdPermissionsRoute;
  AuthenticatedFeature_announcementAdminSystemRolesPlatformRoleIdPermissionsRoute: typeof AuthenticatedFeature_announcementAdminSystemRolesPlatformRoleIdPermissionsRoute;
  AuthenticatedFeature_announcementAdminSystemRolesCommunityRoleIdIndexRoute: typeof AuthenticatedFeature_announcementAdminSystemRolesCommunityRoleIdIndexRoute;
  AuthenticatedFeature_announcementAdminSystemRolesPlatformRoleIdIndexRoute: typeof AuthenticatedFeature_announcementAdminSystemRolesPlatformRoleIdIndexRoute;
}

const AuthenticatedFeature_announcementAdminSystemRolesRouteChildren: AuthenticatedFeature_announcementAdminSystemRolesRouteChildren =
  {
    AuthenticatedFeature_announcementAdminSystemRolesRole_configurationRoute:
      AuthenticatedFeature_announcementAdminSystemRolesRole_configurationRoute,
    AuthenticatedFeature_announcementAdminSystemRolesCommunityIndexRoute:
      AuthenticatedFeature_announcementAdminSystemRolesCommunityIndexRoute,
    AuthenticatedFeature_announcementAdminSystemRolesPlatformIndexRoute:
      AuthenticatedFeature_announcementAdminSystemRolesPlatformIndexRoute,
    AuthenticatedFeature_announcementAdminSystemRolesCommunityRoleIdPermissionsRoute:
      AuthenticatedFeature_announcementAdminSystemRolesCommunityRoleIdPermissionsRoute,
    AuthenticatedFeature_announcementAdminSystemRolesPlatformRoleIdPermissionsRoute:
      AuthenticatedFeature_announcementAdminSystemRolesPlatformRoleIdPermissionsRoute,
    AuthenticatedFeature_announcementAdminSystemRolesCommunityRoleIdIndexRoute:
      AuthenticatedFeature_announcementAdminSystemRolesCommunityRoleIdIndexRoute,
    AuthenticatedFeature_announcementAdminSystemRolesPlatformRoleIdIndexRoute:
      AuthenticatedFeature_announcementAdminSystemRolesPlatformRoleIdIndexRoute,
  };

const AuthenticatedFeature_announcementAdminSystemRolesRouteWithChildren =
  AuthenticatedFeature_announcementAdminSystemRolesRoute._addFileChildren(
    AuthenticatedFeature_announcementAdminSystemRolesRouteChildren,
  );

interface AuthenticatedFeature_announcementAdminSystemSettingsConfigurationRouteChildren {
  AuthenticatedFeature_announcementAdminSystemSettingsConfigurationCommunitiesRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsConfigurationCommunitiesRoute;
  AuthenticatedFeature_announcementAdminSystemSettingsConfigurationConfigurationRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsConfigurationConfigurationRoute;
  AuthenticatedFeature_announcementAdminSystemSettingsConfigurationModulesRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsConfigurationModulesRoute;
  AuthenticatedFeature_announcementAdminSystemSettingsConfigurationProfile_fieldsRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsConfigurationProfile_fieldsRoute;
}

const AuthenticatedFeature_announcementAdminSystemSettingsConfigurationRouteChildren: AuthenticatedFeature_announcementAdminSystemSettingsConfigurationRouteChildren =
  {
    AuthenticatedFeature_announcementAdminSystemSettingsConfigurationCommunitiesRoute:
      AuthenticatedFeature_announcementAdminSystemSettingsConfigurationCommunitiesRoute,
    AuthenticatedFeature_announcementAdminSystemSettingsConfigurationConfigurationRoute:
      AuthenticatedFeature_announcementAdminSystemSettingsConfigurationConfigurationRoute,
    AuthenticatedFeature_announcementAdminSystemSettingsConfigurationModulesRoute:
      AuthenticatedFeature_announcementAdminSystemSettingsConfigurationModulesRoute,
    AuthenticatedFeature_announcementAdminSystemSettingsConfigurationProfile_fieldsRoute:
      AuthenticatedFeature_announcementAdminSystemSettingsConfigurationProfile_fieldsRoute,
  };

const AuthenticatedFeature_announcementAdminSystemSettingsConfigurationRouteWithChildren =
  AuthenticatedFeature_announcementAdminSystemSettingsConfigurationRoute._addFileChildren(
    AuthenticatedFeature_announcementAdminSystemSettingsConfigurationRouteChildren,
  );

interface AuthenticatedFeature_announcementAdminSystemSettingsRouteChildren {
  AuthenticatedFeature_announcementAdminSystemSettingsConfigurationRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsConfigurationRouteWithChildren;
  AuthenticatedFeature_announcementAdminSystemSettingsCustom_textsRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsCustom_textsRoute;
  AuthenticatedFeature_announcementAdminSystemSettingsFieldsRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsFieldsRoute;
  AuthenticatedFeature_announcementAdminSystemSettingsSsoRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsSsoRoute;
  AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsNewRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsNewRoute;
  AuthenticatedFeature_announcementAdminSystemSettingsEmailsIndexRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsEmailsIndexRoute;
  AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsIndexRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsIndexRoute;
  AuthenticatedFeature_announcementAdminSystemSettingsEmailsEmailIdEditRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsEmailsEmailIdEditRoute;
  AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsEditPolicyDocumentIdRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsEditPolicyDocumentIdRoute;
}

const AuthenticatedFeature_announcementAdminSystemSettingsRouteChildren: AuthenticatedFeature_announcementAdminSystemSettingsRouteChildren =
  {
    AuthenticatedFeature_announcementAdminSystemSettingsConfigurationRoute:
      AuthenticatedFeature_announcementAdminSystemSettingsConfigurationRouteWithChildren,
    AuthenticatedFeature_announcementAdminSystemSettingsCustom_textsRoute:
      AuthenticatedFeature_announcementAdminSystemSettingsCustom_textsRoute,
    AuthenticatedFeature_announcementAdminSystemSettingsFieldsRoute:
      AuthenticatedFeature_announcementAdminSystemSettingsFieldsRoute,
    AuthenticatedFeature_announcementAdminSystemSettingsSsoRoute:
      AuthenticatedFeature_announcementAdminSystemSettingsSsoRoute,
    AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsNewRoute:
      AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsNewRoute,
    AuthenticatedFeature_announcementAdminSystemSettingsEmailsIndexRoute:
      AuthenticatedFeature_announcementAdminSystemSettingsEmailsIndexRoute,
    AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsIndexRoute:
      AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsIndexRoute,
    AuthenticatedFeature_announcementAdminSystemSettingsEmailsEmailIdEditRoute:
      AuthenticatedFeature_announcementAdminSystemSettingsEmailsEmailIdEditRoute,
    AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsEditPolicyDocumentIdRoute:
      AuthenticatedFeature_announcementAdminSystemSettingsPolicy_documentsEditPolicyDocumentIdRoute,
  };

const AuthenticatedFeature_announcementAdminSystemSettingsRouteWithChildren =
  AuthenticatedFeature_announcementAdminSystemSettingsRoute._addFileChildren(
    AuthenticatedFeature_announcementAdminSystemSettingsRouteChildren,
  );

interface AuthenticatedFeature_announcementAdminSystemUsersUserIdEditRouteChildren {
  AuthenticatedFeature_announcementAdminSystemUsersUserIdEditFieldsRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdEditFieldsRoute;
  AuthenticatedFeature_announcementAdminSystemUsersUserIdEditGeneralRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdEditGeneralRoute;
}

const AuthenticatedFeature_announcementAdminSystemUsersUserIdEditRouteChildren: AuthenticatedFeature_announcementAdminSystemUsersUserIdEditRouteChildren =
  {
    AuthenticatedFeature_announcementAdminSystemUsersUserIdEditFieldsRoute:
      AuthenticatedFeature_announcementAdminSystemUsersUserIdEditFieldsRoute,
    AuthenticatedFeature_announcementAdminSystemUsersUserIdEditGeneralRoute:
      AuthenticatedFeature_announcementAdminSystemUsersUserIdEditGeneralRoute,
  };

const AuthenticatedFeature_announcementAdminSystemUsersUserIdEditRouteWithChildren =
  AuthenticatedFeature_announcementAdminSystemUsersUserIdEditRoute._addFileChildren(
    AuthenticatedFeature_announcementAdminSystemUsersUserIdEditRouteChildren,
  );

interface AuthenticatedFeature_announcementAdminSystemUsersRouteChildren {
  AuthenticatedFeature_announcementAdminSystemUsersImportRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersImportRoute;
  AuthenticatedFeature_announcementAdminSystemUsersListRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersListRoute;
  AuthenticatedFeature_announcementAdminSystemUsersMergeRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersMergeRoute;
  AuthenticatedFeature_announcementAdminSystemUsersNewRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersNewRoute;
  AuthenticatedFeature_announcementAdminSystemUsersUserIdEditRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdEditRouteWithChildren;
  AuthenticatedFeature_announcementAdminSystemUsersUserIdRole_assignmentsRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdRole_assignmentsRoute;
  AuthenticatedFeature_announcementAdminSystemUsersUserIdStatisticsRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdStatisticsRoute;
  AuthenticatedFeature_announcementAdminSystemUsersRolesNewRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersRolesNewRoute;
  AuthenticatedFeature_announcementAdminSystemUsersUserIdIndexRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersUserIdIndexRoute;
  AuthenticatedFeature_announcementAdminSystemUsersPolicy_templatesIndexRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersPolicy_templatesIndexRoute;
  AuthenticatedFeature_announcementAdminSystemUsersRolesIndexRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersRolesIndexRoute;
  AuthenticatedFeature_announcementAdminSystemUsersPolicy_templatesPolicyIdEditRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersPolicy_templatesPolicyIdEditRoute;
  AuthenticatedFeature_announcementAdminSystemUsersRolesRoleIdEditRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersRolesRoleIdEditRoute;
}

const AuthenticatedFeature_announcementAdminSystemUsersRouteChildren: AuthenticatedFeature_announcementAdminSystemUsersRouteChildren =
  {
    AuthenticatedFeature_announcementAdminSystemUsersImportRoute:
      AuthenticatedFeature_announcementAdminSystemUsersImportRoute,
    AuthenticatedFeature_announcementAdminSystemUsersListRoute:
      AuthenticatedFeature_announcementAdminSystemUsersListRoute,
    AuthenticatedFeature_announcementAdminSystemUsersMergeRoute:
      AuthenticatedFeature_announcementAdminSystemUsersMergeRoute,
    AuthenticatedFeature_announcementAdminSystemUsersNewRoute:
      AuthenticatedFeature_announcementAdminSystemUsersNewRoute,
    AuthenticatedFeature_announcementAdminSystemUsersUserIdEditRoute:
      AuthenticatedFeature_announcementAdminSystemUsersUserIdEditRouteWithChildren,
    AuthenticatedFeature_announcementAdminSystemUsersUserIdRole_assignmentsRoute:
      AuthenticatedFeature_announcementAdminSystemUsersUserIdRole_assignmentsRoute,
    AuthenticatedFeature_announcementAdminSystemUsersUserIdStatisticsRoute:
      AuthenticatedFeature_announcementAdminSystemUsersUserIdStatisticsRoute,
    AuthenticatedFeature_announcementAdminSystemUsersRolesNewRoute:
      AuthenticatedFeature_announcementAdminSystemUsersRolesNewRoute,
    AuthenticatedFeature_announcementAdminSystemUsersUserIdIndexRoute:
      AuthenticatedFeature_announcementAdminSystemUsersUserIdIndexRoute,
    AuthenticatedFeature_announcementAdminSystemUsersPolicy_templatesIndexRoute:
      AuthenticatedFeature_announcementAdminSystemUsersPolicy_templatesIndexRoute,
    AuthenticatedFeature_announcementAdminSystemUsersRolesIndexRoute:
      AuthenticatedFeature_announcementAdminSystemUsersRolesIndexRoute,
    AuthenticatedFeature_announcementAdminSystemUsersPolicy_templatesPolicyIdEditRoute:
      AuthenticatedFeature_announcementAdminSystemUsersPolicy_templatesPolicyIdEditRoute,
    AuthenticatedFeature_announcementAdminSystemUsersRolesRoleIdEditRoute:
      AuthenticatedFeature_announcementAdminSystemUsersRolesRoleIdEditRoute,
  };

const AuthenticatedFeature_announcementAdminSystemUsersRouteWithChildren =
  AuthenticatedFeature_announcementAdminSystemUsersRoute._addFileChildren(
    AuthenticatedFeature_announcementAdminSystemUsersRouteChildren,
  );

interface AuthenticatedFeature_announcementAdminSystemRouteChildren {
  AuthenticatedFeature_announcementAdminSystemApi_access_tokensRoute: typeof AuthenticatedFeature_announcementAdminSystemApi_access_tokensRoute;
  AuthenticatedFeature_announcementAdminSystemBrandingRoute: typeof AuthenticatedFeature_announcementAdminSystemBrandingRouteWithChildren;
  AuthenticatedFeature_announcementAdminSystemIntegrationsRoute: typeof AuthenticatedFeature_announcementAdminSystemIntegrationsRouteWithChildren;
  AuthenticatedFeature_announcementAdminSystemLogsRoute: typeof AuthenticatedFeature_announcementAdminSystemLogsRoute;
  AuthenticatedFeature_announcementAdminSystemMcp_connectorRoute: typeof AuthenticatedFeature_announcementAdminSystemMcp_connectorRoute;
  AuthenticatedFeature_announcementAdminSystemRolesRoute: typeof AuthenticatedFeature_announcementAdminSystemRolesRouteWithChildren;
  AuthenticatedFeature_announcementAdminSystemSettingsRoute: typeof AuthenticatedFeature_announcementAdminSystemSettingsRouteWithChildren;
  AuthenticatedFeature_announcementAdminSystemUsersRoute: typeof AuthenticatedFeature_announcementAdminSystemUsersRouteWithChildren;
}

const AuthenticatedFeature_announcementAdminSystemRouteChildren: AuthenticatedFeature_announcementAdminSystemRouteChildren =
  {
    AuthenticatedFeature_announcementAdminSystemApi_access_tokensRoute:
      AuthenticatedFeature_announcementAdminSystemApi_access_tokensRoute,
    AuthenticatedFeature_announcementAdminSystemBrandingRoute:
      AuthenticatedFeature_announcementAdminSystemBrandingRouteWithChildren,
    AuthenticatedFeature_announcementAdminSystemIntegrationsRoute:
      AuthenticatedFeature_announcementAdminSystemIntegrationsRouteWithChildren,
    AuthenticatedFeature_announcementAdminSystemLogsRoute:
      AuthenticatedFeature_announcementAdminSystemLogsRoute,
    AuthenticatedFeature_announcementAdminSystemMcp_connectorRoute:
      AuthenticatedFeature_announcementAdminSystemMcp_connectorRoute,
    AuthenticatedFeature_announcementAdminSystemRolesRoute:
      AuthenticatedFeature_announcementAdminSystemRolesRouteWithChildren,
    AuthenticatedFeature_announcementAdminSystemSettingsRoute:
      AuthenticatedFeature_announcementAdminSystemSettingsRouteWithChildren,
    AuthenticatedFeature_announcementAdminSystemUsersRoute:
      AuthenticatedFeature_announcementAdminSystemUsersRouteWithChildren,
  };

const AuthenticatedFeature_announcementAdminSystemRouteWithChildren =
  AuthenticatedFeature_announcementAdminSystemRoute._addFileChildren(
    AuthenticatedFeature_announcementAdminSystemRouteChildren,
  );

interface AuthenticatedFeature_announcementAdminAnalyzeGroupsRouteChildren {
  AuthenticatedFeature_announcementAdminAnalyzeGroupsEventsRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsEventsRoute;
  AuthenticatedFeature_announcementAdminAnalyzeGroupsPostsRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsPostsRoute;
  AuthenticatedFeature_announcementAdminAnalyzeGroupsResourcesRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsResourcesRoute;
  AuthenticatedFeature_announcementAdminAnalyzeGroupsUsersRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsUsersRoute;
  AuthenticatedFeature_announcementAdminAnalyzeGroupsIndexRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsIndexRoute;
}

const AuthenticatedFeature_announcementAdminAnalyzeGroupsRouteChildren: AuthenticatedFeature_announcementAdminAnalyzeGroupsRouteChildren =
  {
    AuthenticatedFeature_announcementAdminAnalyzeGroupsEventsRoute:
      AuthenticatedFeature_announcementAdminAnalyzeGroupsEventsRoute,
    AuthenticatedFeature_announcementAdminAnalyzeGroupsPostsRoute:
      AuthenticatedFeature_announcementAdminAnalyzeGroupsPostsRoute,
    AuthenticatedFeature_announcementAdminAnalyzeGroupsResourcesRoute:
      AuthenticatedFeature_announcementAdminAnalyzeGroupsResourcesRoute,
    AuthenticatedFeature_announcementAdminAnalyzeGroupsUsersRoute:
      AuthenticatedFeature_announcementAdminAnalyzeGroupsUsersRoute,
    AuthenticatedFeature_announcementAdminAnalyzeGroupsIndexRoute:
      AuthenticatedFeature_announcementAdminAnalyzeGroupsIndexRoute,
  };

const AuthenticatedFeature_announcementAdminAnalyzeGroupsRouteWithChildren =
  AuthenticatedFeature_announcementAdminAnalyzeGroupsRoute._addFileChildren(
    AuthenticatedFeature_announcementAdminAnalyzeGroupsRouteChildren,
  );

interface AuthenticatedFeature_announcementAdminAnalyzeUsersRouteChildren {
  AuthenticatedFeature_announcementAdminAnalyzeUsersEventsRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeUsersEventsRoute;
  AuthenticatedFeature_announcementAdminAnalyzeUsersIndexRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeUsersIndexRoute;
}

const AuthenticatedFeature_announcementAdminAnalyzeUsersRouteChildren: AuthenticatedFeature_announcementAdminAnalyzeUsersRouteChildren =
  {
    AuthenticatedFeature_announcementAdminAnalyzeUsersEventsRoute:
      AuthenticatedFeature_announcementAdminAnalyzeUsersEventsRoute,
    AuthenticatedFeature_announcementAdminAnalyzeUsersIndexRoute:
      AuthenticatedFeature_announcementAdminAnalyzeUsersIndexRoute,
  };

const AuthenticatedFeature_announcementAdminAnalyzeUsersRouteWithChildren =
  AuthenticatedFeature_announcementAdminAnalyzeUsersRoute._addFileChildren(
    AuthenticatedFeature_announcementAdminAnalyzeUsersRouteChildren,
  );

interface AuthenticatedFeature_announcementAdminGamificationRewardsRouteChildren {
  AuthenticatedFeature_announcementAdminGamificationRewardsNewRoute: typeof AuthenticatedFeature_announcementAdminGamificationRewardsNewRoute;
  AuthenticatedFeature_announcementAdminGamificationRewardsPendingRoute: typeof AuthenticatedFeature_announcementAdminGamificationRewardsPendingRoute;
  AuthenticatedFeature_announcementAdminGamificationRewardsIndexRoute: typeof AuthenticatedFeature_announcementAdminGamificationRewardsIndexRoute;
  AuthenticatedFeature_announcementAdminGamificationRewardsRewardIdEditRoute: typeof AuthenticatedFeature_announcementAdminGamificationRewardsRewardIdEditRoute;
}

const AuthenticatedFeature_announcementAdminGamificationRewardsRouteChildren: AuthenticatedFeature_announcementAdminGamificationRewardsRouteChildren =
  {
    AuthenticatedFeature_announcementAdminGamificationRewardsNewRoute:
      AuthenticatedFeature_announcementAdminGamificationRewardsNewRoute,
    AuthenticatedFeature_announcementAdminGamificationRewardsPendingRoute:
      AuthenticatedFeature_announcementAdminGamificationRewardsPendingRoute,
    AuthenticatedFeature_announcementAdminGamificationRewardsIndexRoute:
      AuthenticatedFeature_announcementAdminGamificationRewardsIndexRoute,
    AuthenticatedFeature_announcementAdminGamificationRewardsRewardIdEditRoute:
      AuthenticatedFeature_announcementAdminGamificationRewardsRewardIdEditRoute,
  };

const AuthenticatedFeature_announcementAdminGamificationRewardsRouteWithChildren =
  AuthenticatedFeature_announcementAdminGamificationRewardsRoute._addFileChildren(
    AuthenticatedFeature_announcementAdminGamificationRewardsRouteChildren,
  );

interface AuthenticatedFeature_announcementAdminManageEventsRouteChildren {
  AuthenticatedFeature_announcementAdminManageEventsCalendarRoute: typeof AuthenticatedFeature_announcementAdminManageEventsCalendarRoute;
  AuthenticatedFeature_announcementAdminManageEventsConfigurationRoute: typeof AuthenticatedFeature_announcementAdminManageEventsConfigurationRoute;
  AuthenticatedFeature_announcementAdminManageEventsQuestionnaireRoute: typeof AuthenticatedFeature_announcementAdminManageEventsQuestionnaireRoute;
  AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCreateRoute: typeof AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCreateRoute;
  AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarIndexRoute: typeof AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarIndexRoute;
  AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdUpdateRoute: typeof AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdUpdateRoute;
  AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdNotable_datesCreateRoute: typeof AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdNotable_datesCreateRoute;
  AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdNotable_datesEventIdUpdateRoute: typeof AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdNotable_datesEventIdUpdateRoute;
}

const AuthenticatedFeature_announcementAdminManageEventsRouteChildren: AuthenticatedFeature_announcementAdminManageEventsRouteChildren =
  {
    AuthenticatedFeature_announcementAdminManageEventsCalendarRoute:
      AuthenticatedFeature_announcementAdminManageEventsCalendarRoute,
    AuthenticatedFeature_announcementAdminManageEventsConfigurationRoute:
      AuthenticatedFeature_announcementAdminManageEventsConfigurationRoute,
    AuthenticatedFeature_announcementAdminManageEventsQuestionnaireRoute:
      AuthenticatedFeature_announcementAdminManageEventsQuestionnaireRoute,
    AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCreateRoute:
      AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCreateRoute,
    AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarIndexRoute:
      AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarIndexRoute,
    AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdUpdateRoute:
      AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdUpdateRoute,
    AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdNotable_datesCreateRoute:
      AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdNotable_datesCreateRoute,
    AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdNotable_datesEventIdUpdateRoute:
      AuthenticatedFeature_announcementAdminManageEventsNotable_dates_calendarCalendarIdNotable_datesEventIdUpdateRoute,
  };

const AuthenticatedFeature_announcementAdminManageEventsRouteWithChildren =
  AuthenticatedFeature_announcementAdminManageEventsRoute._addFileChildren(
    AuthenticatedFeature_announcementAdminManageEventsRouteChildren,
  );

interface AuthenticatedFeature_announcementAdminRouteChildren {
  AuthenticatedFeature_announcementAdminSupportConfigRoute: typeof AuthenticatedFeature_announcementAdminSupportConfigRoute;
  AuthenticatedFeature_announcementAdminSystemRoute: typeof AuthenticatedFeature_announcementAdminSystemRouteWithChildren;
  AuthenticatedFeature_announcementAdminAnalyzeCommunityLabReportRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeCommunityLabReportRoute;
  AuthenticatedFeature_announcementAdminAnalyzeGroupsRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeGroupsRouteWithChildren;
  AuthenticatedFeature_announcementAdminAnalyzeReportsRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeReportsRoute;
  AuthenticatedFeature_announcementAdminAnalyzeSegmentsRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeSegmentsRoute;
  AuthenticatedFeature_announcementAdminAnalyzeUsersRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeUsersRouteWithChildren;
  AuthenticatedFeature_announcementAdminGamificationRewardsRoute: typeof AuthenticatedFeature_announcementAdminGamificationRewardsRouteWithChildren;
  AuthenticatedFeature_announcementAdminManageArchivedRoute: typeof AuthenticatedFeature_announcementAdminManageArchivedRoute;
  AuthenticatedFeature_announcementAdminManageEventsRoute: typeof AuthenticatedFeature_announcementAdminManageEventsRouteWithChildren;
  AuthenticatedFeature_announcementAdminManageFoldersRoute: typeof AuthenticatedFeature_announcementAdminManageFoldersRoute;
  AuthenticatedFeature_announcementAdminManageLabelsRoute: typeof AuthenticatedFeature_announcementAdminManageLabelsRoute;
  AuthenticatedFeature_announcementAdminManageLeadersRoute: typeof AuthenticatedFeature_announcementAdminManageLeadersRoute;
  AuthenticatedFeature_announcementAdminManageTagsRoute: typeof AuthenticatedFeature_announcementAdminManageTagsRoute;
  AuthenticatedFeature_announcementAdminPlanAggregate_budgetingRoute: typeof AuthenticatedFeature_announcementAdminPlanAggregate_budgetingRoute;
  AuthenticatedFeature_announcementAdminSurveysNewRoute: typeof AuthenticatedFeature_announcementAdminSurveysNewRoute;
  AuthenticatedFeature_announcementAdminAnalyzeIndexRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeIndexRoute;
  AuthenticatedFeature_announcementAdminContextBackfillIndexRoute: typeof AuthenticatedFeature_announcementAdminContextBackfillIndexRoute;
  AuthenticatedFeature_announcementAdminSurveysIndexRoute: typeof AuthenticatedFeature_announcementAdminSurveysIndexRoute;
  AuthenticatedFeature_announcementAdminAnalyzeDashboardsSplatRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeDashboardsSplatRoute;
  AuthenticatedFeature_announcementAdminAnalyzeRoiSuiteSplatRoute: typeof AuthenticatedFeature_announcementAdminAnalyzeRoiSuiteSplatRoute;
  AuthenticatedFeature_announcementAdminGamificationAchievementsNewRoute: typeof AuthenticatedFeature_announcementAdminGamificationAchievementsNewRoute;
  AuthenticatedFeature_announcementAdminGamificationPointsManageRoute: typeof AuthenticatedFeature_announcementAdminGamificationPointsManageRoute;
  AuthenticatedFeature_announcementAdminManageCalendarCreateRoute: typeof AuthenticatedFeature_announcementAdminManageCalendarCreateRoute;
  AuthenticatedFeature_announcementAdminManageCommunicationsNewRoute: typeof AuthenticatedFeature_announcementAdminManageCommunicationsNewRoute;
  AuthenticatedFeature_announcementAdminManageGroupsConnectionsRoute: typeof AuthenticatedFeature_announcementAdminManageGroupsConnectionsRoute;
  AuthenticatedFeature_announcementAdminManageGroupsLeader_positionsRoute: typeof AuthenticatedFeature_announcementAdminManageGroupsLeader_positionsRoute;
  AuthenticatedFeature_announcementAdminManageGroupsNewRoute: typeof AuthenticatedFeature_announcementAdminManageGroupsNewRoute;
  AuthenticatedFeature_announcementAdminManageSegmentsNewRoute: typeof AuthenticatedFeature_announcementAdminManageSegmentsNewRoute;
  AuthenticatedFeature_announcementAdminSurveysSurveyIdEditRoute: typeof AuthenticatedFeature_announcementAdminSurveysSurveyIdEditRoute;
  AuthenticatedFeature_announcementAdminSurveysSurveyIdResponsesRoute: typeof AuthenticatedFeature_announcementAdminSurveysSurveyIdResponsesRoute;
  AuthenticatedFeature_announcementAdminGamificationAchievementsIndexRoute: typeof AuthenticatedFeature_announcementAdminGamificationAchievementsIndexRoute;
  AuthenticatedFeature_announcementAdminManageCalendarIndexRoute: typeof AuthenticatedFeature_announcementAdminManageCalendarIndexRoute;
  AuthenticatedFeature_announcementAdminManageCommunicationsIndexRoute: typeof AuthenticatedFeature_announcementAdminManageCommunicationsIndexRoute;
  AuthenticatedFeature_announcementAdminManageGroupsIndexRoute: typeof AuthenticatedFeature_announcementAdminManageGroupsIndexRoute;
  AuthenticatedFeature_announcementAdminManageSegmentsIndexRoute: typeof AuthenticatedFeature_announcementAdminManageSegmentsIndexRoute;
  AuthenticatedFeature_announcementAdminPlanBudgetingIndexRoute: typeof AuthenticatedFeature_announcementAdminPlanBudgetingIndexRoute;
  AuthenticatedFeature_announcementAdminGamificationAchievementsAchievementIdEditRoute: typeof AuthenticatedFeature_announcementAdminGamificationAchievementsAchievementIdEditRoute;
  AuthenticatedFeature_announcementAdminManageCalendarCalendarIdUpdateRoute: typeof AuthenticatedFeature_announcementAdminManageCalendarCalendarIdUpdateRoute;
  AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdDistributionsRoute: typeof AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdDistributionsRoute;
  AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdEditRoute: typeof AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdEditRoute;
  AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdRecipientsRoute: typeof AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdRecipientsRoute;
  AuthenticatedFeature_announcementAdminManageGroupsGroupIdCategorizeRoute: typeof AuthenticatedFeature_announcementAdminManageGroupsGroupIdCategorizeRoute;
  AuthenticatedFeature_announcementAdminManageGroupsGroupIdEditRoute: typeof AuthenticatedFeature_announcementAdminManageGroupsGroupIdEditRoute;
  AuthenticatedFeature_announcementAdminManageGroupsCategoriesNewRoute: typeof AuthenticatedFeature_announcementAdminManageGroupsCategoriesNewRoute;
  AuthenticatedFeature_announcementAdminManageSegmentsSegmentIdEditRoute: typeof AuthenticatedFeature_announcementAdminManageSegmentsSegmentIdEditRoute;
  AuthenticatedFeature_announcementAdminPlanBudgetingFiscal_periodsNewRoute: typeof AuthenticatedFeature_announcementAdminPlanBudgetingFiscal_periodsNewRoute;
  AuthenticatedFeature_announcementAdminManageGroupsCategoriesIndexRoute: typeof AuthenticatedFeature_announcementAdminManageGroupsCategoriesIndexRoute;
  AuthenticatedFeature_announcementAdminManageCalendarCalendarIdNotable_datesCreateRoute: typeof AuthenticatedFeature_announcementAdminManageCalendarCalendarIdNotable_datesCreateRoute;
  AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsNewRoute: typeof AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsNewRoute;
  AuthenticatedFeature_announcementAdminManageGroupsCategoriesCategoryIdEditRoute: typeof AuthenticatedFeature_announcementAdminManageGroupsCategoriesCategoryIdEditRoute;
  AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsIndexRoute: typeof AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsIndexRoute;
  AuthenticatedFeature_announcementAdminManageCalendarCalendarIdNotable_datesEventIdUpdateRoute: typeof AuthenticatedFeature_announcementAdminManageCalendarCalendarIdNotable_datesEventIdUpdateRoute;
  AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsRegionIdEditRoute: typeof AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsRegionIdEditRoute;
}

const AuthenticatedFeature_announcementAdminRouteChildren: AuthenticatedFeature_announcementAdminRouteChildren =
  {
    AuthenticatedFeature_announcementAdminSupportConfigRoute:
      AuthenticatedFeature_announcementAdminSupportConfigRoute,
    AuthenticatedFeature_announcementAdminSystemRoute:
      AuthenticatedFeature_announcementAdminSystemRouteWithChildren,
    AuthenticatedFeature_announcementAdminAnalyzeCommunityLabReportRoute:
      AuthenticatedFeature_announcementAdminAnalyzeCommunityLabReportRoute,
    AuthenticatedFeature_announcementAdminAnalyzeGroupsRoute:
      AuthenticatedFeature_announcementAdminAnalyzeGroupsRouteWithChildren,
    AuthenticatedFeature_announcementAdminAnalyzeReportsRoute:
      AuthenticatedFeature_announcementAdminAnalyzeReportsRoute,
    AuthenticatedFeature_announcementAdminAnalyzeSegmentsRoute:
      AuthenticatedFeature_announcementAdminAnalyzeSegmentsRoute,
    AuthenticatedFeature_announcementAdminAnalyzeUsersRoute:
      AuthenticatedFeature_announcementAdminAnalyzeUsersRouteWithChildren,
    AuthenticatedFeature_announcementAdminGamificationRewardsRoute:
      AuthenticatedFeature_announcementAdminGamificationRewardsRouteWithChildren,
    AuthenticatedFeature_announcementAdminManageArchivedRoute:
      AuthenticatedFeature_announcementAdminManageArchivedRoute,
    AuthenticatedFeature_announcementAdminManageEventsRoute:
      AuthenticatedFeature_announcementAdminManageEventsRouteWithChildren,
    AuthenticatedFeature_announcementAdminManageFoldersRoute:
      AuthenticatedFeature_announcementAdminManageFoldersRoute,
    AuthenticatedFeature_announcementAdminManageLabelsRoute:
      AuthenticatedFeature_announcementAdminManageLabelsRoute,
    AuthenticatedFeature_announcementAdminManageLeadersRoute:
      AuthenticatedFeature_announcementAdminManageLeadersRoute,
    AuthenticatedFeature_announcementAdminManageTagsRoute:
      AuthenticatedFeature_announcementAdminManageTagsRoute,
    AuthenticatedFeature_announcementAdminPlanAggregate_budgetingRoute:
      AuthenticatedFeature_announcementAdminPlanAggregate_budgetingRoute,
    AuthenticatedFeature_announcementAdminSurveysNewRoute:
      AuthenticatedFeature_announcementAdminSurveysNewRoute,
    AuthenticatedFeature_announcementAdminAnalyzeIndexRoute:
      AuthenticatedFeature_announcementAdminAnalyzeIndexRoute,
    AuthenticatedFeature_announcementAdminContextBackfillIndexRoute:
      AuthenticatedFeature_announcementAdminContextBackfillIndexRoute,
    AuthenticatedFeature_announcementAdminSurveysIndexRoute:
      AuthenticatedFeature_announcementAdminSurveysIndexRoute,
    AuthenticatedFeature_announcementAdminAnalyzeDashboardsSplatRoute:
      AuthenticatedFeature_announcementAdminAnalyzeDashboardsSplatRoute,
    AuthenticatedFeature_announcementAdminAnalyzeRoiSuiteSplatRoute:
      AuthenticatedFeature_announcementAdminAnalyzeRoiSuiteSplatRoute,
    AuthenticatedFeature_announcementAdminGamificationAchievementsNewRoute:
      AuthenticatedFeature_announcementAdminGamificationAchievementsNewRoute,
    AuthenticatedFeature_announcementAdminGamificationPointsManageRoute:
      AuthenticatedFeature_announcementAdminGamificationPointsManageRoute,
    AuthenticatedFeature_announcementAdminManageCalendarCreateRoute:
      AuthenticatedFeature_announcementAdminManageCalendarCreateRoute,
    AuthenticatedFeature_announcementAdminManageCommunicationsNewRoute:
      AuthenticatedFeature_announcementAdminManageCommunicationsNewRoute,
    AuthenticatedFeature_announcementAdminManageGroupsConnectionsRoute:
      AuthenticatedFeature_announcementAdminManageGroupsConnectionsRoute,
    AuthenticatedFeature_announcementAdminManageGroupsLeader_positionsRoute:
      AuthenticatedFeature_announcementAdminManageGroupsLeader_positionsRoute,
    AuthenticatedFeature_announcementAdminManageGroupsNewRoute:
      AuthenticatedFeature_announcementAdminManageGroupsNewRoute,
    AuthenticatedFeature_announcementAdminManageSegmentsNewRoute:
      AuthenticatedFeature_announcementAdminManageSegmentsNewRoute,
    AuthenticatedFeature_announcementAdminSurveysSurveyIdEditRoute:
      AuthenticatedFeature_announcementAdminSurveysSurveyIdEditRoute,
    AuthenticatedFeature_announcementAdminSurveysSurveyIdResponsesRoute:
      AuthenticatedFeature_announcementAdminSurveysSurveyIdResponsesRoute,
    AuthenticatedFeature_announcementAdminGamificationAchievementsIndexRoute:
      AuthenticatedFeature_announcementAdminGamificationAchievementsIndexRoute,
    AuthenticatedFeature_announcementAdminManageCalendarIndexRoute:
      AuthenticatedFeature_announcementAdminManageCalendarIndexRoute,
    AuthenticatedFeature_announcementAdminManageCommunicationsIndexRoute:
      AuthenticatedFeature_announcementAdminManageCommunicationsIndexRoute,
    AuthenticatedFeature_announcementAdminManageGroupsIndexRoute:
      AuthenticatedFeature_announcementAdminManageGroupsIndexRoute,
    AuthenticatedFeature_announcementAdminManageSegmentsIndexRoute:
      AuthenticatedFeature_announcementAdminManageSegmentsIndexRoute,
    AuthenticatedFeature_announcementAdminPlanBudgetingIndexRoute:
      AuthenticatedFeature_announcementAdminPlanBudgetingIndexRoute,
    AuthenticatedFeature_announcementAdminGamificationAchievementsAchievementIdEditRoute:
      AuthenticatedFeature_announcementAdminGamificationAchievementsAchievementIdEditRoute,
    AuthenticatedFeature_announcementAdminManageCalendarCalendarIdUpdateRoute:
      AuthenticatedFeature_announcementAdminManageCalendarCalendarIdUpdateRoute,
    AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdDistributionsRoute:
      AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdDistributionsRoute,
    AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdEditRoute:
      AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdEditRoute,
    AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdRecipientsRoute:
      AuthenticatedFeature_announcementAdminManageCommunicationsCommunicationIdRecipientsRoute,
    AuthenticatedFeature_announcementAdminManageGroupsGroupIdCategorizeRoute:
      AuthenticatedFeature_announcementAdminManageGroupsGroupIdCategorizeRoute,
    AuthenticatedFeature_announcementAdminManageGroupsGroupIdEditRoute:
      AuthenticatedFeature_announcementAdminManageGroupsGroupIdEditRoute,
    AuthenticatedFeature_announcementAdminManageGroupsCategoriesNewRoute:
      AuthenticatedFeature_announcementAdminManageGroupsCategoriesNewRoute,
    AuthenticatedFeature_announcementAdminManageSegmentsSegmentIdEditRoute:
      AuthenticatedFeature_announcementAdminManageSegmentsSegmentIdEditRoute,
    AuthenticatedFeature_announcementAdminPlanBudgetingFiscal_periodsNewRoute:
      AuthenticatedFeature_announcementAdminPlanBudgetingFiscal_periodsNewRoute,
    AuthenticatedFeature_announcementAdminManageGroupsCategoriesIndexRoute:
      AuthenticatedFeature_announcementAdminManageGroupsCategoriesIndexRoute,
    AuthenticatedFeature_announcementAdminManageCalendarCalendarIdNotable_datesCreateRoute:
      AuthenticatedFeature_announcementAdminManageCalendarCalendarIdNotable_datesCreateRoute,
    AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsNewRoute:
      AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsNewRoute,
    AuthenticatedFeature_announcementAdminManageGroupsCategoriesCategoryIdEditRoute:
      AuthenticatedFeature_announcementAdminManageGroupsCategoriesCategoryIdEditRoute,
    AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsIndexRoute:
      AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsIndexRoute,
    AuthenticatedFeature_announcementAdminManageCalendarCalendarIdNotable_datesEventIdUpdateRoute:
      AuthenticatedFeature_announcementAdminManageCalendarCalendarIdNotable_datesEventIdUpdateRoute,
    AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsRegionIdEditRoute:
      AuthenticatedFeature_announcementAdminManageGroupsGroupIdRegionsRegionIdEditRoute,
  };

const AuthenticatedFeature_announcementAdminRouteWithChildren =
  AuthenticatedFeature_announcementAdminRoute._addFileChildren(
    AuthenticatedFeature_announcementAdminRouteChildren,
  );

interface AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRouteRouteChildren {
  AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsNewRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsNewRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsIndexRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsIndexRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRuleIdEditRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRuleIdEditRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsHistoryRunIdRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsHistoryRunIdRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsHistoryIndexRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsHistoryIndexRoute;
}

const AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRouteRouteChildren: AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRouteRouteChildren =
  {
    AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsNewRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsNewRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsIndexRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsIndexRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRuleIdEditRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRuleIdEditRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsHistoryRunIdRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsHistoryRunIdRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsHistoryIndexRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsHistoryIndexRoute,
  };

const AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRouteRouteWithChildren =
  AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRouteRoute._addFileChildren(
    AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRouteRouteChildren,
  );

interface AuthenticatedFeature_announcementCommunitiesCommunityIdMembersRouteRouteChildren {
  AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRouteRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRouteRouteWithChildren;
  AuthenticatedFeature_announcementCommunitiesCommunityIdMembersInvitationsRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersInvitationsRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdMembersIndexRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersIndexRoute;
}

const AuthenticatedFeature_announcementCommunitiesCommunityIdMembersRouteRouteChildren: AuthenticatedFeature_announcementCommunitiesCommunityIdMembersRouteRouteChildren =
  {
    AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRouteRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdMembersAutomationsRouteRouteWithChildren,
    AuthenticatedFeature_announcementCommunitiesCommunityIdMembersInvitationsRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdMembersInvitationsRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdMembersIndexRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdMembersIndexRoute,
  };

const AuthenticatedFeature_announcementCommunitiesCommunityIdMembersRouteRouteWithChildren =
  AuthenticatedFeature_announcementCommunitiesCommunityIdMembersRouteRoute._addFileChildren(
    AuthenticatedFeature_announcementCommunitiesCommunityIdMembersRouteRouteChildren,
  );

interface AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRouteChildren {
  AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingManageRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingManageRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingOverviewRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingOverviewRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRequestRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRequestRoute;
}

const AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRouteChildren: AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRouteChildren =
  {
    AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingManageRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingManageRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingOverviewRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingOverviewRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRequestRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRequestRoute,
  };

const AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRouteWithChildren =
  AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRoute._addFileChildren(
    AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRouteChildren,
  );

interface AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsRouteChildren {
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsIntegrationRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsIntegrationRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsWelcome_messageRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsWelcome_messageRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsIndexRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsIndexRoute;
}

const AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsRouteChildren: AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsRouteChildren =
  {
    AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsIntegrationRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsIntegrationRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsWelcome_messageRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsWelcome_messageRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsIndexRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsIndexRoute,
  };

const AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsRouteWithChildren =
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsRoute._addFileChildren(
    AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsRouteChildren,
  );

interface AuthenticatedFeature_announcementCommunitiesCommunityIdManageRouteChildren {
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageArchivesRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageArchivesRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunityLabReportRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunityLabReportRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageReview_settingsRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageReview_settingsRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageRole_configurationRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRole_configurationRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsRouteWithChildren;
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsNewRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsNewRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageEventsPendingRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageEventsPendingRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersNewRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersNewRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsNewRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsNewRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysNewRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysNewRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsIndexRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsIndexRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersIndexRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersIndexRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsIndexRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsIndexRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysIndexRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysIndexRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdDistributionsRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdDistributionsRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdEditRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdEditRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdRecipientsRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdRecipientsRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersLeaderIdEditRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersLeaderIdEditRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsSponsorIdEditRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsSponsorIdEditRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysSurveyIdEditRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysSurveyIdEditRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysSurveyIdResponsesRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysSurveyIdResponsesRoute;
}

const AuthenticatedFeature_announcementCommunitiesCommunityIdManageRouteChildren: AuthenticatedFeature_announcementCommunitiesCommunityIdManageRouteChildren =
  {
    AuthenticatedFeature_announcementCommunitiesCommunityIdManageArchivesRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdManageArchivesRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunityLabReportRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunityLabReportRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdManageReview_settingsRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdManageReview_settingsRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdManageRole_configurationRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdManageRole_configurationRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdManageSettingsRouteWithChildren,
    AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsNewRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsNewRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdManageEventsPendingRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdManageEventsPendingRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersNewRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersNewRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsNewRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsNewRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysNewRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysNewRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsIndexRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsIndexRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersIndexRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersIndexRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsIndexRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsIndexRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysIndexRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysIndexRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdDistributionsRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdDistributionsRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdEditRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdEditRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdRecipientsRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdManageCommunicationsCommunicationIdRecipientsRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersLeaderIdEditRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdManageLeadersLeaderIdEditRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsSponsorIdEditRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdManageSponsorsSponsorIdEditRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysSurveyIdEditRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysSurveyIdEditRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysSurveyIdResponsesRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdManageSurveysSurveyIdResponsesRoute,
  };

const AuthenticatedFeature_announcementCommunitiesCommunityIdManageRouteWithChildren =
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute._addFileChildren(
    AuthenticatedFeature_announcementCommunitiesCommunityIdManageRouteChildren,
  );

interface AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRouteChildren {
  AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingManageRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingManageRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingOverviewRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingOverviewRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRequestRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRequestRoute;
}

const AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRouteChildren: AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRouteChildren =
  {
    AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingManageRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingManageRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingOverviewRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingOverviewRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRequestRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRequestRoute,
  };

const AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRouteWithChildren =
  AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRoute._addFileChildren(
    AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRouteChildren,
  );

interface AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRouteChildren {
  AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRouteWithChildren;
  AuthenticatedFeature_announcementCommunitiesCommunityIdPlanEventsRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanEventsRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesNewRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesNewRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsNewRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsNewRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesIndexRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesIndexRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsIndexRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsIndexRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesOutcomeIdEditRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesOutcomeIdEditRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsPillarIdEditRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsPillarIdEditRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsPillarIdEventsRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsPillarIdEventsRoute;
}

const AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRouteChildren: AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRouteChildren =
  {
    AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdPlanBudgetingRouteWithChildren,
    AuthenticatedFeature_announcementCommunitiesCommunityIdPlanEventsRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdPlanEventsRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesNewRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesNewRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsNewRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsNewRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesIndexRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesIndexRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsIndexRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsIndexRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesOutcomeIdEditRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdPlanOutcomesOutcomeIdEditRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsPillarIdEditRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsPillarIdEditRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsPillarIdEventsRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdPlanPillarsPillarIdEventsRoute,
  };

const AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRouteWithChildren =
  AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRoute._addFileChildren(
    AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRouteChildren,
  );

interface AuthenticatedFeature_announcementCommunitiesCommunityIdRouteChildren {
  AuthenticatedFeature_announcementCommunitiesCommunityIdMembersRouteRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdMembersRouteRouteWithChildren;
  AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRouteWithChildren;
  AuthenticatedFeature_announcementCommunitiesCommunityIdChaptersRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdChaptersRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdFoldersRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdFoldersRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdManageRouteWithChildren;
  AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRouteWithChildren;
  AuthenticatedFeature_announcementCommunitiesCommunityIdIndexRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdIndexRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdEventsPendingRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsPendingRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdRoiSuiteSplatRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdRoiSuiteSplatRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdEventsIndexRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsIndexRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdPostsIndexRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPostsIndexRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdEditRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdEditRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdPostsPostIdEditRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPostsPostIdEditRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdIndexRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdIndexRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdPostsPostIdIndexRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdPostsPostIdIndexRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageAttendeesRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageAttendeesRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageBudgetingRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageBudgetingRoute;
  AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageWaitlistRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageWaitlistRoute;
}

const AuthenticatedFeature_announcementCommunitiesCommunityIdRouteChildren: AuthenticatedFeature_announcementCommunitiesCommunityIdRouteChildren =
  {
    AuthenticatedFeature_announcementCommunitiesCommunityIdMembersRouteRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdMembersRouteRouteWithChildren,
    AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdBudgetingRouteWithChildren,
    AuthenticatedFeature_announcementCommunitiesCommunityIdChaptersRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdChaptersRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdFoldersRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdFoldersRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdManageRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdManageRouteWithChildren,
    AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdPlanRouteWithChildren,
    AuthenticatedFeature_announcementCommunitiesCommunityIdIndexRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdIndexRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdEventsPendingRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdEventsPendingRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdRoiSuiteSplatRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdRoiSuiteSplatRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdEventsIndexRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdEventsIndexRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdPostsIndexRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdPostsIndexRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdEditRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdEditRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdPostsPostIdEditRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdPostsPostIdEditRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdIndexRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdIndexRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdPostsPostIdIndexRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdPostsPostIdIndexRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageAttendeesRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageAttendeesRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageBudgetingRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageBudgetingRoute,
    AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageWaitlistRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdEventsEventIdManageWaitlistRoute,
  };

const AuthenticatedFeature_announcementCommunitiesCommunityIdRouteWithChildren =
  AuthenticatedFeature_announcementCommunitiesCommunityIdRoute._addFileChildren(
    AuthenticatedFeature_announcementCommunitiesCommunityIdRouteChildren,
  );

interface AuthenticatedFeature_announcementRouteChildren {
  AuthenticatedFeature_announcementUserRoute: typeof AuthenticatedFeature_announcementUserRouteWithChildren;
  AuthenticatedFeature_announcementAdminRoute: typeof AuthenticatedFeature_announcementAdminRouteWithChildren;
  AuthenticatedFeature_announcementCommunitiesCommunityIdRoute: typeof AuthenticatedFeature_announcementCommunitiesCommunityIdRouteWithChildren;
  AuthenticatedFeature_announcementOpen_invitationsOpenInvitationIdRoute: typeof AuthenticatedFeature_announcementOpen_invitationsOpenInvitationIdRoute;
  AuthenticatedFeature_announcementGroupsGroupIdSplatRoute: typeof AuthenticatedFeature_announcementGroupsGroupIdSplatRoute;
  AuthenticatedFeature_announcementInvitationsInvitationIdAcceptRoute: typeof AuthenticatedFeature_announcementInvitationsInvitationIdAcceptRoute;
  AuthenticatedFeature_announcementInvitationsInvitationIdDeclineRoute: typeof AuthenticatedFeature_announcementInvitationsInvitationIdDeclineRoute;
  AuthenticatedFeature_announcementRegionsRegionIdSplatRoute: typeof AuthenticatedFeature_announcementRegionsRegionIdSplatRoute;
}

const AuthenticatedFeature_announcementRouteChildren: AuthenticatedFeature_announcementRouteChildren =
  {
    AuthenticatedFeature_announcementUserRoute:
      AuthenticatedFeature_announcementUserRouteWithChildren,
    AuthenticatedFeature_announcementAdminRoute:
      AuthenticatedFeature_announcementAdminRouteWithChildren,
    AuthenticatedFeature_announcementCommunitiesCommunityIdRoute:
      AuthenticatedFeature_announcementCommunitiesCommunityIdRouteWithChildren,
    AuthenticatedFeature_announcementOpen_invitationsOpenInvitationIdRoute:
      AuthenticatedFeature_announcementOpen_invitationsOpenInvitationIdRoute,
    AuthenticatedFeature_announcementGroupsGroupIdSplatRoute:
      AuthenticatedFeature_announcementGroupsGroupIdSplatRoute,
    AuthenticatedFeature_announcementInvitationsInvitationIdAcceptRoute:
      AuthenticatedFeature_announcementInvitationsInvitationIdAcceptRoute,
    AuthenticatedFeature_announcementInvitationsInvitationIdDeclineRoute:
      AuthenticatedFeature_announcementInvitationsInvitationIdDeclineRoute,
    AuthenticatedFeature_announcementRegionsRegionIdSplatRoute:
      AuthenticatedFeature_announcementRegionsRegionIdSplatRoute,
  };

const AuthenticatedFeature_announcementRouteWithChildren =
  AuthenticatedFeature_announcementRoute._addFileChildren(
    AuthenticatedFeature_announcementRouteChildren,
  );

interface AuthenticatedRouteChildren {
  AuthenticatedFeature_announcementRoute: typeof AuthenticatedFeature_announcementRouteWithChildren;
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedFeature_announcementRoute:
    AuthenticatedFeature_announcementRouteWithChildren,
};

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
);

interface CmsRouteChildren {
  CmsCmsIndexRoute: typeof CmsCmsIndexRoute;
  CmsCmsReviewComment_moderationRoute: typeof CmsCmsReviewComment_moderationRoute;
  CmsCmsToolsReview_settingsRoute: typeof CmsCmsToolsReview_settingsRoute;
  CmsCmsManageCommunicationsDraftIdRoute: typeof CmsCmsManageCommunicationsDraftIdRoute;
  CmsCmsManageEventsDraftIdRoute: typeof CmsCmsManageEventsDraftIdRoute;
  CmsCmsManageEventsNewRoute: typeof CmsCmsManageEventsNewRoute;
  CmsCmsManagePostsDraftIdRoute: typeof CmsCmsManagePostsDraftIdRoute;
  CmsCmsManagePublication_requestsPublicationRequestIdRoute: typeof CmsCmsManagePublication_requestsPublicationRequestIdRoute;
  CmsCmsReviewPublication_requestsPublicationRequestIdRoute: typeof CmsCmsReviewPublication_requestsPublicationRequestIdRoute;
  CmsCmsManageCommunicationsIndexRoute: typeof CmsCmsManageCommunicationsIndexRoute;
  CmsCmsManageEventsIndexRoute: typeof CmsCmsManageEventsIndexRoute;
  CmsCmsManagePostsIndexRoute: typeof CmsCmsManagePostsIndexRoute;
  CmsCmsManagePublication_requestsIndexRoute: typeof CmsCmsManagePublication_requestsIndexRoute;
  CmsCmsReviewPublication_requestsIndexRoute: typeof CmsCmsReviewPublication_requestsIndexRoute;
}

const CmsRouteChildren: CmsRouteChildren = {
  CmsCmsIndexRoute: CmsCmsIndexRoute,
  CmsCmsReviewComment_moderationRoute: CmsCmsReviewComment_moderationRoute,
  CmsCmsToolsReview_settingsRoute: CmsCmsToolsReview_settingsRoute,
  CmsCmsManageCommunicationsDraftIdRoute:
    CmsCmsManageCommunicationsDraftIdRoute,
  CmsCmsManageEventsDraftIdRoute: CmsCmsManageEventsDraftIdRoute,
  CmsCmsManageEventsNewRoute: CmsCmsManageEventsNewRoute,
  CmsCmsManagePostsDraftIdRoute: CmsCmsManagePostsDraftIdRoute,
  CmsCmsManagePublication_requestsPublicationRequestIdRoute:
    CmsCmsManagePublication_requestsPublicationRequestIdRoute,
  CmsCmsReviewPublication_requestsPublicationRequestIdRoute:
    CmsCmsReviewPublication_requestsPublicationRequestIdRoute,
  CmsCmsManageCommunicationsIndexRoute: CmsCmsManageCommunicationsIndexRoute,
  CmsCmsManageEventsIndexRoute: CmsCmsManageEventsIndexRoute,
  CmsCmsManagePostsIndexRoute: CmsCmsManagePostsIndexRoute,
  CmsCmsManagePublication_requestsIndexRoute:
    CmsCmsManagePublication_requestsIndexRoute,
  CmsCmsReviewPublication_requestsIndexRoute:
    CmsCmsReviewPublication_requestsIndexRoute,
};

const CmsRouteWithChildren = CmsRoute._addFileChildren(CmsRouteChildren);

interface SessionRouteChildren {
  SessionForgotRoute: typeof SessionForgotRoute;
  SessionLoginActivateRoute: typeof SessionLoginActivateRoute;
  SessionLoginAdminRoute: typeof SessionLoginAdminRoute;
  SessionLoginCredentialsRoute: typeof SessionLoginCredentialsRoute;
  SessionPassword_resetTokenRoute: typeof SessionPassword_resetTokenRoute;
  SessionLoginIndexRoute: typeof SessionLoginIndexRoute;
  SessionPassword_resetIndexRoute: typeof SessionPassword_resetIndexRoute;
}

const SessionRouteChildren: SessionRouteChildren = {
  SessionForgotRoute: SessionForgotRoute,
  SessionLoginActivateRoute: SessionLoginActivateRoute,
  SessionLoginAdminRoute: SessionLoginAdminRoute,
  SessionLoginCredentialsRoute: SessionLoginCredentialsRoute,
  SessionPassword_resetTokenRoute: SessionPassword_resetTokenRoute,
  SessionLoginIndexRoute: SessionLoginIndexRoute,
  SessionPassword_resetIndexRoute: SessionPassword_resetIndexRoute,
};

const SessionRouteWithChildren =
  SessionRoute._addFileChildren(SessionRouteChildren);

interface EnrollmentRouteChildren {
  EnrollmentCompleteRoute: typeof EnrollmentCompleteRoute;
  EnrollmentDiscoverRoute: typeof EnrollmentDiscoverRoute;
  EnrollmentProfileRoute: typeof EnrollmentProfileRoute;
  EnrollmentIndexRoute: typeof EnrollmentIndexRoute;
}

const EnrollmentRouteChildren: EnrollmentRouteChildren = {
  EnrollmentCompleteRoute: EnrollmentCompleteRoute,
  EnrollmentDiscoverRoute: EnrollmentDiscoverRoute,
  EnrollmentProfileRoute: EnrollmentProfileRoute,
  EnrollmentIndexRoute: EnrollmentIndexRoute,
};

const EnrollmentRouteWithChildren = EnrollmentRoute._addFileChildren(
  EnrollmentRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  AnonymousRoute: AnonymousRouteWithChildren,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  CmsRoute: CmsRouteWithChildren,
  SessionRoute: SessionRouteWithChildren,
  AutoLoginRoute: AutoLoginRoute,
  EnrollmentRoute: EnrollmentRouteWithChildren,
  compatibilityOnboardingRoute: compatibilityOnboardingRoute,
  compatibilitySign_upRoute: compatibilitySign_upRoute,
  compatibilityEnterprisesEnterpriseIdFoldersFolderIdResourcesRoute:
    compatibilityEnterprisesEnterpriseIdFoldersFolderIdResourcesRoute,
  compatibilityGroupsGroupIdFoldersFolderIdResourcesRoute:
    compatibilityGroupsGroupIdFoldersFolderIdResourcesRoute,
  compatibilityGroupsGroupIdNewsTypePostIdRoute:
    compatibilityGroupsGroupIdNewsTypePostIdRoute,
  compatibilityRegionsRegionIdNewsTypePostIdRoute:
    compatibilityRegionsRegionIdNewsTypePostIdRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
